function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var ufinetWebFunctions = require('ufinet-web-functions');
var reactIntl = require('react-intl');
var faTrash = require('@fortawesome/free-solid-svg-icons/faTrash');
var Swal = _interopDefault(require('sweetalert2'));
var reactFontawesome = require('@fortawesome/react-fontawesome');
var button = require('primereact/button');
var reactBootstrap = require('react-bootstrap');
var uuid = require('uuid');
var calendar = require('primereact/calendar');
var utils = require('primereact/utils');
var fastEquals = require('fast-equals');
var reactDropzone = require('react-dropzone');
var reactToastify = require('react-toastify');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var Select = _interopDefault(require('react-select'));
var CreatableSelect = _interopDefault(require('react-select/creatable'));
var faMagnifyingGlass = require('@fortawesome/free-solid-svg-icons/faMagnifyingGlass');
var formik = require('formik');
require('@formatjs/intl-relativetimeformat/locale-data/de');
require('@formatjs/intl-relativetimeformat/locale-data/en');
require('@formatjs/intl-relativetimeformat/locale-data/es');
require('@formatjs/intl-relativetimeformat/locale-data/fr');
require('@formatjs/intl-relativetimeformat/locale-data/ja');
require('@formatjs/intl-relativetimeformat/locale-data/zh');
require('@formatjs/intl-relativetimeformat/polyfill');
var api = require('primereact/api');
var reactRouterDom = require('react-router-dom');
var SVG = _interopDefault(require('react-inlinesvg'));
var faMapLocationDot = require('@fortawesome/free-solid-svg-icons/faMapLocationDot');
var faAngleRight = require('@fortawesome/free-solid-svg-icons/faAngleRight');
var column = require('primereact/column');
var datatable = require('primereact/datatable');
var inputtext = require('primereact/inputtext');

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call = Function.prototype.call;

var functionCall = functionBindNative ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype = Function.prototype;
var call$1 = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call$1, call$1);

var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$1.apply(fn, arguments);
  };
};

var toString = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString(it), 8, -1);
};

var $Object = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

var documentAll_1 = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll$2 = documentAll_1.all;

var isObject = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll$2;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var process$1 = global_1.process;
var Deno$1 = global_1.Deno;
var versions = process$1 && process$1.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */




var $String = global_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var $Object$1 = Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$1 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$1(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$2 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw $TypeError$2("Can't convert object to primitive value");
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty(global_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || defineGlobalProperty(SHARED, {});

var sharedStore = store;

var shared = createCommonjsModule(function (module) {



(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.2',
  mode:  'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var Symbol$1 = global_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var $String$2 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError$4($String$2(argument) + ' is not an object');
};

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE$1 = EXISTS$1 && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE$1
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global_1.TypeError;
var WeakMap$1 = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {





var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = functionUncurryThis(''.slice);
var replace = functionUncurryThis(''.replace);
var join = functionUncurryThis([].join);

var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat$1 = functionUncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$5 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$5
};

var html = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$3 = Object;
var ObjectPrototype = $Object$3.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$3.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$3 ? ObjectPrototype : null;
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var defineProperty$3 = objectDefineProperty.f;



var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG)) {
    defineProperty$3(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var $String$3 = String;
var $TypeError$6 = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$6("Can't set " + $String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if ( CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var defineProperty$4 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if ( descriptors && values.name !== 'values') try {
  defineProperty$4(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var ITERATOR$2 = wellKnownSymbol('iterator');
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

const StubAuthProvider = _ref => {
  let {
    auth,
    children
  } = _ref;
  let ReducerTypes;
  (function (ReducerTypes) {
    ReducerTypes[ReducerTypes["STATUS"] = 0] = "STATUS";
    ReducerTypes[ReducerTypes["TOKEN"] = 1] = "TOKEN";
    ReducerTypes[ReducerTypes["USER"] = 2] = "USER";
    ReducerTypes[ReducerTypes["FRAME"] = 3] = "FRAME";
    ReducerTypes[ReducerTypes["CLEAR"] = 4] = "CLEAR";
  })(ReducerTypes || (ReducerTypes = {}));
  function authDataReducer(state, _ref2) {
    let {
      type,
      value
    } = _ref2;
    switch (type) {
      case ReducerTypes.STATUS:
        {
          const {
            status,
            user
          } = value;
          if (status === ufinetWebFunctions.AuthStatus.LOGGED_OUT) {
            state.authFrame && ufinetWebFunctions.authService.initLogout(state.authFrame);
            return Object.assign({}, ufinetWebFunctions.InitialAuthData, {
              authFrame: state.authFrame
            });
          } else return Object.assign({}, state, {
            status,
            userData: user || state.userData
          });
        }
      case ReducerTypes.TOKEN:
        {
          const parsedToken = typeof value === 'string' ? JSON.parse(value) : value;
          return Object.assign({}, state, {
            token: parsedToken
          });
        }
      case ReducerTypes.USER:
        return Object.assign({}, state, {
          userData: value
        });
      case ReducerTypes.FRAME:
        return Object.assign({}, state, {
          authFrame: value
        });
      case ReducerTypes.CLEAR:
        return Object.assign({}, ufinetWebFunctions.InitialAuthData, {
          authFrame: state.authFrame
        });
      default:
        return state;
    }
  }
  const [authData, dispatch] = React.useReducer(authDataReducer, Object.assign({}, ufinetWebFunctions.InitialAuthData, auth));
  return /*#__PURE__*/React__default.createElement(ufinetWebFunctions.AuthContext.Provider, {
    value: Object.assign({}, authData, {
      logout: () => dispatch({
        type: ReducerTypes.STATUS,
        value: {
          status: ufinetWebFunctions.AuthStatus.LOGGED_OUT
        }
      }),
      setStatus: (status, user) => dispatch({
        type: ReducerTypes.STATUS,
        value: {
          status,
          user
        }
      }),
      setToken: token => dispatch({
        type: ReducerTypes.TOKEN,
        value: token
      }),
      setUser: user => dispatch({
        type: ReducerTypes.USER,
        value: user
      }),
      setAuthFrame: iframe => dispatch({
        type: ReducerTypes.FRAME,
        value: iframe
      }),
      clear: () => dispatch({
        type: ReducerTypes.CLEAR
      })
    })
  }, children);
};

var FunctionPrototype$2 = Function.prototype;
var apply = FunctionPrototype$2.apply;
var call$2 = FunctionPrototype$2.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function () {
  return call$2.apply(apply, arguments);
});

var arraySlice = functionUncurryThis([].slice);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) === 'Array';
};

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var $Object$4 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$4(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var $String$4 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$4(argument);
};

var push$1 = functionUncurryThis([].push);

var getJsonReplacerFunction = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push$1(keys, element);
    else if (typeof element == 'number' || classofRaw(element) === 'Number' || classofRaw(element) === 'String') push$1(keys, toString_1(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

var $String$5 = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = functionUncurryThis(/./.exec);
var charAt = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var replace = functionUncurryThis(''.replace);
var numberToString = functionUncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getJsonReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = functionCall($replacer, this, $String$5(key), value);
    if (!isSymbol(value)) return value;
  };
  return functionApply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  _export({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}

const AuthProvider = _ref => {
  let {
    application,
    initialState = {
      status: ufinetWebFunctions.AuthStatus.VERIFYING,
      application
    },
    children
  } = _ref;
  let ReducerTypes;
  (function (ReducerTypes) {
    ReducerTypes[ReducerTypes["STATUS"] = 0] = "STATUS";
    ReducerTypes[ReducerTypes["TOKEN"] = 1] = "TOKEN";
    ReducerTypes[ReducerTypes["USER"] = 2] = "USER";
    ReducerTypes[ReducerTypes["FRAME"] = 3] = "FRAME";
    ReducerTypes[ReducerTypes["CLEAR"] = 4] = "CLEAR";
  })(ReducerTypes || (ReducerTypes = {}));
  const defaultContextData = Object.assign({}, ufinetWebFunctions.InitialAuthData, {
    application
  });
  function authDataReducer(state, _ref2) {
    let {
      type,
      value
    } = _ref2;
    switch (type) {
      case ReducerTypes.STATUS:
        {
          const {
            status,
            user
          } = value;
          if (status === ufinetWebFunctions.AuthStatus.LOGGED_OUT) {
            state.authFrame && ufinetWebFunctions.authService.initLogout(state.authFrame);
            return Object.assign({}, defaultContextData, {
              authFrame: state.authFrame
            });
          } else return Object.assign({}, state, {
            status,
            userData: user || state.userData
          });
        }
      case ReducerTypes.TOKEN:
        {
          const parsedToken = typeof value === 'string' ? JSON.parse(value) : value;
          return Object.assign({}, state, {
            token: parsedToken
          });
        }
      case ReducerTypes.USER:
        return Object.assign({}, state, {
          userData: value
        });
      case ReducerTypes.FRAME:
        return Object.assign({}, state, {
          authFrame: value
        });
      case ReducerTypes.CLEAR:
        return Object.assign({}, defaultContextData, {
          authFrame: state.authFrame
        });
      default:
        return state;
    }
  }
  const [authData, dispatch] = React.useReducer(authDataReducer, Object.assign({}, getLocalStorage(ufinetWebFunctions.localStorageAuthKey, defaultContextData), initialState));
  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(Object.assign({}, value, {
        authFrame: undefined
      })));
    } catch (e) {
      console.warn(e);
    }
  }
  function getLocalStorage(key, initialValue) {
    try {
      const localValue = localStorage.getItem(key);
      return localValue ? JSON.parse(localValue) : initialValue;
    } catch (e) {
      console.warn(e);
      return initialValue;
    }
  }
  React.useEffect(() => {
    setLocalStorage(ufinetWebFunctions.localStorageAuthKey, authData);
  }, [authData]);
  return /*#__PURE__*/React__default.createElement(ufinetWebFunctions.AuthContext.Provider, {
    value: Object.assign({}, authData, {
      logout: () => dispatch({
        type: ReducerTypes.STATUS,
        value: {
          status: ufinetWebFunctions.AuthStatus.LOGGED_OUT
        }
      }),
      setStatus: (status, user) => dispatch({
        type: ReducerTypes.STATUS,
        value: {
          status,
          user
        }
      }),
      setToken: token => dispatch({
        type: ReducerTypes.TOKEN,
        value: token
      }),
      setUser: user => dispatch({
        type: ReducerTypes.USER,
        value: user
      }),
      setAuthFrame: iframe => dispatch({
        type: ReducerTypes.FRAME,
        value: iframe
      }),
      clear: () => dispatch({
        type: ReducerTypes.CLEAR
      })
    })
  }, children);
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const ufinetBoxHeightBufferFraction = 0.025;
const ufinetBoxHeightBufferInPx = () => window.innerHeight * ufinetBoxHeightBufferFraction;
const useUfinetBox = _ref => {
  let {
    containerRef,
    limitHeightToPageBottom,
    extraHeightBufferPx = 0
  } = _ref;
  const [boxHeightInPixels, setBoxHeightInPixels] = React.useState();
  const updateBoxHeightInPixels = React.useCallback(() => {
    const containerDiv = containerRef.current;
    if (!containerDiv || !limitHeightToPageBottom) return;
    const containerPositionY = containerDiv.getBoundingClientRect().y;
    setBoxHeightInPixels(window.innerHeight - containerPositionY - ufinetBoxHeightBufferInPx() - extraHeightBufferPx);
  }, [containerRef, extraHeightBufferPx, limitHeightToPageBottom]);
  React.useEffect(() => {
    if (containerRef.current) {
      updateBoxHeightInPixels();
    }
  }, [containerRef, updateBoxHeightInPixels]);
  React.useEffect(() => {
    window.addEventListener('resize', updateBoxHeightInPixels);
    updateBoxHeightInPixels();
    return () => {
      window.removeEventListener('resize', updateBoxHeightInPixels);
    };
  }, [updateBoxHeightInPixels]);
  return {
    style: {
      height: boxHeightInPixels,
      maxHeight: boxHeightInPixels
    }
  };
};

const _excluded = ["children", "className", "limitHeightToPageBottom", "extraHeightBufferPx", "style"];
const UfinetBoxContext = /*#__PURE__*/React.createContext({
  isChildOfBox: false
});
const UfinetBox = _ref => {
  let {
      children,
      className,
      limitHeightToPageBottom = true,
      extraHeightBufferPx,
      style: styleProps
    } = _ref,
    divProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const containerRef = React.useRef(null);
  const {
    style: styleFromHook
  } = useUfinetBox({
    containerRef,
    limitHeightToPageBottom: limitHeightToPageBottom,
    extraHeightBufferPx
  });
  return /*#__PURE__*/React__default.createElement(UfinetBoxContext.Provider, {
    value: {
      isChildOfBox: true
    }
  }, /*#__PURE__*/React__default.createElement("div", Object.assign({
    ref: containerRef
  }, divProps, {
    className: clsx('ufinet-box d-flex flex-column container-fluid animation-transition', className),
    style: Object.assign({}, styleProps, styleFromHook)
  }), children));
};

var defineProperty$5 = objectDefineProperty.f;

var proxyAccessor = function (Target, Source, key) {
  key in Target || defineProperty$5(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var normalizeStringArgument = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString_1(argument);
};

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

var $Error = Error;
var replace$1 = functionUncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$1(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var errorStackInstallable = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (errorStackInstallable) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', errorStackClear(stack, dropEntries));
  }
};

var wrapErrorConstructorWithCause = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if ( hasOwnProperty_1(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    errorStackInstall(result, WrappedError, result.stack, 2);
    if (this && objectIsPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (objectSetPrototypeOf) objectSetPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (descriptors && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */





var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global_1[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  _export({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    _export({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return functionApply(init, this, arguments); };
});

const useUfinetSectionBox = _ref => {
  var _containerDiv$parentE;
  let {
    containerRef: {
      current: containerDiv
    }
  } = _ref;
  const offsetFromParent = containerDiv && (_containerDiv$parentE = containerDiv.parentElement) !== null && _containerDiv$parentE !== void 0 && _containerDiv$parentE.classList.contains('ufinet-box') ? containerDiv.getBoundingClientRect().y - containerDiv.parentElement.getBoundingClientRect().y : undefined;
  return {
    style: {
      maxHeight: offsetFromParent !== undefined ? "calc(100% - " + offsetFromParent + "px)" : undefined
    }
  };
};

const _excluded$1 = ["children", "className", "style"];
const UfinetSectionBox = _ref => {
  let {
      children,
      className,
      style: styleProps
    } = _ref,
    divProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const {
    isChildOfBox
  } = React.useContext(UfinetBoxContext);
  if (!isChildOfBox) {
    throw new Error('Cannot use a section box outside of a box component');
  }
  const containerRef = React.useRef(null);
  const {
    style: styleFromHook
  } = useUfinetSectionBox({
    containerRef
  });
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    ref: containerRef
  }, divProps, {
    className: clsx('ufinet-section-box container-fluid bg-white', 'p-md-4 p-lg-6 p-xl-8', 'rounded shadow', className),
    style: Object.assign({}, styleProps, styleFromHook)
  }), children);
};

const Loading = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    userClasses = '',
    userStyles = {}
  } = _ref;
  return /*#__PURE__*/React__default.createElement("span", {
    ref: ref,
    className: "position-absolute spinner-grow me-2 " + userClasses,
    style: Object.assign({
      bottom: '50%',
      right: '50%',
      zIndex: 9999
    }, userStyles),
    role: "status",
    "aria-hidden": "true"
  });
});

class Backdrop extends React.PureComponent {
  render() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "backdrop",
      id: "mobile-backdrop"
    });
  }
}

const LoadingButton = _ref => {
  let {
    className,
    spinner = true
  } = _ref;
  const intl = reactIntl.useIntl();
  const spinnerRef = React.useRef(null);
  React.useLayoutEffect(() => {
    var _spinnerRef$current;
    return (_spinnerRef$current = spinnerRef.current) === null || _spinnerRef$current === void 0 ? void 0 : _spinnerRef$current.style.setProperty('position', 'static', 'important');
  }, []);
  return /*#__PURE__*/React__default.createElement("button", {
    className: className,
    type: "button",
    disabled: true
  }, spinner && /*#__PURE__*/React__default.createElement(Loading, {
    ref: spinnerRef,
    userClasses: "spinner-grow-sm"
  }), /*#__PURE__*/React__default.createElement("span", null, intl.formatMessage({
    id: 'LOADING_DOTS'
  })));
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global_1.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp$2 = global_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp$2('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState$1 = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$1 = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace$2 = functionUncurryThis(''.replace);
var stringSlice$1 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$1(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = functionUncurryThisClause(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThisClause(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var $TypeError$7 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$7('RegExp#exec called on incompatible receiver');
};

// @@search logic
fixRegexpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? functionCall(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString_1(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regexpExecAbstract(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

const colorConstants = {
  primaryColor: '#0065A4',
  dangerColor: '#f64e60'
};

const UfinetButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    type = 'button',
    className,
    iconClassName,
    uiStyle = 'bootstrap',
    style: userStyles = {},
    onClick = () => {},
    content,
    outline = false,
    icon,
    isDisabled = false,
    secondaryButton = false
  } = _ref;
  const formattedStyles = React.useMemo(() => Object.assign({}, userStyles, {
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    pointerEvents: 'all'
  }), [userStyles, isDisabled]);
  const formattedIcon = React.useMemo(() => icon && /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
    className: clsx(iconClassName, content && 'me-2'),
    icon: icon
  }), [icon, content, iconClassName]);
  return uiStyle === 'bootstrap' ? /*#__PURE__*/React__default.createElement("button", {
    id: id,
    "data-testid": id,
    ref: ref,
    type: type,
    disabled: !!isDisabled,
    style: formattedStyles,
    className: clsx('btn', outline && 'btn-outline', secondaryButton ? "btn-" + (outline ? 'outline-' : '') + "secondary" : "btn-" + (outline ? 'outline-' : '') + "primary", className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formattedIcon, content)) : /*#__PURE__*/React__default.createElement(button.Button, {
    id: id,
    "data-testid": id,
    type: type,
    disabled: isDisabled,
    icon: formattedIcon,
    style: formattedStyles,
    className: clsx(secondaryButton ? 'p-button-secondary' : 'p-button-info', outline && 'p-button-outlined', className),
    onClick: onClick,
    label: typeof content === 'string' ? content : undefined
  }, typeof content !== 'string' && content);
});

const MultipleDeleter = _ref => {
  let {
    title,
    text,
    selectedValues,
    setSelectedValues,
    deleteEndpoint: deleteEndPoint = () => {},
    deleteUrlParameters = [],
    deletePayloadBaseName = 'ids',
    deleteObjectKeys = [],
    search
  } = _ref;
  const intl = reactIntl.useIntl();
  const getTitle = title !== undefined ? title : intl.formatMessage({
    id: 'DELETE.OPERATION'
  });
  const getText = text !== undefined ? text : intl.formatMessage({
    id: 'DELETE.OPERATION.WARNING'
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, selectedValues && selectedValues.length > 0 && /*#__PURE__*/React__default.createElement(UfinetButton, {
    className: "me-3",
    icon: faTrash.faTrash,
    onClick: () => {
      Swal.fire({
        icon: 'warning',
        title: getTitle,
        html: getText,
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: true,
        confirmButtonColor: colorConstants.primaryColor,
        cancelButtonColor: colorConstants.dangerColor,
        preConfirm: () => {
          const deletionItemsList = deleteObjectKeys.length > 0 ? selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => {
            const idItem = {
              id: x.id
            };
            deleteObjectKeys.forEach(key => {
              if (x[key]) idItem[key] = x[key];
            });
            return idItem;
          }) : selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => x.id);
          const functionParameters = [...deleteUrlParameters, {
            [deletePayloadBaseName]: deletionItemsList
          }];
          deleteEndPoint(...functionParameters).then(() => {
            search();
            return setSelectedValues([]);
          }).catch(console.error);
        }
      });
    },
    content: intl.formatMessage({
      id: 'DELETE_ALL'
    })
  }));
};

const TooltipButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    tooltipProps,
    buttonProps,
    active,
    behaviour = 'hover',
    hideMethod = 'unrender',
    hideConditions = [],
    children
  } = _ref;
  const wrapperRef = React.useRef(null);
  const tooltipId = React.useMemo(() => uuid.v4(), []);
  const [buttonActive, setButtonActive] = React.useState(active || false);
  const [visible, setVisible] = React.useState((tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.show) || false);
  React.useEffect(() => {
    setButtonActive(active || visible);
  }, [active, visible]);
  const toggleTooltip = visibility => {
    const newVisibility = visibility === undefined ? !visible : visibility;
    setVisible(newVisibility);
  };
  const onButtonClick = e => {
    var _buttonProps$onClick;
    buttonProps === null || buttonProps === void 0 ? void 0 : (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 ? void 0 : _buttonProps$onClick.call(buttonProps, e);
    e.stopPropagation();
    if (behaviour === 'click') {
      toggleTooltip();
    } else if (behaviour === 'hover') {
      toggleTooltip(true);
    }
  };
  const onMouseoverToggle = _e => {
    if (behaviour === 'hover') {
      toggleTooltip();
    }
  };
  ufinetWebFunctions.useDOMEvent(wrapperRef, () => {
    toggleTooltip(false);
  }, {
    events: ['click'],
    detection: 'outside',
    conditions: hideConditions,
    conditionsOverride: false
  });
  const renderTooltip = props => /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, Object.assign({
    id: tooltipId
  }, props, {
    className: clsx('tooltip-button', tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.className, hideMethod === 'hide' && !visible && 'd-none'),
    arrowProps: Object.assign({}, props.arrowProps, {
      style: {
        display: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.showArrow) === false ? 'none' : 'block'
      }
    })
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: wrapperRef,
    style: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.styles
  }, children));
  React.useImperativeHandle(ref, () => ({
    toggleTooltip
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, Object.assign({}, tooltipProps, {
    show: hideMethod === 'hide' ? true : visible,
    overlay: e => renderTooltip(e)
  }), /*#__PURE__*/React__default.createElement("span", {
    onMouseEnter: onMouseoverToggle,
    onMouseLeave: onMouseoverToggle
  }, /*#__PURE__*/React__default.createElement(UfinetButton, Object.assign({}, buttonProps, {
    onClick: onButtonClick,
    outline: !buttonActive
  })))));
});

const UfinetActionButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isDisabled = false,
    onClick,
    content: text,
    className,
    icon,
    spinner
  } = _ref;
  const [isLoading, setIsLoading] = React.useState(false);
  const getClassName = () => "btn btn-primary fs-6 " + className;
  const changeActionStatus = status => {
    const newStatus = status != null ? status : !isLoading;
    setIsLoading(newStatus);
    return newStatus;
  };
  React.useImperativeHandle(ref, () => ({
    changeActionStatus
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isLoading ? /*#__PURE__*/React__default.createElement(LoadingButton, {
    className: getClassName(),
    spinner: spinner
  }) : /*#__PURE__*/React__default.createElement("button", {
    type: "submit",
    className: getClassName(),
    disabled: isDisabled,
    style: {
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      pointerEvents: 'all'
    },
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, icon && /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
    icon: icon
  }), icon && text && /*#__PURE__*/React__default.createElement("span", {
    className: "pe-4"
  }), text)));
});

var engineIsNode = classofRaw(global_1.process) === 'process';

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, { setter: true });
  return objectDefineProperty.f(target, name, descriptor);
};

var SPECIES$1 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (descriptors && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var $TypeError$8 = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$8('Incorrect invocation');
};

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var $TypeError$9 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$9(tryToString(argument) + ' is not a constructor');
};

var SPECIES$2 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var $TypeError$a = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw $TypeError$a('Not enough arguments');
  return passed;
};

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$2 = global_1.process;
var Dispatch = global_1.Dispatch;
var Function$1 = global_1.Function;
var MessageChannel = global_1.MessageChannel;
var String$1 = global_1.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global_1.location;
});

var run = function (id) {
  if (hasOwnProperty_1(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global_1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      functionApply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (engineIsNode) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = functionBindContext(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    isCallable(global_1.postMessage) &&
    !global_1.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global_1.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && typeof Pebble != 'undefined';

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask = task.set;






var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$2 = global_1.document;
var process$3 = global_1.process;
var Promise$1 = global_1.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue$2 = new queue$1();

  var flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$3.domain)) parent.exit();
    while (fn = queue$2.get()) try {
      fn();
    } catch (error) {
      if (queue$2.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!engineIsIosPebble && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = functionBindContext(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (engineIsNode) {
    notify = function () {
      process$3.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = functionBindContext(macrotask, global_1);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue$2.head) notify();
    queue$2.add(fn);
  };
}

var microtask_1 = microtask;

var hostReportErrors = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var promiseNativeConstructor = global_1.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var engineIsBrowser = !engineIsDeno && !engineIsNode
  && typeof window == 'object'
  && typeof document == 'object';

var SPECIES$3 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global_1.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$3] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

var $TypeError$b = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$b('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var f$6 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$6
};

var task$1 = task.set;









var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1 = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var setInternalState$1 = internalState.set;
var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError$2 = global_1.TypeError;
var document$3 = global_1.document;
var process$4 = global_1.process;
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$2('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$1 = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask_1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT$1 && (handler = global_1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$4.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;
    if (engineIsNode) {
      process$4.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$2("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask_1(function () {
        var wrapper = { done: false };
        try {
          functionCall(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$1(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$4.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask_1(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if ( isCallable(promiseNativeConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

_export({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var ITERATOR$3 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$3] === it);
};

var ITERATOR$4 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$4)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$c = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$c(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$d = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$d(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var ITERATOR$5 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$2 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;





var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
_export({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$3, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ( isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype$1['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype$1, 'catch', method, { unsafe: true });
  }
}

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
_export({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  reject: function reject(r) {
    var capability = newPromiseCapability.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
_export({ target: 'Promise', stat: true, forced:  FORCED_PROMISE_CONSTRUCTOR$5 }, {
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

var NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!promiseNativeConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype$2['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if ( isCallable(promiseNativeConstructor)) {
  var method$1 = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype$2['finally'] !== method$1) {
    defineBuiltIn(NativePromisePrototype$2, 'finally', method$1, { unsafe: true });
  }
}

const _excluded$2 = ["beforeStart", "onClick", "onComplete", "onError", "showSpinner", "content", "icon", "isDisabled"];
const UfinetAsyncButton = _ref => {
  let {
      beforeStart,
      onClick: _onClick,
      onComplete,
      onError,
      showSpinner = false,
      content,
      icon,
      isDisabled
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(UfinetButton, Object.assign({
    onClick: () => {
      beforeStart === null || beforeStart === void 0 ? void 0 : beforeStart();
      setIsLoading(true);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick().then(() => onComplete === null || onComplete === void 0 ? void 0 : onComplete()).catch(() => onError === null || onError === void 0 ? void 0 : onError()).finally(() => setIsLoading(false));
    },
    isDisabled: isDisabled || isLoading,
    content: showSpinner && isLoading ? /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex flex-col align-items-center",
      style: {
        gap: 8
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "spinner-border spinner-border-sm align-middle"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex flex-col align-items-center"
    }, content)) : content,
    icon: showSpinner && isLoading ? undefined : icon
  }, buttonProps));
};

const UfinetCheckbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id: propsId,
    title,
    checked = false,
    disabled = false,
    value,
    name,
    onChange,
    className
  } = _ref;
  const id = React.useMemo(() => propsId || uuid.v4(), [propsId]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: className === undefined ? 'mb-10' : className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form-check form-check-custom form-check-solid"
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: ref,
    className: "form-check-input",
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    value: value || '',
    name: name,
    id: id,
    onChange: onChange,
    "aria-label": name
  }), title && /*#__PURE__*/React__default.createElement("label", {
    className: "form-check-label",
    htmlFor: id
  }, title)));
});

var $includes = arrayIncludes.includes;



// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) === 'RegExp');
};

var $TypeError$e = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw $TypeError$e("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var stringIndexOf = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const clickableStyles = {
  cursor: 'pointer'
};
const Label = _ref => {
  let {
    id,
    requiredIcon,
    labelTitle,
    tooltipTitle,
    tooltipWarning,
    tooltipError,
    tooltipInfo,
    tooltipProcessing,
    onClick = undefined,
    styles: userStyles = {},
    className,
    htmlForId
  } = _ref;
  return labelTitle === undefined ? null : /*#__PURE__*/React__default.createElement("label", {
    id: id,
    htmlFor: htmlForId,
    style: onClick ? Object.assign({}, clickableStyles, userStyles) : Object.assign({}, userStyles),
    className: clsx('d-flex align-items-center fs-6 fw-bold form-label mb-2', className),
    "aria-labelledby": labelTitle,
    onClick: onClick || (() => {})
  }, (labelTitle || requiredIcon) && /*#__PURE__*/React__default.createElement("span", {
    style: Object.assign({}, userStyles),
    className: clsx(requiredIcon ? 'required' : '')
  }, labelTitle), tooltipTitle && /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "right",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, tooltipTitle)
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "fas fa-exclamation-circle ms-2 fs-7"
  })), tooltipWarning && /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "right",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, tooltipWarning)
  }, /*#__PURE__*/React__default.createElement("i", {
    style: {
      color: '#ffc700'
    },
    className: "fas fa-exclamation-triangle ms-2 fs-7"
  })), tooltipError && /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "right",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, tooltipError)
  }, /*#__PURE__*/React__default.createElement("i", {
    style: {
      color: '#f1416c'
    },
    className: "fas fa-exclamation-triangle ms-2 fs-7"
  })), tooltipInfo && /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "right",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, tooltipInfo)
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "fas fa-exclamation-circle fa-icon-color-blue ms-2 fs-7"
  })), tooltipProcessing && /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "right",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, tooltipProcessing)
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "fas fa-clock ms-2 fs-7"
  })));
};

const UfinetCheckBoxGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    selection,
    options,
    name: propName,
    onChange = () => {},
    inline = false,
    disabled = false,
    error,
    className,
    requiredIcon = false,
    title,
    titleClassName,
    tooltipTitle
  } = _ref;
  const wrapperId = React.useMemo(() => id || uuid.v4(), [id]);
  const name = React.useMemo(() => propName || uuid.v4(), [propName]);
  const [stateSelection, setStateSelection] = React.useState([]);
  const isCheckedOption = React.useCallback(value => stateSelection.map(it => it.value).includes(value), [stateSelection]);
  const mkCheckBoxSelectionItem = React.useCallback(function (value, checked) {
    if (checked === void 0) {
      checked = true;
    }
    return {
      value,
      checked
    };
  }, []);
  const getSelectionOption = React.useCallback(function (items) {
    if (items === void 0) {
      items = [];
    }
    const checkedOptions = items.filter(it => it.checked === true).map(it => it.value);
    return options.filter(it => checkedOptions.includes(it.value));
  }, [options]);
  React.useEffect(() => {
    setStateSelection(getSelectionOption(selection === null || selection === void 0 ? void 0 : selection.map(it => mkCheckBoxSelectionItem(it, true))));
  }, [selection, getSelectionOption, mkCheckBoxSelectionItem]);
  const onChangeSelection = React.useCallback(e => {
    const changedValue = e.target.value;
    const isNowChecked = e.target.checked;
    const newOptions = getSelectionOption([...stateSelection.filter(it => it.value !== changedValue).map(it => mkCheckBoxSelectionItem(it.value, true)), {
      value: changedValue,
      checked: isNowChecked
    }]);
    setStateSelection(newOptions);
    onChange(newOptions);
  }, [onChange, getSelectionOption, mkCheckBoxSelectionItem, stateSelection]);
  React.useImperativeHandle(ref, () => ({
    clear: () => {
      setStateSelection([]);
      onChange([]);
    },
    getCurrentSelection: () => stateSelection
  }), [stateSelection, onChange]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('d-flex flex-column', className)
  }, title && /*#__PURE__*/React__default.createElement(Label, {
    htmlForId: wrapperId,
    className: titleClassName,
    labelTitle: title,
    tooltipTitle: tooltipTitle,
    requiredIcon: requiredIcon
  }), /*#__PURE__*/React__default.createElement("div", {
    id: wrapperId
  }, options.map((opt, idx) => /*#__PURE__*/React__default.createElement("div", {
    key: idx,
    className: clsx(inline && 'form-check-inline')
  }, /*#__PURE__*/React__default.createElement(UfinetCheckbox, {
    value: opt.value,
    title: opt.label,
    name: opt.name,
    id: name + "-" + idx,
    checked: isCheckedOption(opt.value),
    disabled: opt.disabled || disabled,
    onChange: onChangeSelection,
    className: inline ? 'me-1' : 'mt-1'
  })))), error && /*#__PURE__*/React__default.createElement("label", {
    htmlFor: wrapperId,
    className: "text-danger"
  }, error));
});

(function (DatePickerTypeEnum) {
  DatePickerTypeEnum["DATE_ONLY"] = "DATE_ONLY";
  DatePickerTypeEnum["TIME_ONLY"] = "TIME_ONLY";
  DatePickerTypeEnum["DATE_TIME"] = "DATE_TIME";
})(exports.DatePickerTypeEnum || (exports.DatePickerTypeEnum = {}));
const DatePicker = _ref => {
  let {
    id,
    label,
    onChange,
    type,
    className,
    tooltip,
    disabled = false,
    labelIconRequired = false,
    timeFormat = '24',
    value,
    min,
    max,
    showCalendarIcon,
    placeholder: placeholderProps,
    dateFormat = 'dd/mm/yy',
    locale,
    error
  } = _ref;
  const lang = ufinetWebFunctions.useLang();
  const htmlId = React.useMemo(() => id || uuid.v4(), [id]);
  const placeholder = React.useMemo(() => {
    if (placeholderProps) return placeholderProps;
    switch (type) {
      case exports.DatePickerTypeEnum.DATE_ONLY:
        return 'dd/MM/YYYY';
      case exports.DatePickerTypeEnum.TIME_ONLY:
        return 'HH:mm';
      case exports.DatePickerTypeEnum.DATE_TIME:
        return 'dd/MM/YYYY HH:mm';
    }
  }, [placeholderProps, type]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(Label, {
    htmlForId: htmlId,
    labelTitle: label,
    tooltipTitle: tooltip,
    requiredIcon: labelIconRequired
  }), /*#__PURE__*/React__default.createElement(calendar.Calendar, {
    inputId: htmlId,
    value: value,
    className: utils.classNames({
      'p-invalid': error
    }, 'w-100'),
    onChange: onChange,
    disabled: disabled,
    showTime: type === exports.DatePickerTypeEnum.TIME_ONLY || type === exports.DatePickerTypeEnum.DATE_TIME,
    timeOnly: type === exports.DatePickerTypeEnum.TIME_ONLY,
    hourFormat: timeFormat,
    showIcon: showCalendarIcon,
    minDate: min,
    maxDate: max,
    placeholder: placeholder,
    dateFormat: dateFormat,
    locale: locale || lang
  }), error && /*#__PURE__*/React__default.createElement("label", {
    className: "text-danger"
  }, error));
};

const UfinetDropzone = /*#__PURE__*/React.memo(_ref => {
  let {
    onChange,
    value,
    error,
    text,
    accept,
    isMultiple = false,
    isDisabled = false
  } = _ref;
  const translate = ufinetWebFunctions.useTranslator();
  const onDrop = React.useCallback(acceptedFiles => onChange(acceptedFiles.map(element => element).pop()), [onChange]);
  const {
    getRootProps,
    getInputProps
  } = reactDropzone.useDropzone({
    onDrop,
    accept,
    useFsAccessApi: false
  });
  const rootProps = React.useMemo(() => getRootProps(), [getRootProps]);
  const inputProps = React.useMemo(() => getInputProps(), [getInputProps]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", Object.assign({}, rootProps, {
    className: "dropzone " + (isDisabled ? 'dropzone-disabled' : '')
  }), /*#__PURE__*/React__default.createElement("input", Object.assign({}, inputProps, {
    multiple: isMultiple,
    disabled: isDisabled || false
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "bi bi-file-earmark-arrow-up text-primary fs-3x"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "ms-4"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "fs-5 fw-bolder text-primary mb-1"
  }, text)))), /*#__PURE__*/React__default.createElement("label", {
    className: "text-danger"
  }, error), value.path && /*#__PURE__*/React__default.createElement("aside", {
    className: "mt-8"
  }, /*#__PURE__*/React__default.createElement("h4", null, translate('PREVIEW.FILE')), /*#__PURE__*/React__default.createElement("ul", {
    className: "list-unstyled h-40px"
  }, value.path && /*#__PURE__*/React__default.createElement("li", null, value.path, " - ", ufinetWebFunctions.formatFileSize(value.size)))));
}, (prevProps, nextProps) => fastEquals.deepEqual(prevProps.value, nextProps.value) && fastEquals.deepEqual(prevProps.error, nextProps.error) && fastEquals.deepEqual(prevProps.isDisabled, nextProps.isDisabled));

const EasterEggInner = _ref => {
  let {
    id,
    xOffset,
    yOffset,
    movementIntervalMs,
    onActiveChange,
    victory
  } = _ref;
  const imgSrc = React.useMemo(() => ufinetWebFunctions.toAbsoluteUrl('/media/easter/alpaca-2.gif'), [id]);
  const spitAudio = React.useMemo(() => new Audio(ufinetWebFunctions.toAbsoluteUrl('/media/easter/spit.mp3')), [id]);
  const movementInterval = React.useRef();
  const getNewY = () => ufinetWebFunctions.numberInRangeInt(0, yOffset + 1);
  const getNewX = () => ufinetWebFunctions.numberInRangeInt(0, xOffset + 1);
  const [top, setTop] = React.useState(getNewY());
  const [left, setLeft] = React.useState(getNewX());
  const [active, setActive] = React.useState(false);
  const toggleActive = () => {
    if (active || victory) return;
    const newActiveValue = !active;
    if (newActiveValue) spitAudio.play();
    setActive(newActiveValue);
    onActiveChange(newActiveValue);
  };
  const moveImage = () => {
    setTop(getNewY());
    setLeft(getNewX());
  };
  const stopMovement = () => clearInterval(movementInterval.current);
  React.useEffect(() => {
    !victory ? movementInterval.current = setInterval(moveImage, movementIntervalMs) : stopMovement();
    return stopMovement;
  }, [victory]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "easter-egg-fg",
    onClick: toggleActive,
    style: {
      top: top + "%",
      left: left + "%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "easter-egg-media " + (id % 2 !== 0 && 'pos-invert-x') + " " + (active && 'color-invert') + " " + ((active || victory) && 'activated'),
    alt: "LET'S GOOOOO",
    src: imgSrc,
    draggable: false
  }));
};

const defaults = {
  minItems: 4,
  maxItems: 10,
  movementInterval: 2000,
  xOffset: 75,
  yOffset: 80
};
const EasterEgg = _ref => {
  let {
    nItems,
    onVictory
  } = _ref;
  const [victory, setVictory] = React.useState(false);
  const [activeCount, setActiveCount] = React.useState(0);
  const onActiveChange = newActiveState => {
    if (victory) return;
    setActiveCount(newActiveState ? activeCount + 1 : activeCount - 1);
  };
  React.useEffect(() => {
    if (activeCount === nItems) {
      setVictory(true);
      if (onVictory) onVictory();
    }
  }, [activeCount, nItems, onVictory]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "easter-egg-bg disco"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "w-100 h-100 p-relative"
  }, [...Array(nItems)].map((_, idx) => /*#__PURE__*/React__default.createElement(EasterEggInner, {
    key: idx,
    id: idx,
    xOffset: defaults.xOffset,
    yOffset: defaults.yOffset,
    movementIntervalMs: defaults.movementInterval,
    onActiveChange: onActiveChange,
    victory: victory
  }))));
};

const defaultExitTimeout = 800;
const EasterEggWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    durationMs = 10000
  } = _ref;
  const nItems = ufinetWebFunctions.numberInRangeInt(defaults.minItems, defaults.maxItems + 1);
  const [active, setActive] = React.useState(false);
  const exitTimeout = React.useRef();
  const [exitTimeoutMs, setExitTimeoutMs] = React.useState(defaultExitTimeout);
  const victoryAudio = React.useMemo(() => new Audio(ufinetWebFunctions.toAbsoluteUrl('/media/easter/victory.mp3')), [durationMs]);
  React.useEffect(() => {
    const setupExitTimeout = () => setExitTimeoutMs(victoryAudio.duration * 1000);
    victoryAudio.addEventListener('loadedmetadata', setupExitTimeout);
    return () => {
      victoryAudio.removeEventListener('loadedmetadata', setupExitTimeout);
    };
  }, [victoryAudio]);
  const trigger = () => {
    ufinetWebFunctions.notificationParty(durationMs - 1000);
    setActive(true);
  };
  const exit = React.useCallback(() => {
    victoryAudio.play();
    clearTimeout(exitTimeout.current);
    setTimeout(() => {
      reactToastify.toast.dismiss();
      setActive(false);
    }, exitTimeoutMs + 500);
  }, [victoryAudio, exitTimeoutMs]);
  React.useImperativeHandle(ref, () => ({
    trigger,
    exit
  }));
  React.useEffect(() => {
    if (active) exitTimeout.current = setTimeout(() => setActive(false), durationMs);
  }, [active, durationMs]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "easter-egg"
  }, active && /*#__PURE__*/React__default.createElement(EasterEgg, {
    nItems: nItems,
    onVictory: exit
  }));
});

var $TypeError$f = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$3(O, 'length').writable) {
    throw $TypeError$f('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$g = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$g('Maximum allowed index exceeded');
  return it;
};

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$1 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
_export({ target: 'Array', proto: true, arity: 1, forced: FORCED$1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    arraySetLength(O, len);
    return len;
  }
});

(function (MouseEvents) {
  MouseEvents["SHORT"] = "MOUSE_SHORT";
  MouseEvents["LONG"] = "MOUSE_LONG";
})(exports.MouseEvents || (exports.MouseEvents = {}));
const defaultRestartMs = 2000;
const patterns = {
  sosMorsePattern: [exports.MouseEvents.SHORT, exports.MouseEvents.SHORT, exports.MouseEvents.SHORT, exports.MouseEvents.LONG, exports.MouseEvents.LONG, exports.MouseEvents.LONG, exports.MouseEvents.SHORT, exports.MouseEvents.SHORT, exports.MouseEvents.SHORT]
};
const MouseRecorder = _ref => {
  let {
    onComplete,
    pattern: targetPattern = patterns.sosMorsePattern,
    restartMs = defaultRestartMs,
    children
  } = _ref;
  const recordedPattern = React.useRef([]);
  const recorderTimeout = React.useRef();
  const longPressEvents = ufinetWebFunctions.useLongPress({
    onClick: () => sendEvent(exports.MouseEvents.SHORT),
    onLongPress: () => sendEvent(exports.MouseEvents.LONG)
  });
  function sendEvent(event) {
    handleTimeout();
    recordedPattern.current.push(event);
    const result = checkPattern();
    if (result) {
      resetPattern();
      onComplete(targetPattern);
    }
  }
  function handleTimeout() {
    if (recorderTimeout.current) {
      clearTimeout(recorderTimeout.current);
    }
    recorderTimeout.current = setTimeout(resetPattern, restartMs);
  }
  function checkPattern() {
    if (recordedPattern.current.length < targetPattern.length) return false;else if (recordedPattern.current.length === targetPattern.length) return fastEquals.deepEqual(targetPattern, recordedPattern.current);else return fastEquals.deepEqual(targetPattern, recordedPattern.current.slice(recordedPattern.current.length - targetPattern.length));
  }
  function resetPattern() {
    recorderTimeout.current = undefined;
    recordedPattern.current = [];
  }
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, longPressEvents, {
    className: "mouse-recorder"
  }), children);
};

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace$3 = functionUncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$3(string, ltrim, '');
    if (TYPE & 2) string = replace$3(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;



var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $trim = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const UfinetInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    type,
    name,
    isDisabled = false,
    placeholder = '',
    requiredIcon,
    className,
    labelTitle,
    tooltipTitle,
    value,
    onChange = () => {},
    onBlur = () => {},
    error,
    solid = true,
    autofocus = false,
    style: userStyles = {}
  } = _ref;
  const inputId = React.useMemo(() => id || uuid.v4(), [id]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: Object.assign({}, userStyles)
  }, /*#__PURE__*/React__default.createElement(Label, {
    htmlForId: inputId,
    labelTitle: labelTitle,
    tooltipTitle: tooltipTitle,
    requiredIcon: requiredIcon
  }), type === 'decimal' ? /*#__PURE__*/React__default.createElement("input", {
    id: inputId,
    ref: ref,
    type: "number",
    name: name,
    placeholder: placeholder,
    value: value,
    step: "any",
    disabled: isDisabled,
    className: "form-control " + (solid ? 'form-control-solid' : ''),
    onChange: onChange,
    onBlur: onBlur,
    autoFocus: autofocus
  }) : /*#__PURE__*/React__default.createElement("input", {
    id: inputId,
    ref: ref,
    type: type,
    name: name,
    placeholder: placeholder,
    value: value,
    disabled: isDisabled,
    className: "form-control " + (solid ? 'form-control-solid' : ''),
    onChange: onChange,
    onBlur: onBlur,
    autoFocus: autofocus
  }), error && /*#__PURE__*/React__default.createElement("label", {
    htmlFor: inputId,
    className: "text-danger"
  }, error));
});

const UfinetSimpleInput = _ref => {
  let {
    id,
    type,
    className,
    isDisabled = false,
    value,
    onChange = () => {},
    onBlur = () => {},
    required
  } = _ref;
  const inputId = React.useMemo(() => id || uuid.v4(), [id]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, type === 'decimal' ? /*#__PURE__*/React__default.createElement("input", {
    id: inputId,
    type: "number",
    value: value,
    step: "any",
    disabled: isDisabled || false,
    className: "form-control " + className,
    onChange: onChange,
    onBlur: onBlur,
    required: required || false
  }) : /*#__PURE__*/React__default.createElement("input", {
    id: inputId,
    type: type,
    value: value,
    disabled: isDisabled || false,
    className: "form-control " + className,
    onChange: onChange,
    onBlur: onBlur,
    required: required || false
  }));
};

// ES6 Map
var map;
try {
  map = Map;
} catch (_) { }
var set$2;

// ES6 Set
try {
  set$2 = Set;
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set$2 && src instanceof set$2) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

const toString$2 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$2.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$1.call(object, key);
}

var _baseHas = baseHas;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$2 = _root.Symbol;

var _Symbol = Symbol$2;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$5.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString$1 = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$3(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1$1 = toString$3;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1$1(value));
}

var _castPath = castPath;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has$1(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

var has_1 = has$1;

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var defineProperty$6 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$6;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = _mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$9.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$2 = _getNative(_root, 'Promise');

var _Promise = Promise$2;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$2;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$2) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$2) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$a.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$a.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;

  return (this._values[key] = value)
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

var propertyExpr = {
  Cache: Cache,

  split: split$1,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path);

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split$1(path), cb, thisArg);
  },
};

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split$1(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split$1(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}
var propertyExpr_2 = propertyExpr.split;
var propertyExpr_5 = propertyExpr.getter;
var propertyExpr_7 = propertyExpr.forEach;

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr_5(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$1(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_1(_extends$1({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$1({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr_7(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$2({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$2({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(_extends$2({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends$2({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$2({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends$2({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends$2({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$2({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const isAbsent = value => value == null;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create.prototype = StringSchema.prototype; //
// String Interfaces
//

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString_1$1(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr;

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords;

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo$1 + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString_1$1(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos$1, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(words_1(deburr_1(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = _createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$2 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$2 + ']',
    rsCombo$2 = '[' + rsComboRange$3 + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol = '(?:' + [rsNonAstral$1 + rsCombo$2 + '?', rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString_1$1(string);

    var strSymbols = _hasUnicode(string)
      ? _stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? _castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = _createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst_1(toString_1$1(string).toLowerCase());
}

var capitalize_1 = capitalize;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = _createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize_1(word) : word);
});

var camelCase_1 = camelCase;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

var mapKeys_1 = mapKeys;

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

var toposort_1 = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

var array$1 = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}
toposort_1.array = array$1;

function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = propertyExpr_2(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_1(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort_1.array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

let isObject$2 = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject$2(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = _extends$3({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_1(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject$2(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], _extends$3({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends$3({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = propertyExpr_5(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_1(obj, from)) {
        newObj = _extends$3({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_1(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys(camelCase_1);
  }

  snakeCase() {
    return this.transformKeys(snakeCase_1);
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_1(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_1(this.fields, value => value.describe());
    return base;
  }

}
function create$1(spec) {
  return new ObjectSchema(spec);
}
create$1.prototype = ObjectSchema.prototype;

const UfinetSelectOptionShape = {
  label: create().notRequired()
};
const UfinetSelectOptionBaseValidation = create$1().notRequired().shape(UfinetSelectOptionShape);
const deadlineSelectDefaultOptions = [12, 24, 36];

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype$1, R)
    ? functionCall(regexpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;






var TO_STRING = 'toString';
var RegExpPrototype$2 = RegExp.prototype;
var nativeToString = RegExpPrototype$2[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$2 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = toString_1(R.source);
    var flags = toString_1(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const mkOptionFromNumber = (n, unit) => {
  const baseOption = {
    value: n.toString(),
    label: n.toString() + (unit ? " " + (n === 1 ? unit.single || unit.plural : unit.plural) : '')
  };
  return Object.assign({}, baseOption, {
    label: unit !== null && unit !== void 0 && unit.keepCase ? baseOption.label : baseOption.label.toLowerCase()
  });
};
const mkOptionFromAreaType = (areaType, translate) => {
  return {
    label: translate("AREA_TYPE." + areaType),
    value: areaType
  };
};
const mkOptionFromNetworkItemType = (networkItemType, translate) => {
  return {
    label: translate("LOAD_TYPE." + networkItemType),
    value: networkItemType
  };
};
const getValuesFromSelect = function getValuesFromSelect(opt) {
  if (opt === void 0) {
    opt = [];
  }
  if (Array.isArray(opt)) {
    return opt.map(o => o.value);
  } else return opt ? [opt.value] : [];
};

const _excluded$3 = ["id", "onChange", "isMulti", "isCreatable", "defaultValue", "shouldClearDefaultValue"];
const theme = theme => Object.assign({}, theme, {
  colors: Object.assign({}, theme.colors, {
    primary: colorConstants.primaryColor
  })
});
const SELECT_ALL = 'SELECT ALL';
const UfinetSelectInner = (_ref, ref) => {
  let {
      id,
      onChange = () => {},
      isMulti = false,
      isCreatable = false,
      defaultValue = isMulti ? [] : undefined,
      shouldClearDefaultValue = true
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  const inputId = React.useMemo(() => id || uuid.v4(), [id]);
  const labelId = React.useMemo(() => uuid.v4(), []);
  const wasAlreadyMounted = React.useRef(false);
  const translate = ufinetWebFunctions.useTranslator();
  const [ufiOptions, setUfiOptions] = React.useState();
  const [selectedOption, setSelectedOption] = React.useState(props.value);
  const firstUpdate = React.useRef(true);
  const isAllCurrentSelected = React.useCallback(e => e.length > 0 && e[e.length - 1].value === SELECT_ALL, []);
  const isAllPreviousSelected = React.useMemo(() => {
    var _selectedOption$;
    return selectedOption && ((_selectedOption$ = selectedOption[0]) === null || _selectedOption$ === void 0 ? void 0 : _selectedOption$.value.toString()) === SELECT_ALL;
  }, [selectedOption]);
  const onChangeUfinetSelect = React.useCallback(function (e, actionMeta, options) {
    if (options === void 0) {
      options = {
        changeToNewOption: true,
        triggerOnChange: true
      };
    }
    if ((Array.isArray(e) ? !e.length : !e) && !(selectedOption !== null && selectedOption !== void 0 && selectedOption.length)) return;
    if (isMulti && isAllCurrentSelected(e)) {
      const newOptions = [e[e.length - 1]];
      setSelectedOption(newOptions);
      options.triggerOnChange && props.options && onChange([...props.options]);
    } else if (isMulti && isAllPreviousSelected && selectedOption) {
      const newOptions = e.slice(1);
      options.changeToNewOption && setSelectedOption(newOptions);
      options.triggerOnChange && onChange(newOptions);
    } else {
      options.changeToNewOption && setSelectedOption(e);
      const onChangeValue = !e ? isMulti ? [] : undefined : Array.isArray(e) ? isMulti ? e : e[0] : e;
      options.triggerOnChange && onChange(onChangeValue || undefined);
    }
  }, [props.options, selectedOption, isMulti, onChange, isAllPreviousSelected, isAllCurrentSelected]);
  React.useEffect(() => {
    if (props.options !== undefined && props.options.length !== 0) {
      setUfiOptions(props.noSortValues ? props.options : isMulti && props.withSelectAll ? [{
        label: translate('SELECT_ALL').toUpperCase(),
        value: SELECT_ALL
      }, ...ufinetWebFunctions.sortAlphabetically(props.options, 'label')] : ufinetWebFunctions.sortAlphabetically(props.options, 'label'));
    } else {
      setUfiOptions([]);
    }
  }, [translate, isMulti, props.options, props.noSortValues, props.withSelectAll]);
  const isEmpty = React.useCallback(() => !selectedOption || selectedOption.length === 0, [selectedOption]);
  const clearSelect = React.useCallback(function (clearDefaults) {
    if (clearDefaults === void 0) {
      clearDefaults = shouldClearDefaultValue;
    }
    const newOptions = clearDefaults ? [] : !defaultValue ? [] : isMulti ? defaultValue : [defaultValue];
    setSelectedOption(newOptions);
    onChangeUfinetSelect(newOptions);
  }, [defaultValue, isMulti, onChangeUfinetSelect, shouldClearDefaultValue]);
  React.useEffect(() => {
    if (!wasAlreadyMounted.current) {
      wasAlreadyMounted.current = true;
      return;
    }
    clearSelect();
  }, [props.clearValues]);
  React.useEffect(() => {
    var _props$value;
    if ((isMulti && !((_props$value = props.value) !== null && _props$value !== void 0 && _props$value.length) || !isMulti && !props.value) && (isMulti && Array.isArray(defaultValue) && defaultValue !== null && defaultValue !== void 0 && defaultValue.length || !isMulti && defaultValue)) {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        onChangeUfinetSelect(defaultValue);
      } else {
        setSelectedOption([]);
      }
    } else {
      onChangeUfinetSelect(!props.value ? [] : isMulti ? props.value : Array.isArray(props.value) ? props.value : [props.value], undefined, {
        changeToNewOption: true,
        triggerOnChange: !props.value
      });
    }
  }, [defaultValue, isMulti, props.value]);
  React.useImperativeHandle(ref, () => ({
    isEmpty,
    clearSelect,
    createOption: function createOption(newOption, changeToNewOption) {
      if (changeToNewOption === void 0) {
        changeToNewOption = true;
      }
      if (!isCreatable) return;
      const newOptions = ufiOptions !== null && ufiOptions !== void 0 && ufiOptions.find(opt => opt.value.toString() === newOption.value.toString()) ? ufiOptions : [...(!isMulti ? [] : ufiOptions || []), newOption];
      setUfiOptions(newOptions);
      onChangeUfinetSelect(newOptions, undefined, {
        changeToNewOption,
        triggerOnChange: true
      });
    }
  }), [isEmpty, clearSelect, isCreatable, ufiOptions, isMulti, onChangeUfinetSelect]);
  const selectProps = React.useMemo(() => Object.assign({}, props, {
    menuPortalTarget: props.menuPortalTarget || document.body,
    id: inputId,
    instanceId: inputId,
    className: clsx('ufinet-select', props.expandVertically ? 'expand-v' : ''),
    isMulti: isMulti,
    value: selectedOption,
    menuPosition: props.menuPosition,
    onChange: onChangeUfinetSelect,
    options: ufiOptions,
    styles: props.styles || ufinetWebFunctions.UfinetSelectBaseStyles,
    theme: theme,
    noOptionsMessage: () => props.isLoadingOptions ? translate('LOADING_DOTS') : !isCreatable ? translate('NO_OPTIONS') : translate('INTRODUCE_OPTION'),
    filterOption: props.filterOption || ufinetWebFunctions.onlyLabelFilter,
    placeholder: props.placeholder ? /*#__PURE__*/React__default.createElement("span", {
      style: {
        whiteSpace: 'nowrap'
      }
    }, props.placeholder) : undefined,
    'aria-labelledby': labelId
  }), [props, inputId, isMulti, selectedOption, onChangeUfinetSelect, ufiOptions, labelId, translate, isCreatable]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.className
  }, props.labelTitle && /*#__PURE__*/React__default.createElement(Label, {
    id: labelId,
    htmlForId: inputId,
    labelTitle: props.labelTitle,
    tooltipTitle: props.tooltipTitle,
    tooltipWarning: props.tooltipWarning,
    tooltipError: props.tooltipError,
    requiredIcon: props.requiredIcon,
    styles: props.labelStyles
  }), isCreatable ? /*#__PURE__*/React__default.createElement(CreatableSelect, Object.assign({}, selectProps)) : /*#__PURE__*/React__default.createElement(Select, Object.assign({}, selectProps)), props.error && /*#__PURE__*/React__default.createElement("label", {
    className: "text-danger"
  }, props.error));
};
const UfinetSelect = /*#__PURE__*/React.forwardRef(UfinetSelectInner);

const AreaSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isMulti,
    requiredIcon,
    className,
    error,
    value,
    isDisabled,
    onChange,
    areaType,
    noLabel
  } = _ref;
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const [areasOptions, setAreasOptions] = React.useState();
  const [fetching, setFetching] = React.useState(false);
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _areaService = React.useMemo(() => ufinetWebFunctions.areaService(authData, intl), [authData, intl]);
  const getOptionsFromAreas = React.useCallback(result => {
    const options = result.map(element => ({
      label: element.name,
      value: element.name
    }));
    return areaType !== undefined ? [{
      label: intl.formatMessage({
        id: 'BY_DEFAULT'
      }),
      value: 'POR_DEFECTO'
    }, ...options] : options;
  }, [intl, areaType]);
  const fillAreaSelect = React.useCallback(countries => {
    if (countries.length === 0) {
      setAreasOptions([]);
      return;
    }
    setFetching(true);
    const criteria = {
      countries: countries,
      networkAreaTypes: areaType ? [areaType] : [],
      networkAreas: []
    };
    _areaService.findArea(criteria).then(result => {
      return setAreasOptions(getOptionsFromAreas(result));
    }).catch(console.error).finally(() => setFetching(false));
  }, [_areaService, areaType, getOptionsFromAreas]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current2;
    return {
      fillSelect: fillAreaSelect,
      clearSelect: () => {
        var _selectRef$current;
        setAreasOptions([]);
        (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect();
      },
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, [fillAreaSelect]);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, {
    ref: selectRef,
    requiredIcon: requiredIcon,
    className: className,
    isMulti: isMulti,
    error: error,
    labelTitle: noLabel ? '' : intl.formatMessage({
      id: 'AREAS.AREA'
    }),
    tooltipTitle: intl.formatMessage({
      id: 'AREAS.AREA'
    }),
    isClearable: true,
    onChange: onChange,
    isDisabled: isDisabled,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    options: areasOptions,
    placeholder: intl.formatMessage({
      id: 'AREAS.AREA'
    }),
    isLoadingOptions: fetching
  });
});

const AreaTypeSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    onChange,
    value,
    isMulti,
    error,
    isDisabled,
    withoutFetch,
    defaultValue,
    shouldClearDefaultValue,
    labelTitle,
    tooltipTitle
  } = _ref;
  const selectRef = React.useRef(null);
  const translate = ufinetWebFunctions.useTranslator();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _typesAreaService = React.useMemo(() => ufinetWebFunctions.typesAreaService(authData), [authData]);
  const [areaTypeOptions, setAreaTypeOptions] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, []);
  const getAreaTypes = React.useCallback(function () {
    try {
      setFetching(true);
      return Promise.resolve(_typesAreaService.getAllNetworkTypes());
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_typesAreaService]);
  const onAreaTypesFetched = areaTypes => {
    !withoutFetch && setAreaTypeOptions(areaTypes.map(area => mkOptionFromAreaType(area.id, translate)));
  };
  ufinetWebFunctions.useAsync({
    asyncFn: getAreaTypes,
    onSuccess: onAreaTypesFetched,
    onFailure: console.warn,
    runFinally: () => setFetching(false)
  }, []);
  const getColor = value => {
    if (!value || value === SELECT_ALL) return ufinetWebFunctions.defaultColor;else return ufinetWebFunctions.AreaTypeColors.get(value) || ufinetWebFunctions.defaultColor;
  };
  return /*#__PURE__*/React__default.createElement(UfinetSelect, {
    ref: selectRef,
    className: className,
    labelTitle: labelTitle || translate('AREAS.AREA_TYPE'),
    tooltipTitle: tooltipTitle || translate('AREAS.AREA_TYPE'),
    error: error,
    onChange: onChange,
    isMulti: isMulti,
    isDisabled: isDisabled,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    defaultValue: defaultValue,
    shouldClearDefaultValue: shouldClearDefaultValue,
    options: areaTypeOptions,
    isClearable: true,
    placeholder: translate('AREAS.AREA_TYPE'),
    styles: ufinetWebFunctions.selectColorStyles(getColor),
    isLoadingOptions: fetching
  });
});

const _excluded$4 = ["unclearable", "isDisabled", "isMulti", "error", "onChange", "value", "className", "requiredIcon", "options", "isLoadingOptions"];
const BandwidthSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      unclearable,
      isDisabled = false,
      isMulti = false,
      error = undefined,
      onChange,
      value,
      className,
      requiredIcon = false,
      options,
      isLoadingOptions
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const translate = ufinetWebFunctions.useTranslator();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _bandwidthService = React.useMemo(() => ufinetWebFunctions.bandwidthsService(authData), [authData]);
  const isInternalUser = ufinetWebFunctions.useInternalUser();
  const [bandwidthOptions, setBandwidthOptions] = React.useState();
  const [fetching, setFetching] = React.useState();
  React.useEffect(() => {
    setFetching(isLoadingOptions);
  }, [isLoadingOptions]);
  React.useEffect(() => {
    setBandwidthOptions(options);
  }, [options]);
  const fillBandwidthSelect = React.useCallback(bandwidthRequest => {
    if (!bandwidthRequest.countryId || !bandwidthRequest.corporateGroupId || !bandwidthRequest.clientId || !bandwidthRequest.productId) {
      setBandwidthOptions([]);
      return;
    }
    setFetching(true);
    _bandwidthService.findByOriginCountryAndDestinationCountryAndClientIdAndProductId(bandwidthRequest, {
      notifyError: false
    }).then(bandwidthResponse => {
      return setBandwidthOptions(bandwidthResponse.map(ufinetWebFunctions.makeSelectOptionFromBandwidth));
    }).catch(e => {
      if (e.errors[0].includes('This bandwidth combination has no coincidences:')) {
        setBandwidthOptions([]);
        const combinationError = e.errors[0].split(':')[1];
        const lastCommaIndex = combinationError.lastIndexOf(',');
        const messageFormatted = combinationError.substring(0, lastCommaIndex) + ' o ' + combinationError.substring(lastCommaIndex + 1);
        const translateMessage = isInternalUser ? translate('BANDWIDTH.COMBINATION.NO.COINCIDENCES.INTERNAL.USER', {
          bandwidthCombination: messageFormatted
        }) : translate('BANDWIDTH.COMBINATION.NO.COINCIDENCES.EXTERNAL.USER');
        reactToastify.toast.error(translateMessage, {
          toastId: messageFormatted
        });
      } else {
        reactToastify.toast.error(translate('SERVICE.BANDWIDTH.ERROR', {
          containerId: ufinetWebFunctions.TOAST_CONTAINER_ID
        }));
      }
    }).finally(() => setFetching(false));
  }, [intl, _bandwidthService]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      fillBandwidthSelect,
      emptyBandwidthSelect,
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, [fillBandwidthSelect]);
  const emptyBandwidthSelect = () => {
    setBandwidthOptions([]);
  };
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    labelTitle: props.labelTitle !== undefined ? props.labelTitle : intl.formatMessage({
      id: 'SERVICE.BANDWIDTH'
    }),
    tooltipTitle: props.tooltipTitle !== undefined ? props.tooltipTitle : intl.formatMessage({
      id: 'SERVICE.BANDWIDTH.TOOLTIP'
    }),
    options: bandwidthOptions,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    requiredIcon: requiredIcon || false,
    className: className || '',
    isMulti: isMulti || false,
    noSortValues: true,
    error: error,
    isClearable: !unclearable,
    onChange: onChange,
    isDisabled: isDisabled || false,
    placeholder: intl.formatMessage({
      id: 'SERVICE.BANDWIDTH.PLACEHOLDER'
    }),
    isLoadingOptions: fetching,
    filterOption: ufinetWebFunctions.onlyLabelAndBeginsWithLabelFilter
  }));
});

const _excluded$5 = ["bandwidthRequest"];
const BandwidthEditSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      bandwidthRequest
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  const selectRef = React.useRef(null);
  React.useEffect(() => {
    var _selectRef$current, _selectRef$current$fi;
    (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : (_selectRef$current$fi = _selectRef$current.fillBandwidthSelect) === null || _selectRef$current$fi === void 0 ? void 0 : _selectRef$current$fi.call(_selectRef$current, bandwidthRequest);
  }, [bandwidthRequest]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current2, _selectRef$current3;
    return {
      clearSelect: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.clearSelect,
      isEmpty: (_selectRef$current3 = selectRef.current) === null || _selectRef$current3 === void 0 ? void 0 : _selectRef$current3.isEmpty
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(BandwidthSelect, Object.assign({
    requiredIcon: true,
    noLabel: true,
    ref: selectRef
  }, rest));
});

const _excluded$6 = ["requiredIcon", "corporateGroupIds", "isMulti", "isDisabled", "value", "error", "onChange", "className", "placeholder", "labelTitle", "noLabel", "tooltipTitle", "withoutFetch", "withSelectAll"],
  _excluded2 = ["application"];
const emptyClientSelectOption = Object.assign({}, ufinetWebFunctions.emptyUfinetSelectOption, {
  corporateGroupId: ''
});
const ClientSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      requiredIcon = true,
      corporateGroupIds = [],
      isMulti = false,
      isDisabled = false,
      value,
      error = undefined,
      onChange,
      className,
      placeholder,
      labelTitle,
      noLabel = false,
      tooltipTitle,
      withoutFetch,
      withSelectAll
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  const intl = reactIntl.useIntl();
  const selectRef = React.useRef(null);
  const _useContext = React.useContext(ufinetWebFunctions.AuthContext),
    {
      application
    } = _useContext,
    authData = _objectWithoutPropertiesLoose(_useContext, _excluded2);
  const _clientService = React.useMemo(() => ufinetWebFunctions.clientService(authData, {
    frontendApplication: application
  }), [application, authData]);
  const [fetching, setFetching] = React.useState(false);
  const [clientOptions, setClientOptions] = React.useState();
  const createOptionsFromClientResponse = response => response.map(element => ({
    label: element.name,
    value: element.id,
    kamId: element === null || element === void 0 ? void 0 : element.kamId,
    corporateGroupId: element.corporateGroupId
  }));
  const getClients = React.useCallback(function (countries, corporateGroups) {
    try {
      setFetching(true);
      const requestedCountries = countries || [];
      const requestedGroups = corporateGroups || [];
      return Promise.resolve(requestedCountries.length === 0 && requestedGroups.length === 0 ? _clientService.findAll() : _clientService.findClients({
        countries: requestedCountries,
        corporateGroups: requestedGroups
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_clientService]);
  const onClientsFetched = React.useCallback(clients => {
    !withoutFetch && setClientOptions(createOptionsFromClientResponse(clients));
  }, [withoutFetch]);
  ufinetWebFunctions.useAsync({
    asyncFn: getClients,
    onSuccess: onClientsFetched,
    runFinally: () => setFetching(false)
  }, []);
  const fillClientSelect = React.useCallback((countries, corporateGroups) => {
    getClients(countries, corporateGroups).then(onClientsFetched).catch(console.error).finally(() => setFetching(false));
  }, [getClients, onClientsFetched]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      fillSelect: fillClientSelect,
      fillAllClients: () => fillClientSelect(),
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, [fillClientSelect]);
  const clientSelectOptions = React.useMemo(() => !corporateGroupIds.length ? clientOptions : clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.filter(client => corporateGroupIds.includes(client.corporateGroupId)), [clientOptions, corporateGroupIds]);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    labelTitle: noLabel ? undefined : labelTitle || intl.formatMessage({
      id: 'SELECT.CLIENT.TITLE'
    }),
    tooltipTitle: tooltipTitle || intl.formatMessage({
      id: 'SELECT.CLIENT.TOOLTIP'
    }),
    options: clientSelectOptions,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    requiredIcon: requiredIcon,
    className: className || '',
    isMulti: isMulti,
    withSelectAll: withSelectAll,
    error: error,
    isClearable: true,
    onChange: onChange,
    isDisabled: isDisabled,
    placeholder: placeholder || intl.formatMessage({
      id: 'SELECT.CLIENT.TITLE'
    }),
    isLoadingOptions: fetching
  }));
});

const _excluded$7 = ["clientRequest", "placeholder"];
const ClientEditSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      clientRequest,
      placeholder
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  const selectRef = React.useRef(null);
  React.useEffect(() => {
    var _selectRef$current, _selectRef$current$fi;
    (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : (_selectRef$current$fi = _selectRef$current.fillSelect) === null || _selectRef$current$fi === void 0 ? void 0 : _selectRef$current$fi.call(_selectRef$current, clientRequest.countries, clientRequest.corporateGroups);
  }, [clientRequest]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current2, _selectRef$current3;
    return {
      clearSelect: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.clearSelect,
      isEmpty: (_selectRef$current3 = selectRef.current) === null || _selectRef$current3 === void 0 ? void 0 : _selectRef$current3.isEmpty
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(ClientSelect, Object.assign({
    requiredIcon: true,
    noLabel: true,
    placeholder: placeholder,
    ref: selectRef
  }, rest));
});

const _excluded$8 = ["requiredIcon", "error", "onChange", "isMulti", "isDisabled", "value", "labelTitle"];
const ContactSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      requiredIcon = false,
      error = undefined,
      onChange,
      isMulti = false,
      isDisabled = false,
      value,
      labelTitle
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _contactService = React.useMemo(() => ufinetWebFunctions.contactsService(authData), [authData]);
  const [fetching, setFetching] = React.useState(false);
  const [contactOptions, setContactOptions] = React.useState();
  const fillContactSelect = React.useCallback(contactRequest => {
    if (contactRequest.clientIds.length === 0) setContactOptions([]);
    setFetching(true);
    _contactService.findContactsByClientId(contactRequest).then(contactResponse => {
      return setContactOptions(contactResponse.map(_ref2 => {
        let {
          id: value,
          name: label
        } = _ref2;
        return {
          value,
          label
        };
      }));
    }).catch(console.error).finally(() => setFetching(false));
  }, [_contactService]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      fillSelect: fillContactSelect,
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, [fillContactSelect]);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    labelTitle: labelTitle || intl.formatMessage({
      id: 'SELECT.CONTACT.TITLE'
    }),
    tooltipTitle: intl.formatMessage({
      id: 'SELECT.CONTACT.TOOLTIP'
    }),
    options: contactOptions,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    requiredIcon: requiredIcon,
    className: props.className ? props.className : '',
    isMulti: isMulti || false,
    error: error,
    isClearable: true,
    onChange: onChange,
    isDisabled: isDisabled || false,
    placeholder: intl.formatMessage({
      id: 'SELECT.CONTACT.NONE'
    }),
    isLoadingOptions: fetching
  }));
});

const _excluded$9 = ["requiredIcon", "isMulti", "isDisabled", "error", "onChange", "withoutFetch", "value", "className", "withSelectAll"];
const CorporateGroupSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      requiredIcon = true,
      isMulti = false,
      isDisabled = false,
      error = undefined,
      onChange,
      withoutFetch,
      value,
      className,
      withSelectAll
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _corporateGroupService = React.useMemo(() => ufinetWebFunctions.corporateGroupService(authData), [authData]);
  const [corporateGroupOptions, setCorporateGroupOptions] = React.useState();
  const [fetching, setFetching] = React.useState(false);
  const getOptionFromCorporateGroup = cg => {
    return {
      label: cg.name,
      value: cg.id
    };
  };
  const fillCorporateGroupsByCountries = React.useCallback(countries => {
    if (countries.length === 0) {
      _corporateGroupService.getAllCorporateGroups().then(response => {
        return setCorporateGroupOptions(response.map(getOptionFromCorporateGroup));
      }).catch(console.error).finally(() => setFetching(false));
    } else {
      setFetching(true);
      _corporateGroupService.getCorporateGroupsByCountries({
        countries
      }).then(response => {
        return setCorporateGroupOptions(response.map(getOptionFromCorporateGroup));
      }).catch(console.error).finally(() => setFetching(false));
    }
  }, [_corporateGroupService]);
  const fillAllCorporateGroups = React.useCallback(() => fillCorporateGroupsByCountries([]), [fillCorporateGroupsByCountries]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      fillAll: fillAllCorporateGroups,
      fillByCountries: fillCorporateGroupsByCountries,
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, [fillAllCorporateGroups, fillCorporateGroupsByCountries]);
  const getCorporateGroups = React.useCallback(function () {
    try {
      setFetching(true);
      return Promise.resolve(_corporateGroupService.getAllCorporateGroups());
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_corporateGroupService]);
  const onCorporateGroupsFetched = cgs => {
    !withoutFetch && setCorporateGroupOptions(cgs.map(getOptionFromCorporateGroup));
  };
  ufinetWebFunctions.useAsync({
    asyncFn: getCorporateGroups,
    onSuccess: onCorporateGroupsFetched,
    onFailure: console.warn,
    runFinally: () => setFetching(false)
  }, []);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    labelTitle: intl.formatMessage({
      id: 'SELECT.GROUP.TITLE'
    }),
    tooltipTitle: intl.formatMessage({
      id: 'SELECT.GROUP.TOOLTIP'
    }),
    options: corporateGroupOptions,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    requiredIcon: requiredIcon,
    className: className || '',
    isMulti: isMulti || false,
    withSelectAll: withSelectAll,
    error: error,
    isClearable: true,
    onChange: onChange,
    isDisabled: isDisabled || false,
    placeholder: intl.formatMessage({
      id: 'SELECT.GROUP.PLACEHOLDER'
    }),
    isLoadingOptions: fetching
  }));
});

const CountrySelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    requiredIcon = false,
    className,
    onChange,
    value,
    error = undefined,
    isMulti,
    isDisabled,
    withoutFetch,
    defaultValue,
    withSelectAll
  } = _ref;
  const selectRef = React.useRef(null);
  const int = reactIntl.useIntl();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _countriesService = React.useMemo(() => ufinetWebFunctions.countriesService(authData), [authData]);
  const [countryOptions, setCountryOptions] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const getCountries = React.useCallback(function () {
    try {
      setFetching(true);
      return Promise.resolve(_countriesService.getAllCountries());
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_countriesService]);
  const getOptionFromCountry = country => {
    return {
      label: country.name,
      value: country.id
    };
  };
  const onCountriesFetched = countries => {
    !withoutFetch && setCountryOptions(countries.map(getOptionFromCountry));
  };
  const onCountriesFailedToFetch = error => {
    console.warn(error);
  };
  ufinetWebFunctions.useAsync({
    asyncFn: getCountries,
    onSuccess: onCountriesFetched,
    onFailure: onCountriesFailedToFetch,
    runFinally: () => setFetching(false)
  }, []);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, {
    ref: selectRef,
    className: className,
    requiredIcon: requiredIcon,
    labelTitle: int.formatMessage({
      id: 'SELECT.COUNTRY.TITLE'
    }),
    tooltipTitle: int.formatMessage({
      id: 'SELECT.COUNTRY.TOOLTIP'
    }),
    error: error,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    defaultValue: defaultValue,
    onChange: onChange,
    options: countryOptions,
    isClearable: true,
    isMulti: isMulti,
    isDisabled: isDisabled || false,
    placeholder: int.formatMessage({
      id: 'SELECT.COUNTRY.TITLE'
    }),
    isLoadingOptions: fetching,
    withSelectAll: withSelectAll
  });
});

var $TypeError$h = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw $TypeError$h('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array = Array;
var max$1 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max$1(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var floor$1 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$1(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySliceSimple(array, 0, middle), comparefn),
    mergeSort(arraySliceSimple(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var test$1 = [];
var nativeSort = functionUncurryThis(test$1.sort);
var push$2 = functionUncurryThis(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$2(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var charAt$2 = functionUncurryThis(''.charAt);
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
var stringSlice$2 = functionUncurryThis(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$3 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$3(S, index).length : 1);
};

// @@match logic
fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = toString_1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

const _excluded$a = ["isDisabled", "error", "onChange", "onBlur", "value", "className", "requiredIcon", "noLabel", "noTooltip", "options", "unit", "includeDefaultOptions", "unclearable", "isMulti", "preventDefaultOnSubmit"];
const DeadlineSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      isDisabled = false,
      error = undefined,
      onChange,
      onBlur: propsOnBlur,
      value,
      className,
      requiredIcon = false,
      noLabel = false,
      noTooltip = false,
      options = [],
      unit,
      includeDefaultOptions = true,
      unclearable,
      isMulti,
      preventDefaultOnSubmit = true
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const [inputValue, setInputValue] = React.useState('');
  const [latestKeyEvent, setLatestKeyEvent] = React.useState();
  const selectValues = React.useMemo(() => value !== undefined ? Array.isArray(value) ? value.map(v => mkOptionFromNumber(v, unit)) : mkOptionFromNumber(value, unit) : isMulti ? [] : undefined, [isMulti, unit, value]);
  const deadlineOptions = React.useMemo(() => {
    const allOptions = (!includeDefaultOptions ? options : [...new Set([...deadlineSelectDefaultOptions, ...options])]).sort((a, b) => a - b);
    return allOptions.map(n => mkOptionFromNumber(n, unit));
  }, [includeDefaultOptions, options, unit]);
  React.useEffect(() => {
    var _selectRef$current;
    if (!selectValues) (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect();
  }, [selectValues]);
  const addNewOption = React.useCallback(() => {
    var _inputValue$trim$matc;
    if (!inputValue) return;
    const newEntry = inputValue === null || inputValue === void 0 ? void 0 : (_inputValue$trim$matc = inputValue.trim().match(/\s*[1-9][0-9]*\s*,?\s*$/)) === null || _inputValue$trim$matc === void 0 ? void 0 : _inputValue$trim$matc[0].trim();
    const newEntryNumeric = ufinetWebFunctions.isNumeric(newEntry) ? +newEntry : undefined;
    const newOption = newEntryNumeric && newEntryNumeric > 0 ? {
      label: newEntryNumeric.toString(),
      value: newEntryNumeric.toString()
    } : undefined;
    if (newOption) {
      var _selectRef$current2, _selectRef$current2$c;
      (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : (_selectRef$current2$c = _selectRef$current2.createOption) === null || _selectRef$current2$c === void 0 ? void 0 : _selectRef$current2$c.call(_selectRef$current2, newOption);
    }
    setInputValue('');
  }, [inputValue]);
  const handleKeyDown = React.useCallback(event => {
    if (!props.isCreatable) return;
    if (!['Enter', 'Tab', ',', ' '].includes(event.key)) return;
    addNewOption();
  }, [props.isCreatable, addNewOption]);
  const onInputChange = React.useCallback(newInput => {
    setInputValue(newInput);
    latestKeyEvent && handleKeyDown(latestKeyEvent);
  }, [latestKeyEvent, handleKeyDown]);
  const onBlur = React.useCallback(blurEvent => {
    addNewOption();
    setInputValue('');
    propsOnBlur === null || propsOnBlur === void 0 ? void 0 : propsOnBlur(blurEvent);
  }, [addNewOption, propsOnBlur]);
  const onKeyDown = React.useCallback(event => {
    if (event.key === 'Backspace') return;
    if (['Enter', 'Tab'].includes(event.key)) {
      preventDefaultOnSubmit && event.preventDefault();
      handleKeyDown(event);
      return;
    }
    event.persist();
    setLatestKeyEvent(event);
  }, [handleKeyDown, preventDefaultOnSubmit]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current3, _selectRef$current4, _selectRef$current5;
    return {
      clearSelect: (_selectRef$current3 = selectRef.current) === null || _selectRef$current3 === void 0 ? void 0 : _selectRef$current3.clearSelect,
      isEmpty: (_selectRef$current4 = selectRef.current) === null || _selectRef$current4 === void 0 ? void 0 : _selectRef$current4.isEmpty,
      createOption: (_selectRef$current5 = selectRef.current) === null || _selectRef$current5 === void 0 ? void 0 : _selectRef$current5.createOption
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    inputValue: inputValue,
    labelTitle: noLabel ? undefined : props.labelTitle || intl.formatMessage({
      id: 'SERVICE.DEADLINE'
    }),
    tooltipTitle: noTooltip ? undefined : props.tooltipTitle || intl.formatMessage({
      id: 'SERVICE.DEADLINE.TOOLTIP'
    }),
    tooltipError: props.tooltipError,
    tooltipWarning: props.tooltipWarning,
    options: [...deadlineOptions],
    value: selectValues,
    requiredIcon: requiredIcon || false,
    className: className || '',
    noSortValues: true,
    error: error,
    isMulti: isMulti,
    isClearable: !unclearable,
    onChange: onChange,
    onInputChange: onInputChange,
    onKeyDown: onKeyDown,
    onBlur: onBlur,
    isDisabled: isDisabled || false,
    placeholder: intl.formatMessage({
      id: 'SERVICE.DEADLINE'
    })
  }));
});

const HardFilterWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    search,
    actionButtons,
    networkAreaType,
    forceUpdate,
    actionButtonRef,
    hidden = {
      hideCountries: false,
      hideAreas: false,
      hideAreaTypes: true
    }
  } = _ref;
  const intl = reactIntl.useIntl();
  const countrySelectRef = React.useRef(null);
  const areaTypeSelectRef = React.useRef(null);
  const areaSelectRef = React.useRef(null);
  const [selectedCountries, setSelectedCountries] = React.useState([]);
  const [selectedAreas, setSelectedAreas] = React.useState([]);
  const [selectedAreaTypes, setSelectedAreaTypes] = React.useState([]);
  const isFullyHidden = React.useMemo(() => hidden === true, [hidden]);
  const isHiddenCountry = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideCountries), [hidden]);
  const isHiddenArea = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideAreas), [hidden]);
  const isHiddenAreaType = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideAreaTypes), [hidden]);
  const clearSelect = () => {
    var _countrySelectRef$cur, _areaTypeSelectRef$cu, _areaSelectRef$curren;
    (_countrySelectRef$cur = countrySelectRef.current) === null || _countrySelectRef$cur === void 0 ? void 0 : _countrySelectRef$cur.clearSelect();
    (_areaTypeSelectRef$cu = areaTypeSelectRef.current) === null || _areaTypeSelectRef$cu === void 0 ? void 0 : _areaTypeSelectRef$cu.clearSelect();
    (_areaSelectRef$curren = areaSelectRef.current) === null || _areaSelectRef$curren === void 0 ? void 0 : _areaSelectRef$curren.clearSelect();
    setSelectedCountries([]);
    setSelectedAreas([]);
    setSelectedAreaTypes([]);
  };
  React.useEffect(() => clearSelect(), [forceUpdate]);
  React.useImperativeHandle(ref, () => ({
    clearSelect,
    isEmpty: () => {
      var _countrySelectRef$cur2, _areaTypeSelectRef$cu2, _areaSelectRef$curren2;
      return ((_countrySelectRef$cur2 = countrySelectRef.current) === null || _countrySelectRef$cur2 === void 0 ? void 0 : _countrySelectRef$cur2.isEmpty()) && ((_areaTypeSelectRef$cu2 = areaTypeSelectRef.current) === null || _areaTypeSelectRef$cu2 === void 0 ? void 0 : _areaTypeSelectRef$cu2.isEmpty()) && ((_areaSelectRef$curren2 = areaSelectRef.current) === null || _areaSelectRef$curren2 === void 0 ? void 0 : _areaSelectRef$curren2.isEmpty());
    },
    getCountries: () => selectedCountries,
    getAreas: () => selectedAreas,
    getAreaTypes: () => selectedAreaTypes
  }), [selectedCountries, selectedAreas, selectedAreaTypes]);
  const handleCountryChange = React.useCallback(countries => {
    var _areaSelectRef$curren3;
    setSelectedCountries(countries);
    setSelectedAreas([]);
    (_areaSelectRef$curren3 = areaSelectRef.current) === null || _areaSelectRef$curren3 === void 0 ? void 0 : _areaSelectRef$curren3.fillSelect(countries.map(c => c.value));
  }, []);
  const handleAreaChange = React.useCallback(areas => {
    setSelectedAreas(areas);
  }, []);
  const handleAreaTypeChange = React.useCallback(areaTypes => {
    setSelectedAreaTypes(areaTypes);
  }, []);
  return isFullyHidden ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null) : /*#__PURE__*/React__default.createElement("div", {
    className: "container-fluid bg-white mb-5 p-7 rounded shadow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: " row justify-content-between align-items-end pb-5"
  }, !isHiddenCountry && /*#__PURE__*/React__default.createElement(CountrySelect, {
    ref: countrySelectRef,
    className: "col",
    isMulti: true,
    value: selectedCountries,
    onChange: cc => handleCountryChange(cc)
  }), !isHiddenAreaType && /*#__PURE__*/React__default.createElement(AreaTypeSelect, {
    ref: areaTypeSelectRef,
    className: "col",
    isMulti: true,
    value: selectedAreaTypes,
    onChange: atc => handleAreaTypeChange(atc)
  }), !isHiddenArea && /*#__PURE__*/React__default.createElement(AreaSelect, {
    ref: areaSelectRef,
    isMulti: true,
    className: "col",
    areaType: networkAreaType,
    value: selectedAreas,
    onChange: ac => handleAreaChange(ac),
    isDisabled: selectedCountries.length === 0
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12 pt-3 pt-sm-0 col-sm-auto"
  }, /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionButtonRef,
    onClick: () => search(),
    className: "w-auto me-5",
    content: intl.formatMessage({
      id: 'SEARCH'
    }),
    icon: faMagnifyingGlass.faMagnifyingGlass
  }), /*#__PURE__*/React__default.createElement(reactBootstrap.OverlayTrigger, {
    placement: "bottom",
    delay: {
      show: 250,
      hide: 400
    },
    overlay: /*#__PURE__*/React__default.createElement(reactBootstrap.Tooltip, {
      className: "tooltip-dark"
    }, intl.formatMessage({
      id: 'CLEAR'
    }))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-inline"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "pi pi-filter-slash me-5 fa-icon-primary",
    onClick: clearSelect
  }))), actionButtons)));
});

const loadTypesColorRed = '#FA7069';
const loadTypesColorBlue = '#699AFA';
const LoadTypeSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onChange,
    value,
    error = undefined,
    isMulti = false,
    isDisabled = false,
    labelTitle,
    tooltipTitle,
    noLabel = false,
    defaultValue,
    shouldClearDefaultValue
  } = _ref;
  const selectRef = React.useRef(null);
  const translate = ufinetWebFunctions.useTranslator();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const [loadTypes, setLoadTypes] = React.useState([]);
  const selectOptions = React.useMemo(() => loadTypes.map(type => mkOptionFromNetworkItemType(type, translate)), [loadTypes, translate]);
  const [fetching, setFetching] = React.useState(false);
  const _networkItemsService = React.useMemo(() => ufinetWebFunctions.networkItemsService(authData), [authData]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, []);
  const getLoadTypes = React.useCallback(function () {
    try {
      setFetching(true);
      return Promise.resolve(_networkItemsService.getAllNetworkTypes());
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_networkItemsService]);
  const onLoadTypesFetched = res => {
    const typeIds = res.map(r => r.id);
    setLoadTypes(typeIds);
  };
  ufinetWebFunctions.useAsync({
    asyncFn: getLoadTypes,
    onSuccess: onLoadTypesFetched,
    onFailure: console.warn,
    runFinally: () => setFetching(false)
  }, []);
  const getColor = value => {
    if (!value || value === SELECT_ALL) return ufinetWebFunctions.defaultColor;else return value.toLowerCase().includes('air') ? loadTypesColorRed : loadTypesColorBlue;
  };
  return /*#__PURE__*/React__default.createElement(UfinetSelect, {
    ref: selectRef,
    labelTitle: noLabel ? undefined : labelTitle || translate('STEPPER.LOAD_TYPE.SELECT.PLACEHOLDER'),
    tooltipTitle: tooltipTitle || translate('STEPPER.LOAD_TYPE.SELECT.PLACEHOLDER'),
    error: error,
    isMulti: isMulti,
    isDisabled: isDisabled,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    defaultValue: defaultValue,
    shouldClearDefaultValue: shouldClearDefaultValue,
    onChange: onChange,
    options: selectOptions,
    isClearable: true,
    placeholder: translate('STEPPER.LOAD_TYPE.SELECT.PLACEHOLDER'),
    styles: ufinetWebFunctions.selectColorStyles(getColor),
    isLoadingOptions: fetching
  });
});

const _excluded$b = ["isMulti", "isDisabled", "error", "value", "onChange", "origin"];
const PopSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      isMulti = false,
      isDisabled = false,
      error = undefined,
      value,
      onChange,
      origin
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const selectRef = React.useRef(null);
  const intl = reactIntl.useIntl();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _popService = React.useMemo(() => ufinetWebFunctions.popService(authData), [authData]);
  const [fetching, setFetching] = React.useState(false);
  const [popOptions, setPopOptions] = React.useState();
  const formatLocationName = ogName => {
    const [provinceName, countryName] = ogName.split(',').map(str => typeof str === 'string' ? str.trim() : str);
    const formattedName = countryName === undefined ? provinceName : countryName + ": " + provinceName;
    return formattedName;
  };
  const fillPopSelect = React.useCallback(popRequest => {
    if (popRequest.countryId === '' || popRequest.corporateGroupId === '') setPopOptions(undefined);
    setFetching(true);
    _popService.findPopsByCorporateGroupId(popRequest).then(pops => {
      const formattedPops = pops.map(pop => Object.assign({}, pop, {
        provinceName: formatLocationName(pop.provinceName)
      }));
      const popLocations = [...new Set(formattedPops.map(pop => pop.provinceName))];
      const popGroupedOptions = popLocations.map(locationName => ({
        label: locationName,
        options: formattedPops.filter(pop => pop.provinceName === locationName).map(_ref2 => {
          let {
            id: value,
            addressName: label,
            latitude,
            longitude
          } = _ref2;
          return {
            value,
            label,
            latitude,
            longitude
          };
        })
      }));
      return setPopOptions(popGroupedOptions);
    }).catch(console.error).finally(() => setFetching(false));
  }, [_popService]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      fillPopSelect,
      isEmpty: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.isEmpty,
      clearSelect: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.clearSelect
    };
  }, [fillPopSelect]);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    labelTitle: origin ? intl.formatMessage({
      id: 'SERVICE.POP.ORIGIN'
    }) : intl.formatMessage({
      id: 'SERVICE.POP.DESTINATION'
    }),
    tooltipTitle: origin ? intl.formatMessage({
      id: 'SERVICE.POP.ORIGIN.TOOLTIP'
    }) : intl.formatMessage({
      id: 'SERVICE.POP.DESTINATION.TOOLTIP'
    }),
    options: popOptions,
    value: !isMulti ? (value === null || value === void 0 ? void 0 : value.label) && value : value || [],
    requiredIcon: props.requiredIcon ? props.requiredIcon : false,
    className: props.className ? props.className : '',
    isMulti: isMulti,
    error: error,
    isClearable: true,
    onChange: onChange,
    isDisabled: isDisabled,
    placeholder: intl.formatMessage({
      id: 'POP.PLACEHOLDER'
    }),
    isLoadingOptions: fetching
  }));
});

const _excluded$c = ["isDisabled", "className", "onChange", "value", "error", "yesOptionText", "noOptionText", "placeholder"];
const YesNoSelect = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      isDisabled = false,
      className,
      onChange,
      value,
      error = undefined,
      yesOptionText,
      noOptionText,
      placeholder
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  const selectRef = React.useRef(null);
  const translate = ufinetWebFunctions.useTranslator();
  const yesOption = React.useMemo(() => ({
    label: yesOptionText || translate('YES'),
    value: 'true'
  }), [translate, yesOptionText]);
  const noOption = React.useMemo(() => ({
    label: noOptionText || translate('NO'),
    value: 'false'
  }), [translate, noOptionText]);
  const selectValue = React.useMemo(() => !value ? noOption : yesOption, [value, noOption, yesOption]);
  const onSelectChange = React.useCallback(newOption => {
    if (!newOption) return;
    onChange(newOption.value === yesOption.value);
  }, [onChange, yesOption.value]);
  React.useImperativeHandle(ref, () => {
    var _selectRef$current, _selectRef$current2;
    return {
      clearSelect: (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.clearSelect,
      isEmpty: (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.isEmpty
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(UfinetSelect, Object.assign({
    ref: selectRef
  }, props, {
    options: [yesOption, noOption],
    value: selectValue,
    requiredIcon: props.requiredIcon,
    className: className,
    isMulti: false,
    error: error,
    isClearable: false,
    onChange: newOption => onSelectChange(newOption ? newOption : undefined),
    isDisabled: isDisabled,
    placeholder: placeholder
  }));
});

const allowAllFilterFields = {
  allowCountrySelection: true,
  allowCorporateGroupSelection: true,
  allowClientSelection: true,
  allowContact: true,
  allowReference: true,
  allowFinalClient: true,
  allowSubmit: true
};
const allowNoneFilterFields = {
  allowCountrySelection: false,
  allowCorporateGroupSelection: false,
  allowClientSelection: false,
  allowContact: false,
  allowReference: false,
  allowFinalClient: false,
  allowSubmit: false
};
const Filter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _formik$values$refere3, _formik$values$finalC;
  let {
    internalUser,
    initialValues,
    setFilter,
    resetFilter = false,
    resetFilterCallback = () => {},
    disabled = false,
    hidden: hiddenProps = false,
    multi = false,
    required = false,
    afterCountryChange = () => {},
    afterCorporateGroupChange = () => {},
    afterClientChange = () => {},
    afterContactChange = () => {},
    afterReferenceChange = () => {},
    afterFinalClientChange = () => {},
    icon,
    submitButtonContent,
    preSelected = false
  } = _ref;
  const intl = reactIntl.useIntl();
  const hidden = React.useMemo(() => typeof hiddenProps === 'boolean' ? hiddenProps : Object.assign({
    hideFinalClient: true
  }, hiddenProps), [hiddenProps]);
  const translate = ufinetWebFunctions.useTranslator();
  const authData = React.useContext(ufinetWebFunctions.AuthContext);
  const _countriesService = React.useMemo(() => ufinetWebFunctions.countriesService(authData), [authData]);
  const _corporateGroupService = React.useMemo(() => ufinetWebFunctions.corporateGroupService(authData), [authData]);
  const _clientService = React.useMemo(() => ufinetWebFunctions.clientService(authData), [authData]);
  const countrySelectRef = React.useRef(null);
  const groupSelectRef = React.useRef(null);
  const clientSelectRef = React.useRef(null);
  const contactSelectRef = React.useRef(null);
  const actionButtonRef = React.useRef(null);
  const _onChange = React.useCallback(ufinetWebFunctions.onFormikChanges, []);
  const onTextChange = React.useCallback(ufinetWebFunctions.onFormikTextChanges, []);
  const [filterPreSelected, setFilterPreSelected] = React.useState({});
  const isFullyDisabled = React.useMemo(() => disabled === true, [disabled]);
  const isFullyHidden = React.useMemo(() => hidden === true, [hidden]);
  React.useImperativeHandle(ref, () => ({
    clearSelect: () => {
      var _countrySelectRef$cur, _groupSelectRef$curre, _clientSelectRef$curr, _contactSelectRef$cur;
      (_countrySelectRef$cur = countrySelectRef.current) === null || _countrySelectRef$cur === void 0 ? void 0 : _countrySelectRef$cur.clearSelect();
      (_groupSelectRef$curre = groupSelectRef.current) === null || _groupSelectRef$curre === void 0 ? void 0 : _groupSelectRef$curre.clearSelect();
      (_clientSelectRef$curr = clientSelectRef.current) === null || _clientSelectRef$curr === void 0 ? void 0 : _clientSelectRef$curr.clearSelect();
      (_contactSelectRef$cur = contactSelectRef.current) === null || _contactSelectRef$cur === void 0 ? void 0 : _contactSelectRef$cur.clearSelect();
    },
    isEmpty: () => {
      var _countrySelectRef$cur2, _groupSelectRef$curre2, _clientSelectRef$curr2, _contactSelectRef$cur2;
      return ((_countrySelectRef$cur2 = countrySelectRef.current) === null || _countrySelectRef$cur2 === void 0 ? void 0 : _countrySelectRef$cur2.isEmpty()) && ((_groupSelectRef$curre2 = groupSelectRef.current) === null || _groupSelectRef$curre2 === void 0 ? void 0 : _groupSelectRef$curre2.isEmpty()) && ((_clientSelectRef$curr2 = clientSelectRef.current) === null || _clientSelectRef$curr2 === void 0 ? void 0 : _clientSelectRef$curr2.isEmpty()) && ((_contactSelectRef$cur2 = contactSelectRef.current) === null || _contactSelectRef$cur2 === void 0 ? void 0 : _contactSelectRef$cur2.isEmpty());
    }
  }), []);
  const isMultiCountry = React.useMemo(() => multi === true || typeof multi === 'object' && (multi === null || multi === void 0 ? void 0 : multi.multiCountry), [multi]);
  const isMultiCG = React.useMemo(() => multi === true || typeof multi === 'object' && (multi === null || multi === void 0 ? void 0 : multi.multiCorporateGroup), [multi]);
  const isMultiClient = React.useMemo(() => multi === true || typeof multi === 'object' && (multi === null || multi === void 0 ? void 0 : multi.multiClient), [multi]);
  const isHiddenCountry = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideCountry), [hidden]);
  const isHiddenCG = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideCorporateGroup), [hidden]);
  const isHiddenClient = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideClient), [hidden]);
  const isHiddenContact = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideContact), [hidden]);
  const isHiddenReference = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideReference), [hidden]);
  const isHiddenFinalClient = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideFinalClient), [hidden]);
  const isHiddenSubmit = React.useMemo(() => hidden === true || typeof hidden === 'object' && (hidden === null || hidden === void 0 ? void 0 : hidden.hideSubmit), [hidden]);
  const mkPreselectedData = React.useCallback(function () {
    try {
      return Promise.resolve(_countriesService.getAllCountries().then(countries => countries.length === 1 ? countries[0] : undefined)).then(function (preselectedCountry) {
        return Promise.resolve(_corporateGroupService.getCorporateGroupsByCountries({
          countries: preselectedCountry ? [preselectedCountry.id] : []
        }).then(cgs => cgs.length === 1 ? cgs[0] : undefined)).then(function (preselectedCG) {
          return Promise.resolve(_clientService.findClients({
            countries: preselectedCountry ? [preselectedCountry.id] : [],
            corporateGroups: preselectedCG ? [preselectedCG.id] : []
          }).then(clients => clients.length === 1 ? clients[0] : undefined)).then(function (preselectedClient) {
            const ret = {};
            if (preselectedCountry) {
              const countryOption = {
                label: preselectedCountry.name,
                value: preselectedCountry.id
              };
              ret.countrySelect = isMultiCountry ? [countryOption] : countryOption;
            }
            if (preselectedCG) {
              const cgOption = {
                label: preselectedCG.name,
                value: preselectedCG.id
              };
              ret.corporateGroupSelect = isMultiCG ? [cgOption] : cgOption;
            }
            if (preselectedClient) {
              const clientOption = {
                label: preselectedClient.name,
                value: preselectedClient.id
              };
              ret.clientSelect = isMultiClient ? [clientOption] : clientOption;
            }
            return ret;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [_countriesService, _corporateGroupService, _clientService, isMultiCountry, isMultiCG, isMultiClient]);
  React.useEffect(() => {
    if (preSelected) {
      mkPreselectedData().then(setFilterPreSelected).catch();
    }
  }, [mkPreselectedData]);
  const mkEmptyFilterData = React.useCallback(() => Object.assign({}, {
    countrySelect: isMultiCountry ? [] : ufinetWebFunctions.emptyUfinetSelectOption,
    corporateGroupSelect: isMultiCG ? [] : ufinetWebFunctions.emptyUfinetSelectOption,
    clientSelect: isMultiClient ? [] : ufinetWebFunctions.emptyUfinetSelectOption,
    contactSelect: ufinetWebFunctions.emptyUfinetSelectOption,
    reference: '',
    finalClient: ''
  }, filterPreSelected), [isMultiCountry, isMultiCG, isMultiClient, filterPreSelected]);
  const onCountryChange = country => {
    ufinetWebFunctions.onFormikChanges(formik$1, 'countrySelect', isMultiCountry ? [] : ufinetWebFunctions.emptyUfinetSelectOption)(country);
    ufinetWebFunctions.onFormikChanges(formik$1, 'corporateGroupSelect')(isMultiCG ? [] : ufinetWebFunctions.emptyUfinetSelectOption);
    ufinetWebFunctions.onFormikChanges(formik$1, 'clientSelect')(isMultiClient ? [] : ufinetWebFunctions.emptyUfinetSelectOption);
    ufinetWebFunctions.onFormikChanges(formik$1, 'contactSelect')(ufinetWebFunctions.emptyUfinetSelectOption);
    if (country) {
      var _groupSelectRef$curre3, _clientSelectRef$curr3;
      const countryIds = getValuesFromSelect(country);
      (_groupSelectRef$curre3 = groupSelectRef.current) === null || _groupSelectRef$curre3 === void 0 ? void 0 : _groupSelectRef$curre3.fillByCountries(countryIds);
      (_clientSelectRef$curr3 = clientSelectRef.current) === null || _clientSelectRef$curr3 === void 0 ? void 0 : _clientSelectRef$curr3.fillSelect(countryIds, []);
    } else {
      var _groupSelectRef$curre4;
      (_groupSelectRef$curre4 = groupSelectRef.current) === null || _groupSelectRef$curre4 === void 0 ? void 0 : _groupSelectRef$curre4.fillByCountries([]);
    }
    afterCountryChange(country);
  };
  const onCorporateGroupChange = cg => {
    ufinetWebFunctions.onFormikChanges(formik$1, 'corporateGroupSelect', isMultiCG ? [] : ufinetWebFunctions.emptyUfinetSelectOption)(cg);
    ufinetWebFunctions.onFormikChanges(formik$1, 'clientSelect')(isMultiClient ? [] : ufinetWebFunctions.emptyUfinetSelectOption);
    ufinetWebFunctions.onFormikChanges(formik$1, 'contactSelect')(ufinetWebFunctions.emptyUfinetSelectOption);
    if (cg) {
      var _clientSelectRef$curr4;
      const countryIds = getValuesFromSelect(formik$1.values.countrySelect);
      const cgIds = getValuesFromSelect(cg);
      (_clientSelectRef$curr4 = clientSelectRef.current) === null || _clientSelectRef$curr4 === void 0 ? void 0 : _clientSelectRef$curr4.fillSelect(countryIds, cgIds);
    }
    afterCorporateGroupChange(cg);
  };
  const onClientChange = client => {
    ufinetWebFunctions.onFormikChanges(formik$1, 'clientSelect', isMultiClient ? [] : ufinetWebFunctions.emptyUfinetSelectOption)(client);
    ufinetWebFunctions.onFormikChanges(formik$1, 'contactSelect')(ufinetWebFunctions.emptyUfinetSelectOption);
    !!client && fillContactList(client);
    afterClientChange(client);
  };
  const fillContactList = client => {
    var _contactSelectRef$cur3;
    const clientIds = getValuesFromSelect(client);
    internalUser && ((_contactSelectRef$cur3 = contactSelectRef.current) === null || _contactSelectRef$cur3 === void 0 ? void 0 : _contactSelectRef$cur3.fillSelect({
      clientIds
    }));
  };
  const sendData = values => {
    setFilter({
      countrySelect: values.countrySelect,
      corporateGroupSelect: values.corporateGroupSelect,
      clientSelect: values.clientSelect,
      contactSelect: values.contactSelect,
      reference: values.reference,
      finalClient: values.finalClient
    });
  };
  const isRequiredCountry = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredCountry), [required]);
  const isRequiredCG = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredCorporateGroup), [required]);
  const isRequiredClient = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredClient), [required]);
  const isRequiredContact = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredContact), [required]);
  const isRequiredReference = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredReference), [required]);
  const isRequiredFinalClient = React.useMemo(() => required === true || typeof required === 'object' && (required === null || required === void 0 ? void 0 : required.requiredFinalClient), [required]);
  const mkDataFormSchema = React.useCallback(() => create$1().shape({
    countrySelect: ufinetWebFunctions.mkFormSchema(UfinetSelectOptionShape, {
      multi: isMultiCountry,
      required: isRequiredCountry,
      intl
    }),
    corporateGroupSelect: ufinetWebFunctions.mkFormSchema(UfinetSelectOptionShape, {
      multi: isMultiCG,
      required: isRequiredCG,
      intl
    }),
    clientSelect: ufinetWebFunctions.mkFormSchema(UfinetSelectOptionShape, {
      multi: isMultiClient,
      required: isRequiredClient,
      intl
    }),
    contactSelect: ufinetWebFunctions.mkFormSchema(UfinetSelectOptionShape, {
      multi: false,
      required: isRequiredContact,
      intl
    }),
    reference: isRequiredReference ? create().required() : create().notRequired(),
    finalClient: isRequiredFinalClient ? create().required() : create().notRequired()
  }), [isMultiClient, isMultiCG, isMultiCountry, intl, isRequiredClient, isRequiredCG, isRequiredCountry, isRequiredContact, isRequiredReference, isRequiredFinalClient]);
  const formik$1 = formik.useFormik({
    initialValues: initialValues || mkEmptyFilterData(),
    validationSchema: mkDataFormSchema(),
    onSubmit: sendData,
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true
  });
  React.useEffect(() => {
    if (initialValues !== null && initialValues !== void 0 && initialValues.clientSelect) {
      fillContactList(initialValues.clientSelect);
    }
  }, [initialValues]);
  React.useEffect(() => {
    if (resetFilter) {
      formik$1.resetForm();
      resetFilterCallback();
    }
  }, [resetFilter, formik$1, resetFilterCallback]);
  const corporateGroupIds = React.useMemo(() => getValuesFromSelect(formik$1.values.corporateGroupSelect), [formik$1.values.corporateGroupSelect]);
  const isDisabledCountry = React.useMemo(() => isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowCountrySelection) || preSelected && !!filterPreSelected.countrySelect, [isFullyDisabled, disabled, preSelected, filterPreSelected]);
  const isDisabledCG = React.useMemo(() => isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowCorporateGroupSelection) || preSelected && !!filterPreSelected.corporateGroupSelect, [isFullyDisabled, disabled, preSelected, filterPreSelected]);
  const isDisabledClient = React.useMemo(() => isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowClientSelection) || preSelected && !!filterPreSelected.clientSelect, [isFullyDisabled, disabled, preSelected, filterPreSelected]);
  const isDisabledContact = React.useMemo(() => {
    var _formik$values$client;
    return isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowContact) || (isMultiClient ? formik$1.values.clientSelect.length === 0 : !((_formik$values$client = formik$1.values.clientSelect) !== null && _formik$values$client !== void 0 && _formik$values$client.value));
  }, [isFullyDisabled, disabled, isMultiClient, formik$1.values.clientSelect]);
  const isDisabledReference = React.useMemo(() => isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowReference), [isFullyDisabled, disabled]);
  const isDisabledFinalClient = React.useMemo(() => isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowFinalClient), [isFullyDisabled, disabled]);
  const isDisabledSubmit = React.useMemo(() => {
    var _formik$values$countr, _formik$values$countr2, _formik$values$corpor, _formik$values$corpor2, _formik$values$client2, _formik$values$client3, _formik$values$contac, _formik$values$refere, _formik$values$refere2;
    return isFullyDisabled || typeof disabled === 'object' && !(disabled !== null && disabled !== void 0 && disabled.allowSubmit) || isRequiredCountry && (isMultiCountry ? !((_formik$values$countr = formik$1.values.countrySelect) !== null && _formik$values$countr !== void 0 && _formik$values$countr.length) : !((_formik$values$countr2 = formik$1.values.countrySelect) !== null && _formik$values$countr2 !== void 0 && _formik$values$countr2.value)) || isRequiredCG && (isMultiCG ? !((_formik$values$corpor = formik$1.values.corporateGroupSelect) !== null && _formik$values$corpor !== void 0 && _formik$values$corpor.length) : !((_formik$values$corpor2 = formik$1.values.corporateGroupSelect) !== null && _formik$values$corpor2 !== void 0 && _formik$values$corpor2.value)) || isRequiredClient && (isMultiClient ? !((_formik$values$client2 = formik$1.values.clientSelect) !== null && _formik$values$client2 !== void 0 && _formik$values$client2.length) : !((_formik$values$client3 = formik$1.values.clientSelect) !== null && _formik$values$client3 !== void 0 && _formik$values$client3.value)) || isRequiredContact && !((_formik$values$contac = formik$1.values.contactSelect) !== null && _formik$values$contac !== void 0 && _formik$values$contac.value) || isRequiredReference && !((_formik$values$refere = formik$1.values.reference) !== null && _formik$values$refere !== void 0 && _formik$values$refere.trim()) || isRequiredFinalClient && !((_formik$values$refere2 = formik$1.values.reference) !== null && _formik$values$refere2 !== void 0 && _formik$values$refere2.trim());
  }, [isFullyDisabled, disabled, isRequiredCountry, isRequiredCG, isRequiredClient, isRequiredContact, isRequiredReference, isRequiredFinalClient, isMultiCountry, isMultiCG, isMultiClient, formik$1.values]);
  return isFullyHidden ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null) : /*#__PURE__*/React__default.createElement("form", {
    onSubmit: formik$1.handleSubmit,
    className: "d-flex flex-column justify-content-center p-0 m-0"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, !isHiddenCountry && /*#__PURE__*/React__default.createElement(CountrySelect, {
    ref: countrySelectRef,
    className: "col-12 col-sm-6 col-md-4 mb-5",
    requiredIcon: isRequiredCountry,
    onChange: onCountryChange,
    value: formik$1.values.countrySelect,
    error: formik$1.errors.countrySelect,
    isDisabled: isDisabledCountry,
    isMulti: isMultiCountry
  }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isHiddenCG && /*#__PURE__*/React__default.createElement(CorporateGroupSelect, {
    ref: groupSelectRef,
    className: "col-12 col-sm-6 col-md-4 mb-5",
    requiredIcon: isRequiredCG,
    withoutFetch: false,
    onChange: onCorporateGroupChange,
    value: formik$1.values.corporateGroupSelect,
    error: formik$1.errors.corporateGroupSelect,
    isDisabled: isDisabledCG,
    isMulti: isMultiCG
  }), !isHiddenClient && /*#__PURE__*/React__default.createElement(ClientSelect, {
    ref: clientSelectRef,
    requiredIcon: isRequiredClient,
    className: "col-12 col-sm-6 col-md-4 mb-5",
    value: formik$1.values.clientSelect,
    error: formik$1.errors.clientSelect,
    onChange: onClientChange,
    corporateGroupIds: corporateGroupIds,
    isDisabled: isDisabledClient,
    isMulti: isMultiClient
  }), !isHiddenContact && /*#__PURE__*/React__default.createElement(ContactSelect, {
    ref: contactSelectRef,
    requiredIcon: isRequiredContact,
    className: "col-12 col-sm-6 col-md-4 mb-5",
    value: formik$1.values.contactSelect,
    error: formik$1.errors.contactSelect,
    onChange: contact => {
      _onChange(formik$1, 'contactSelect')(contact);
      afterContactChange(contact);
    },
    isDisabled: isDisabledContact,
    isMulti: false
  }), !isHiddenReference && /*#__PURE__*/React__default.createElement(UfinetInput, {
    className: "col-12 col-sm-6 col-md-4 mb-5",
    requiredIcon: isRequiredReference,
    value: (_formik$values$refere3 = formik$1.values.reference) != null ? _formik$values$refere3 : '',
    error: formik$1.errors.reference,
    type: "text",
    solid: false,
    placeholder: translate('SERVICE.REFERENCE.INPUT.PLACEHOLDER'),
    labelTitle: translate('SERVICE.REFERENCE.INPUT.TITLE'),
    tooltipTitle: translate('SERVICE.REFERENCE.INPUT.TOOLTIP'),
    onChange: e => {
      onTextChange(formik$1, 'reference', '')(e);
      afterReferenceChange(e.target.value);
    },
    onBlur: () => ufinetWebFunctions.onFormikTrimField(formik$1, 'reference', ''),
    isDisabled: isDisabledReference
  }), !isHiddenFinalClient && /*#__PURE__*/React__default.createElement(UfinetInput, {
    className: "col-12 col-sm-6 col-md-4 mb-5",
    requiredIcon: isRequiredFinalClient,
    value: (_formik$values$finalC = formik$1.values.finalClient) != null ? _formik$values$finalC : '',
    error: formik$1.errors.finalClient,
    type: "text",
    solid: false,
    placeholder: translate('SERVICE.FINAL_CLIENT.INPUT.PLACEHOLDER'),
    labelTitle: translate('SERVICE.FINAL_CLIENT.INPUT.TITLE'),
    tooltipTitle: translate('SERVICE.FINAL_CLIENT.INPUT.TOOLTIP'),
    onChange: e => {
      onTextChange(formik$1, 'finalClient', '')(e);
      afterFinalClientChange(e.target.value);
    },
    onBlur: () => ufinetWebFunctions.onFormikTrimField(formik$1, 'finalClient', ''),
    isDisabled: isDisabledFinalClient
  }))), !isHiddenSubmit && /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionButtonRef,
    className: "ms-3 p-5 w-auto",
    content: submitButtonContent || translate('NEW.ENTRY'),
    icon: icon || freeSolidSvgIcons.faPlus,
    isDisabled: isDisabledSubmit
  })));
});

var startsWith = "Starts with";
var contains = "Contains";
var notContains = "Not contains";
var endsWith = "Ends with";
var equals = "Equals";
var notEquals = "Not equals";
var noFilter = "No Filter";
var filter = "Filter";
var lt = "Less than";
var lte = "Less than or equal to";
var gt = "Greater than";
var gte = "Greater than or equal to";
var dateIs = "Date is";
var dateIsNot = "Date is not";
var dateBefore = "Date is before";
var dateAfter = "Date is after";
var custom = "Custom";
var clear$1 = "Clear";
var apply$1 = "Apply";
var matchAll = "Match All";
var matchAny = "Match Any";
var addRule = "Add Rule";
var removeRule = "Remove Rule";
var accept = "Yes";
var reject = "No";
var choose = "Choose";
var upload = "Upload";
var cancel = "Cancel";
var completed = "Completed";
var pending = "Pending";
var fileSizeTypes = [
	"B",
	"KB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
];
var dayNames = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday"
];
var dayNamesShort = [
	"Sun",
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat"
];
var dayNamesMin = [
	"Su",
	"Mo",
	"Tu",
	"We",
	"Th",
	"Fr",
	"Sa"
];
var monthNames = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
var monthNamesShort = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
var chooseYear = "Choose Year";
var chooseMonth = "Choose Month";
var chooseDate = "Choose Date";
var prevDecade = "Previous Decade";
var nextDecade = "Next Decade";
var prevYear = "Previous Year";
var nextYear = "Next Year";
var prevMonth = "Previous Month";
var nextMonth = "Next Month";
var prevHour = "Previous Hour";
var nextHour = "Next Hour";
var prevMinute = "Previous Minute";
var nextMinute = "Next Minute";
var prevSecond = "Previous Second";
var nextSecond = "Next Second";
var am = "AM";
var pm = "PM";
var today = "Today";
var now = "Now";
var weekHeader = "Wk";
var firstDayOfWeek = 0;
var showMonthAfterYear = false;
var dateFormat = "mm/dd/yy";
var weak = "Weak";
var medium = "Medium";
var strong = "Strong";
var passwordPrompt = "Enter a password";
var emptyFilterMessage = "No results found";
var searchMessage = "{0} results are available";
var selectionMessage = "{0} items selected";
var emptySelectionMessage = "No selected item";
var emptySearchMessage = "No results found";
var emptyMessage = "No available options";
var aria = {
	trueLabel: "True",
	falseLabel: "False",
	nullLabel: "Not Selected",
	star: "1 star",
	stars: "{star} stars",
	selectAll: "All items selected",
	unselectAll: "All items unselected",
	close: "Close",
	previous: "Previous",
	next: "Next",
	navigation: "Navigation",
	scrollTop: "Scroll Top",
	moveTop: "Move Top",
	moveUp: "Move Up",
	moveDown: "Move Down",
	moveBottom: "Move Bottom",
	moveToTarget: "Move to Target",
	moveToSource: "Move to Source",
	moveAllToTarget: "Move All to Target",
	moveAllToSource: "Move All to Source",
	pageLabel: "Page {page}",
	firstPageLabel: "First Page",
	lastPageLabel: "Last Page",
	nextPageLabel: "Next Page",
	previousPageLabel: "Previous Page",
	rowsPerPageLabel: "Rows per page",
	jumpToPageDropdownLabel: "Jump to Page Dropdown",
	jumpToPageInputLabel: "Jump to Page Input",
	selectRow: "Row Selected",
	unselectRow: "Row Unselected",
	expandRow: "Row Expanded",
	collapseRow: "Row Collapsed",
	showFilterMenu: "Show Filter Menu",
	hideFilterMenu: "Hide Filter Menu",
	filterOperator: "Filter Operator",
	filterConstraint: "Filter Constraint",
	editRow: "Edit Row",
	saveEdit: "Save Edit",
	cancelEdit: "Cancel Edit",
	listView: "List View",
	gridView: "Grid View",
	slide: "Slide",
	slideNumber: "{slideNumber}",
	zoomImage: "Zoom Image",
	zoomIn: "Zoom In",
	zoomOut: "Zoom Out",
	rotateRight: "Rotate Right",
	rotateLeft: "Rotate Left"
};
var primeReactEnMessages = {
	startsWith: startsWith,
	contains: contains,
	notContains: notContains,
	endsWith: endsWith,
	equals: equals,
	notEquals: notEquals,
	noFilter: noFilter,
	filter: filter,
	lt: lt,
	lte: lte,
	gt: gt,
	gte: gte,
	dateIs: dateIs,
	dateIsNot: dateIsNot,
	dateBefore: dateBefore,
	dateAfter: dateAfter,
	custom: custom,
	clear: clear$1,
	apply: apply$1,
	matchAll: matchAll,
	matchAny: matchAny,
	addRule: addRule,
	removeRule: removeRule,
	accept: accept,
	reject: reject,
	choose: choose,
	upload: upload,
	cancel: cancel,
	completed: completed,
	pending: pending,
	fileSizeTypes: fileSizeTypes,
	dayNames: dayNames,
	dayNamesShort: dayNamesShort,
	dayNamesMin: dayNamesMin,
	monthNames: monthNames,
	monthNamesShort: monthNamesShort,
	chooseYear: chooseYear,
	chooseMonth: chooseMonth,
	chooseDate: chooseDate,
	prevDecade: prevDecade,
	nextDecade: nextDecade,
	prevYear: prevYear,
	nextYear: nextYear,
	prevMonth: prevMonth,
	nextMonth: nextMonth,
	prevHour: prevHour,
	nextHour: nextHour,
	prevMinute: prevMinute,
	nextMinute: nextMinute,
	prevSecond: prevSecond,
	nextSecond: nextSecond,
	am: am,
	pm: pm,
	today: today,
	now: now,
	weekHeader: weekHeader,
	firstDayOfWeek: firstDayOfWeek,
	showMonthAfterYear: showMonthAfterYear,
	dateFormat: dateFormat,
	weak: weak,
	medium: medium,
	strong: strong,
	passwordPrompt: passwordPrompt,
	emptyFilterMessage: emptyFilterMessage,
	searchMessage: searchMessage,
	selectionMessage: selectionMessage,
	emptySelectionMessage: emptySelectionMessage,
	emptySearchMessage: emptySearchMessage,
	emptyMessage: emptyMessage,
	aria: aria
};

var startsWith$1 = "Comience con";
var contains$1 = "Contenga";
var notContains$1 = "No contenga";
var endsWith$1 = "Termine con";
var equals$1 = "Igual a";
var notEquals$1 = "Diferente a";
var noFilter$1 = "Sin filtro";
var filter$1 = "Filtro";
var lt$1 = "Menor que";
var lte$1 = "Menor o igual a";
var gt$1 = "Mayor que";
var gte$1 = "Mayor o igual a";
var dateIs$1 = "Fecha igual a";
var dateIsNot$1 = "Fecha diferente a";
var dateBefore$1 = "Fecha antes de";
var dateAfter$1 = "Fecha después de";
var custom$1 = "Personalizar";
var clear$2 = "Limpiar";
var apply$2 = "Aplicar";
var matchAll$1 = "Coincidir todo";
var matchAny$1 = "Coincidir con cualquiera";
var addRule$1 = "Agregar regla";
var removeRule$1 = "Eliminar regla";
var accept$1 = "Sí";
var reject$1 = "No";
var choose$1 = "Escoger";
var upload$1 = "Subir";
var cancel$1 = "Cancelar";
var fileSizeTypes$1 = [
	"B",
	"KB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
];
var dayNames$1 = [
	"Domingo",
	"Lunes",
	"Martes",
	"Miércoles",
	"Jueves",
	"Viernes",
	"Sábado"
];
var dayNamesShort$1 = [
	"Dom",
	"Lun",
	"Mar",
	"Mié",
	"Jue",
	"Vie",
	"Sáb"
];
var dayNamesMin$1 = [
	"D",
	"L",
	"M",
	"M",
	"J",
	"V",
	"S"
];
var monthNames$1 = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre"
];
var monthNamesShort$1 = [
	"Ene",
	"Feb",
	"Mar",
	"Abr",
	"May",
	"Jun",
	"Jul",
	"Ago",
	"Sep",
	"Oct",
	"Nov",
	"Dic"
];
var today$1 = "Hoy";
var now$1 = "Ahora";
var weekHeader$1 = "Sem";
var firstDayOfWeek$1 = 1;
var showMonthAfterYear$1 = false;
var dateFormat$1 = "dd/mm/yy";
var weak$1 = "Débil";
var medium$1 = "Medio";
var strong$1 = "Fuerte";
var passwordPrompt$1 = "Escriba una contraseña";
var emptyFilterMessage$1 = "Sin opciones disponibles";
var emptySearchMessage$1 = "Sin opciones disponibles";
var emptyMessage$1 = "No se han encontrado resultados";
var aria$1 = {
	trueLabel: "Verdadero",
	falseLabel: "Falso",
	nullLabel: "No seleccionado",
	star: "1 estrella",
	stars: "{star} estrellas",
	selectAll: "Seleccionar todos",
	unselectAll: "Deseleccionar todos",
	close: "Cerrar",
	previous: "Anterior",
	next: "Siguiente",
	navigation: "Navegación",
	scrollTop: "Desplazarse hacia arriba",
	moveTop: "Mover arriba",
	moveUp: "Subir",
	moveDown: "Bajar",
	moveBottom: "Desplazarse hacia abajo",
	moveToTarget: "Mover al objetivo",
	moveToSource: "Mover al origen",
	moveAllToTarget: "Mover todo al objetivo",
	moveAllToSource: "Mover todo al origen",
	pageLabel: "Página {page}",
	firstPageLabel: "Primera Página",
	lastPageLabel: "Última Página",
	nextPageLabel: "Siguiente Página",
	previousPageLabel: "Página Anterior",
	rowsPerPageLabel: "Filas por página",
	jumpToPageDropdownLabel: "Ir al menú desplegable de página",
	jumpToPageInputLabel: "Ir a la entrada de página",
	selectRow: "Seleccionar fila",
	unselectRow: "Desmarcar fila",
	expandRow: "Expandir Fila",
	collapseRow: "Reducir Fila",
	showFilterMenu: "Mostrar menú del filtro",
	hideFilterMenu: "Ocultar menú del filtro",
	filterOperator: "Operador de filtro",
	filterConstraint: "Restricción de filtro",
	editRow: "Editar fila",
	saveEdit: "Guardar editado",
	cancelEdit: "Cancelar editado",
	listView: "Vista de lista",
	gridView: "Vista de cuadrícula",
	slide: "Deslizar",
	slideNumber: "{slideNumber}",
	zoomImage: "Ampliar imagen",
	zoomIn: "Ampliar",
	zoomOut: "Reducir",
	rotateRight: "Girar a la derecha",
	rotateLeft: "Girar a la izquierda"
};
var primeReactEsMessages = {
	startsWith: startsWith$1,
	contains: contains$1,
	notContains: notContains$1,
	endsWith: endsWith$1,
	equals: equals$1,
	notEquals: notEquals$1,
	noFilter: noFilter$1,
	filter: filter$1,
	lt: lt$1,
	lte: lte$1,
	gt: gt$1,
	gte: gte$1,
	dateIs: dateIs$1,
	dateIsNot: dateIsNot$1,
	dateBefore: dateBefore$1,
	dateAfter: dateAfter$1,
	custom: custom$1,
	clear: clear$2,
	apply: apply$2,
	matchAll: matchAll$1,
	matchAny: matchAny$1,
	addRule: addRule$1,
	removeRule: removeRule$1,
	accept: accept$1,
	reject: reject$1,
	choose: choose$1,
	upload: upload$1,
	cancel: cancel$1,
	fileSizeTypes: fileSizeTypes$1,
	dayNames: dayNames$1,
	dayNamesShort: dayNamesShort$1,
	dayNamesMin: dayNamesMin$1,
	monthNames: monthNames$1,
	monthNamesShort: monthNamesShort$1,
	today: today$1,
	now: now$1,
	weekHeader: weekHeader$1,
	firstDayOfWeek: firstDayOfWeek$1,
	showMonthAfterYear: showMonthAfterYear$1,
	dateFormat: dateFormat$1,
	weak: weak$1,
	medium: medium$1,
	strong: strong$1,
	passwordPrompt: passwordPrompt$1,
	emptyFilterMessage: emptyFilterMessage$1,
	emptySearchMessage: emptySearchMessage$1,
	emptyMessage: emptyMessage$1,
	aria: aria$1
};

var startsWith$2 = "Começa com";
var contains$2 = "Contém";
var notContains$2 = "Não contém";
var endsWith$2 = "Termina com";
var equals$2 = "Igual";
var notEquals$2 = "Diferente";
var noFilter$2 = "Sem filtro";
var filter$2 = "Filtro";
var lt$2 = "Menor que";
var lte$2 = "Menor que ou igual a";
var gt$2 = "Maior que";
var gte$2 = "Maior que ou igual a";
var dateIs$2 = "Data é";
var dateIsNot$2 = "Data não é";
var dateBefore$2 = "Date é anterior";
var dateAfter$2 = "Data é posterior";
var custom$2 = "Customizado";
var clear$3 = "Limpar";
var close = "Fechar";
var apply$3 = "Aplicar";
var matchAll$2 = "Match All";
var matchAny$2 = "Match Any";
var addRule$2 = "Adicionar Regra";
var removeRule$2 = "Remover Regra";
var accept$2 = "Sim";
var reject$2 = "Não";
var choose$2 = "Escolha";
var upload$2 = "Upload";
var cancel$2 = "Cancelar";
var completed$1 = "Concluído";
var pending$1 = "Pendente";
var fileSizeTypes$2 = [
	"B",
	"KB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
];
var dayNames$2 = [
	"Domingo",
	"Segunda",
	"Terça",
	"Quarta",
	"Quinta",
	"Sexta",
	"Sábado"
];
var dayNamesShort$2 = [
	"Dom",
	"Seg",
	"Ter",
	"Qua",
	"Qui",
	"Sex",
	"Sáb"
];
var dayNamesMin$2 = [
	"Do",
	"Se",
	"Te",
	"Qa",
	"Qi",
	"Sx",
	"Sa"
];
var monthNames$2 = [
	"Janeiro",
	"Fevereiro",
	"Março",
	"Abril",
	"Maio",
	"Junho",
	"Julho",
	"Agosto",
	"Setembro",
	"Outubro",
	"Novembro",
	"Dezembro"
];
var monthNamesShort$2 = [
	"Jan",
	"Fev",
	"Mar",
	"Abr",
	"Mai",
	"Jun",
	"Jul",
	"Ago",
	"Set",
	"Out",
	"Nov",
	"Dez"
];
var chooseYear$1 = "Escolha Ano";
var chooseMonth$1 = "Escolha Mês";
var chooseDate$1 = "Escolha Data";
var prevDecade$1 = "Década Anterior";
var nextDecade$1 = "Década Seguinte";
var prevYear$1 = "Ano Anterior";
var nextYear$1 = "Ano Seguinte";
var prevMonth$1 = "Mês Anterior";
var nextMonth$1 = "Mês Seguinte";
var prevHour$1 = "Hora Anterior";
var nextHour$1 = "Hora Seguinte";
var prevMinute$1 = "Minuto Anterior";
var nextMinute$1 = "Minuto Seguinte";
var prevSecond$1 = "Segundo Anterior";
var nextSecond$1 = "Segundo Seguinte";
var am$1 = "am";
var pm$1 = "pm";
var today$2 = "Hoje";
var now$2 = "Agora";
var weekHeader$2 = "Sem";
var firstDayOfWeek$2 = 0;
var showMonthAfterYear$2 = false;
var dateFormat$2 = "dd/mm/yy";
var weak$2 = "Fraco";
var medium$2 = "Médio";
var strong$2 = "Forte";
var passwordPrompt$2 = "Digite uma senha";
var emptyFilterMessage$2 = "Nenhum resultado encontrado";
var searchMessage$1 = "{0} resultados disponíveis";
var selectionMessage$1 = "{0} itens selecionados";
var emptySelectionMessage$1 = "Nenhum item selecionado";
var emptySearchMessage$2 = "Nenhum resultado encontrado";
var emptyMessage$2 = "Nenhuma opção disponível";
var aria$2 = {
	trueLabel: "Verdadeiro",
	falseLabel: "Falso",
	nullLabel: "Não selecionado",
	star: "1 estrela",
	stars: "{star} estrelas",
	selectAll: "Todos itens selecionados",
	unselectAll: "Nenhum item selecionado",
	close: "Fechar",
	previous: "Anterior",
	next: "Seguinte",
	navigation: "Navegação",
	scrollTop: "Rolar para Topo",
	moveTop: "Mover para Topo",
	moveUp: "Mover para Cima",
	moveDown: "Mover para Baixo",
	moveBottom: "Mover para Final",
	moveToTarget: "Mover para Alvo",
	moveToSource: "Mover para Fonte",
	moveAllToTarget: "Mover Todos para Alvo",
	moveAllToSource: "Mover Todos para Fonte",
	pageLabel: "Página {page}",
	firstPageLabel: "Primeira Página",
	lastPageLabel: "Última Página",
	nextPageLabel: "Página Seguinte",
	previousPageLabel: "Página Anterior",
	rowsPerPageLabel: "Linhas por página",
	jumpToPageDropdownLabel: "Pular para Menu da Página",
	jumpToPageInputLabel: "Pular para Campo da Página",
	selectRow: "Linha Selecionada",
	unselectRow: "Linha Não Selecionada",
	expandRow: "Linha Expandida",
	collapseRow: "Linha Recolhida",
	showFilterMenu: "Mostrar Menu de Filtro",
	hideFilterMenu: "Esconder Menu de Filtro",
	filterOperator: "Operador de Filtro",
	filterConstraint: "Restrição de Filtro",
	editRow: "Editar Linha",
	saveEdit: "Salvar Editar",
	cancelEdit: "Cancelar Editar",
	listView: "Exibição em Lista",
	gridView: "Exibição em Grade",
	slide: "Deslizar",
	slideNumber: "{slideNumber}",
	zoomImage: "Ampliar Imagem",
	zoomIn: "Mais Zoom",
	zoomOut: "Menos Zoom",
	rotateRight: "Girar à Direita",
	rotateLeft: "Girar à Esquerda"
};
var primeReactPtMessages = {
	startsWith: startsWith$2,
	contains: contains$2,
	notContains: notContains$2,
	endsWith: endsWith$2,
	equals: equals$2,
	notEquals: notEquals$2,
	noFilter: noFilter$2,
	filter: filter$2,
	lt: lt$2,
	lte: lte$2,
	gt: gt$2,
	gte: gte$2,
	dateIs: dateIs$2,
	dateIsNot: dateIsNot$2,
	dateBefore: dateBefore$2,
	dateAfter: dateAfter$2,
	custom: custom$2,
	clear: clear$3,
	close: close,
	apply: apply$3,
	matchAll: matchAll$2,
	matchAny: matchAny$2,
	addRule: addRule$2,
	removeRule: removeRule$2,
	accept: accept$2,
	reject: reject$2,
	choose: choose$2,
	upload: upload$2,
	cancel: cancel$2,
	completed: completed$1,
	pending: pending$1,
	fileSizeTypes: fileSizeTypes$2,
	dayNames: dayNames$2,
	dayNamesShort: dayNamesShort$2,
	dayNamesMin: dayNamesMin$2,
	monthNames: monthNames$2,
	monthNamesShort: monthNamesShort$2,
	chooseYear: chooseYear$1,
	chooseMonth: chooseMonth$1,
	chooseDate: chooseDate$1,
	prevDecade: prevDecade$1,
	nextDecade: nextDecade$1,
	prevYear: prevYear$1,
	nextYear: nextYear$1,
	prevMonth: prevMonth$1,
	nextMonth: nextMonth$1,
	prevHour: prevHour$1,
	nextHour: nextHour$1,
	prevMinute: prevMinute$1,
	nextMinute: nextMinute$1,
	prevSecond: prevSecond$1,
	nextSecond: nextSecond$1,
	am: am$1,
	pm: pm$1,
	today: today$2,
	now: now$2,
	weekHeader: weekHeader$2,
	firstDayOfWeek: firstDayOfWeek$2,
	showMonthAfterYear: showMonthAfterYear$2,
	dateFormat: dateFormat$2,
	weak: weak$2,
	medium: medium$2,
	strong: strong$2,
	passwordPrompt: passwordPrompt$2,
	emptyFilterMessage: emptyFilterMessage$2,
	searchMessage: searchMessage$1,
	selectionMessage: selectionMessage$1,
	emptySelectionMessage: emptySelectionMessage$1,
	emptySearchMessage: emptySearchMessage$2,
	emptyMessage: emptyMessage$2,
	aria: aria$2
};

var ACCEPT = "Accept";
var AND = "and";
var BY_DEFAULT = "By default";
var CANCEL = "Cancel";
var CLEAR = "Clear";
var COPY = "Copy";
var CORPORATE_GROUP = "Corporate group";
var DAY = "Day";
var DAYS = "Days";
var DELETE_ALL = "Delete selected items";
var ENGLISH = "English";
var INTRODUCE_OPTION = "Type an option";
var ITEM = "Item";
var LANGUAGE = "Language";
var LOADING = "Loading";
var LOADING_DOTS = "Loading...";
var MONTH = "Month";
var MONTHS = "Months";
var NEW = "New";
var NO = "No";
var NO_OPTIONS = "No options";
var OK = "OK";
var OR = "or";
var PATH_DETAIL = "Detail";
var PATH_HOME = "Home";
var PORTUGUESE = "Portuguese";
var RESET = "Reset";
var RESTART = "Restart";
var SAVE = "Save";
var SEARCH = "Search";
var SELECT_ALL$1 = "Select all";
var SPANISH = "Spanish";
var UNKNOWN = "Unknown";
var UPDATE = "Update";
var VALUE = "Value";
var WELCOME = "Welcome to {appName}";
var YES = "Yes";
var commonEnMessages = {
	ACCEPT: ACCEPT,
	"ADD.CLOSE": "Submit and close",
	"ADD.CONTINUE": "Submit and continue",
	AND: AND,
	"AUTH.LOGGING_IN": "Logging in...",
	"AUTH.LOGIN": "Sign in",
	"AUTH.LOGIN.DOWN": "The authentication service could not be reached",
	"AUTH.LOGOUT": "Log out",
	"AUTH.MAIL": "Email",
	"AUTH.SESSION.EXPIRED": "Session has expired",
	BY_DEFAULT: BY_DEFAULT,
	CANCEL: CANCEL,
	CLEAR: CLEAR,
	"COL.ACT_AT": "Updated at",
	"COL.ACT_BY": "Updated by",
	"CONTACT.US": "Contact Us",
	"COOKIES.POLICY": "Cookies Policy",
	COPY: COPY,
	CORPORATE_GROUP: CORPORATE_GROUP,
	"COUNTRY.DESTINATION": "Destionation country",
	"COUNTRY.ORIGIN": "Origin country",
	DAY: DAY,
	DAYS: DAYS,
	"DELETE.OPERATION": "Delete operation",
	"DELETE.OPERATION.WARNING": "The selected elementes will be permanently removed. This is irreversible. Continue?",
	DELETE_ALL: DELETE_ALL,
	"DEVELOPED.BY": "Developed by",
	"EMPTY.MESSAGE": "No data",
	ENGLISH: ENGLISH,
	"ERROR.INVALID": "Invalid value",
	"ERROR.INVALID.MAXIMUM": "Invalid value",
	"ERROR.INVALID.MINIMUM": "Invalid value",
	"ERROR.MAIL.INVALID": "Invalid email address",
	"ERROR.MUST_BE_GREATER": "Must be greater than {value}",
	"ERROR.MUST_BE_LOWER": "Must be lower than {value}",
	"ERROR.MUST_CONTAIN_N_ITEMS": "Must contain at least {value} element(s)",
	"ERROR.NOT_EMPTY": "Must be empty",
	"ERROR.REQUIRED": "Required",
	"FILTERS.LABEL": "Clear filters",
	"GENERIC.REGISTRY.CREATE.SUCCESS": "Created the registry {target}",
	"GENERIC.REGISTRY.UPDATE.SUCCESS": "Updated the registry {target}",
	INTRODUCE_OPTION: INTRODUCE_OPTION,
	ITEM: ITEM,
	LANGUAGE: LANGUAGE,
	LOADING: LOADING,
	LOADING_DOTS: LOADING_DOTS,
	"MENU.HOME": "Home",
	"MODAL.NEW.REGISTER.TITLE": "Create new register",
	MONTH: MONTH,
	MONTHS: MONTHS,
	NEW: NEW,
	"NEW.ENTRY": "New entry",
	"NEW.PLACEHOLDER": "New entry...",
	"NEW.REGISTER": "New",
	NO: NO,
	NO_OPTIONS: NO_OPTIONS,
	"OFFER.CURRENCY": "Offer currency",
	OK: OK,
	OR: OR,
	"PAGINATOR.REPORT": "Displaying from '{first}' to '{last}' out of '{totalRecords}'",
	PATH_DETAIL: PATH_DETAIL,
	PATH_HOME: PATH_HOME,
	PORTUGUESE: PORTUGUESE,
	"PRIVACY.POLICY": "Privacy Policy",
	"PRODUCT.TYPE": "Product type",
	"QUICK_LINKS.AQS.DESCRIPTION": "Quoter",
	"QUICK_LINKS.COMM.DESCRIPTION": "Commisions",
	"QUICK_LINKS.FACT.DESCRIPTION": "Billing",
	"QUICK_LINKS.FTTH.DESCRIPTION": "FTTH Network",
	"QUICK_LINKS.GDS.DESCRIPTION": "Services",
	"QUICK_LINKS.GFA.DESCRIPTION": "Invoices",
	"QUICK_LINKS.GTI.DESCRIPTION": "Tickets",
	"QUICK_LINKS.OFE.DESCRIPTION": "Offers",
	"QUICK_LINKS.PORTAL.DESCRIPTION": "User",
	"QUICK_LINKS.QR.DESCRIPTION": "QR Inventory",
	"QUICK_LINKS.WEB.DESCRIPTION": "Corporate website",
	RESET: RESET,
	RESTART: RESTART,
	SAVE: SAVE,
	SEARCH: SEARCH,
	"SEARCH.PLACEHOLDER": "Search...",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS": "Successfully deleted from {section}",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS.WITH_ID": "Successfully deleted from {section} with ID {id}",
	"SECTION.DELETE.MASSIVE.FAILURE": "An error occurred in the deletion of {section}",
	"SECTION.DELETE.MASSIVE.SUCCESS": "Successful multiple deletion of {section}",
	"SELECT.CLIENT.TITLE": "Client",
	"SELECT.CLIENT.TOOLTIP": "Select a client from the list",
	"SELECT.CONTACT.NONE": "No contact",
	"SELECT.CONTACT.TITLE": "Contact",
	"SELECT.CONTACT.TOOLTIP": "Select a contact from the list",
	"SELECT.COUNTRY.TITLE": "Country",
	"SELECT.COUNTRY.TOOLTIP": "Select a country from the list",
	"SELECT.GROUP.PLACEHOLDER": "Group",
	"SELECT.GROUP.TITLE": "Corporate group",
	"SELECT.GROUP.TOOLTIP": "Select a corporate group from the list",
	SELECT_ALL: SELECT_ALL$1,
	"SERVICE.FINAL_CLIENT.INPUT.PLACEHOLDER": "Final client...",
	"SERVICE.FINAL_CLIENT.INPUT.TITLE": "Final client",
	"SERVICE.FINAL_CLIENT.INPUT.TOOLTIP": "Enter the name of the end client if applicable",
	"SERVICE.REFERENCE.INPUT.PLACEHOLDER": "Reference message...",
	"SERVICE.REFERENCE.INPUT.TITLE": "Reference",
	"SERVICE.REFERENCE.INPUT.TOOLTIP": "Reference message attached to the quotation",
	SPANISH: SPANISH,
	"STEP.BUTTON.BACK": "Back",
	"STEP.BUTTON.CLOSE": "Exit",
	"STEP.BUTTON.CONFIRM": "Confirm",
	"STEP.BUTTON.CONTINUE": "Continue",
	"STEP.BUTTON.SUBMIT": "Submit",
	"STEP.BUTTON.WAIT": "Please wait...",
	"UNAUTHORIZED.ROUTE.ACCESS": "Access to forbidden route",
	UNKNOWN: UNKNOWN,
	UPDATE: UPDATE,
	"USER.EXTERNAL.NAME": "External",
	"USER.INTERNAL.NAME": "Internal",
	"USER.UNKNOWN.NAME": "Unknown",
	VALUE: VALUE,
	WELCOME: WELCOME,
	YES: YES
};

var ACCEPT$1 = "Aceptar";
var AND$1 = "y";
var BY_DEFAULT$1 = "Por defecto";
var CANCEL$1 = "Cancelar";
var CLEAR$1 = "Limpiar";
var COPY$1 = "Copiar";
var CORPORATE_GROUP$1 = "Grupo corporativo";
var DAY$1 = "Día";
var DAYS$1 = "Días";
var DELETE_ALL$1 = "Borrar items seleccionados";
var ENGLISH$1 = "Inglés";
var INTRODUCE_OPTION$1 = "Introduza una opción";
var ITEM$1 = "Ítem";
var LANGUAGE$1 = "Idioma";
var LOADING$1 = "Cargando";
var LOADING_DOTS$1 = "Cargando...";
var MONTH$1 = "Mes";
var MONTHS$1 = "Meses";
var NEW$1 = "Nuevo";
var NO$1 = "No";
var NO_OPTIONS$1 = "Sin opciones";
var OK$1 = "OK";
var OR$1 = "o";
var PATH_DETAIL$1 = "Detalle";
var PATH_HOME$1 = "Inicio";
var PORTUGUESE$1 = "Portugués";
var RESET$1 = "Resetear";
var RESTART$1 = "Reiniciar";
var SAVE$1 = "Guardar";
var SEARCH$1 = "Buscar";
var SELECT_ALL$2 = "Seleccionar todos";
var SPANISH$1 = "Español";
var UNKNOWN$1 = "Desconocido";
var UPDATE$1 = "Actualizar";
var VALUE$1 = "Valor";
var WELCOME$1 = "Bienvenid@ a {appName}";
var YES$1 = "Sí";
var commonEsMessages = {
	ACCEPT: ACCEPT$1,
	"ADD.CLOSE": "Añadir y cerrar",
	"ADD.CONTINUE": "Añadir y continuar",
	AND: AND$1,
	"AUTH.LOGGING_IN": "Iniciando sesión...",
	"AUTH.LOGIN": "Iniciar sesión",
	"AUTH.LOGIN.DOWN": "No se ha podido contactar con el servicio de autenticación",
	"AUTH.LOGOUT": "Salir",
	"AUTH.MAIL": "Correo electrónico",
	"AUTH.SESSION.EXPIRED": "La sesión ha expirado",
	BY_DEFAULT: BY_DEFAULT$1,
	CANCEL: CANCEL$1,
	CLEAR: CLEAR$1,
	"COL.ACT_AT": "Actualizado a",
	"COL.ACT_BY": "Actualizado por",
	"CONTACT.US": "Contáctanos",
	"COOKIES.POLICY": "Política de Cookies",
	COPY: COPY$1,
	CORPORATE_GROUP: CORPORATE_GROUP$1,
	"COUNTRY.DESTINATION": "País de destino",
	"COUNTRY.ORIGIN": "País de origen",
	DAY: DAY$1,
	DAYS: DAYS$1,
	"DELETE.OPERATION": "Operación de borrado",
	"DELETE.OPERATION.WARNING": "Los elementos seleccionados van a ser eliminados. Operación irreversible. ¿Está seguro?",
	DELETE_ALL: DELETE_ALL$1,
	"DEVELOPED.BY": "Desarrollado por",
	"EMPTY.MESSAGE": "Sin datos",
	ENGLISH: ENGLISH$1,
	"ERROR.INVALID": "Valor no válido",
	"ERROR.INVALID.MAXIMUM": "Valor no válido",
	"ERROR.INVALID.MINIMUM": "Valor no válido",
	"ERROR.MAIL.INVALID": "Correo inválido",
	"ERROR.MUST_BE_GREATER": "Debe ser mayor que {value}",
	"ERROR.MUST_BE_LOWER": "Debe ser menor que {value}",
	"ERROR.MUST_CONTAIN_N_ITEMS": "Debe contener al menos {value} valor(es)",
	"ERROR.NOT_EMPTY": "Debe estar vacío",
	"ERROR.REQUIRED": "Requerido",
	"FILTERS.LABEL": "Limpiar filtros",
	"GENERIC.REGISTRY.CREATE.SUCCESS": "Creado el registro {target}",
	"GENERIC.REGISTRY.UPDATE.SUCCESS": "Actualizado el registro {target}",
	INTRODUCE_OPTION: INTRODUCE_OPTION$1,
	ITEM: ITEM$1,
	LANGUAGE: LANGUAGE$1,
	LOADING: LOADING$1,
	LOADING_DOTS: LOADING_DOTS$1,
	"MENU.HOME": "Inicio",
	"MODAL.NEW.REGISTER.TITLE": "Crear nuevo registro",
	MONTH: MONTH$1,
	MONTHS: MONTHS$1,
	NEW: NEW$1,
	"NEW.ENTRY": "Nuevo registro",
	"NEW.PLACEHOLDER": "Nuevo registro...",
	"NEW.REGISTER": "Nuevo",
	NO: NO$1,
	NO_OPTIONS: NO_OPTIONS$1,
	"OFFER.CURRENCY": "Divisa de la oferta",
	OK: OK$1,
	OR: OR$1,
	"PAGINATOR.REPORT": "Mostrando '{first}' a '{last}' de '{totalRecords}'",
	PATH_DETAIL: PATH_DETAIL$1,
	PATH_HOME: PATH_HOME$1,
	PORTUGUESE: PORTUGUESE$1,
	"PRIVACY.POLICY": "Política de Privacidad",
	"PRODUCT.TYPE": "Tipo de producto",
	"QUICK_LINKS.AQS.DESCRIPTION": "Cotizador",
	"QUICK_LINKS.COMM.DESCRIPTION": "Comisiones",
	"QUICK_LINKS.FACT.DESCRIPTION": "Facturación",
	"QUICK_LINKS.FTTH.DESCRIPTION": "FTTH Network",
	"QUICK_LINKS.GDS.DESCRIPTION": "Servicios",
	"QUICK_LINKS.GFA.DESCRIPTION": "Facturas",
	"QUICK_LINKS.GTI.DESCRIPTION": "Tickets",
	"QUICK_LINKS.OFE.DESCRIPTION": "Ofertas",
	"QUICK_LINKS.PORTAL.DESCRIPTION": "Usuario",
	"QUICK_LINKS.QR.DESCRIPTION": "Inventario QR",
	"QUICK_LINKS.WEB.DESCRIPTION": "Web corporativa",
	RESET: RESET$1,
	RESTART: RESTART$1,
	SAVE: SAVE$1,
	SEARCH: SEARCH$1,
	"SEARCH.PLACEHOLDER": "Buscar...",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS": "Se ha realizado con éxito la eliminación de {section}",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS.WITH_ID": "Se ha realizado con éxito la eliminación de {section} con ID {id}",
	"SECTION.DELETE.MASSIVE.FAILURE": "Ha ocurrido un error en la eliminación masiva de {section}",
	"SECTION.DELETE.MASSIVE.SUCCESS": "Se ha realizado con éxito la eliminación masiva de {section}",
	"SELECT.CLIENT.TITLE": "Cliente",
	"SELECT.CLIENT.TOOLTIP": "Seleccione un cliente de la lista",
	"SELECT.CONTACT.NONE": "Sin contacto",
	"SELECT.CONTACT.TITLE": "Contacto",
	"SELECT.CONTACT.TOOLTIP": "Seleccione contacto de la lista",
	"SELECT.COUNTRY.TITLE": "País",
	"SELECT.COUNTRY.TOOLTIP": "Seleccione un país de la lista",
	"SELECT.GROUP.PLACEHOLDER": "Grupo",
	"SELECT.GROUP.TITLE": "G. Corporativo",
	"SELECT.GROUP.TOOLTIP": "Seleccione grupo corporativo de la lista",
	SELECT_ALL: SELECT_ALL$2,
	"SERVICE.FINAL_CLIENT.INPUT.PLACEHOLDER": "Cliente final...",
	"SERVICE.FINAL_CLIENT.INPUT.TITLE": "Cliente final",
	"SERVICE.FINAL_CLIENT.INPUT.TOOLTIP": "Escriba el nombre del cliente final en caso de que aplique",
	"SERVICE.REFERENCE.INPUT.PLACEHOLDER": "Mensaje...",
	"SERVICE.REFERENCE.INPUT.TITLE": "Referencia",
	"SERVICE.REFERENCE.INPUT.TOOLTIP": "Mensaje de referencia adjunto a la cotización",
	SPANISH: SPANISH$1,
	"STEP.BUTTON.BACK": "Atras",
	"STEP.BUTTON.CLOSE": "Salir",
	"STEP.BUTTON.CONFIRM": "Confirmar",
	"STEP.BUTTON.CONTINUE": "Siguiente",
	"STEP.BUTTON.SUBMIT": "Enviar",
	"STEP.BUTTON.WAIT": "Por favor espere...",
	"UNAUTHORIZED.ROUTE.ACCESS": "Acceso a ruta restringida",
	UNKNOWN: UNKNOWN$1,
	UPDATE: UPDATE$1,
	"USER.EXTERNAL.NAME": "Externo",
	"USER.INTERNAL.NAME": "Interno",
	"USER.UNKNOWN.NAME": "Desconocido",
	VALUE: VALUE$1,
	WELCOME: WELCOME$1,
	YES: YES$1
};

var ACCEPT$2 = "Aceitar";
var AND$2 = "e";
var BY_DEFAULT$2 = "Por padrão";
var CANCEL$2 = "Cancelar";
var CLEAR$2 = "Limpar";
var COPY$2 = "Copiar";
var CORPORATE_GROUP$2 = "Grupo corporativo";
var DAY$2 = "Dia";
var DAYS$2 = "Dias";
var DELETE_ALL$2 = "Excluir todos os itens selecionados";
var ENGLISH$2 = "Inglês";
var INTRODUCE_OPTION$2 = "Introduza uma opção";
var ITEM$2 = "Item";
var LANGUAGE$2 = "Idioma";
var LOADING$2 = "Carregando";
var LOADING_DOTS$2 = "Carregando...";
var MONTH$2 = "Mês";
var MONTHS$2 = "Meses";
var NEW$2 = "Novo";
var NO$2 = "Não";
var NO_OPTIONS$2 = "Sem opções";
var OK$2 = "OK";
var OR$2 = "ou";
var PATH_DETAIL$2 = "Detalhe";
var PATH_HOME$2 = "Início";
var PORTUGUESE$2 = "Português";
var RESET$2 = "Reiniciar";
var RESTART$2 = "Reiniciar";
var SAVE$2 = "Salvar";
var SEARCH$2 = "Buscar";
var SELECT_ALL$3 = "Selecionar todos";
var SPANISH$2 = "Espanhol";
var UNKNOWN$2 = "Desconhecido";
var UPDATE$2 = "Atualizar";
var VALUE$2 = "Valor";
var WELCOME$2 = "Bem-vind@ ao {appName}";
var YES$2 = "Sim";
var commonPtMessages = {
	ACCEPT: ACCEPT$2,
	"ADD.CLOSE": "Adicionar e fechar",
	"ADD.CONTINUE": "Adicionar e continuar",
	AND: AND$2,
	"AUTH.LOGGING_IN": "Iniciando sessão...",
	"AUTH.LOGIN": "Iniciar sessão",
	"AUTH.LOGIN.DOWN": "Não foi possível contactar o serviço de autenticação",
	"AUTH.LOGOUT": "Sair",
	"AUTH.MAIL": "E-mail",
	"AUTH.SESSION.EXPIRED": "A sessão expirou",
	BY_DEFAULT: BY_DEFAULT$2,
	CANCEL: CANCEL$2,
	CLEAR: CLEAR$2,
	"COL.ACT_AT": "Atualizado em",
	"COL.ACT_BY": "Atualizado por",
	"CONTACT.US": "Contate-nos",
	"COOKIES.POLICY": "Política de Cookies",
	COPY: COPY$2,
	CORPORATE_GROUP: CORPORATE_GROUP$2,
	"COUNTRY.DESTINATION": "País de destino",
	"COUNTRY.ORIGIN": "País de origem",
	DAY: DAY$2,
	DAYS: DAYS$2,
	"DELETE.OPERATION": "Operação de exclusão",
	"DELETE.OPERATION.WARNING": "Os itens selecionados serão excluídos. Operação irreversível. Tem certeza?",
	DELETE_ALL: DELETE_ALL$2,
	"DEVELOPED.BY": "Desenvolvido por",
	"EMPTY.MESSAGE": "Sem dados",
	ENGLISH: ENGLISH$2,
	"ERROR.INVALID": "Valor inválido",
	"ERROR.INVALID.MAXIMUM": "Valor inválido",
	"ERROR.INVALID.MINIMUM": "Valor inválido",
	"ERROR.MAIL.INVALID": "E-mail inválido",
	"ERROR.MUST_BE_GREATER": "Deve ser maior que {value}",
	"ERROR.MUST_BE_LOWER": "Deve ser menor que {value}",
	"ERROR.MUST_CONTAIN_N_ITEMS": "Deve conter pelo menos {value} valor(es)",
	"ERROR.NOT_EMPTY": "Não pode estar vazio",
	"ERROR.REQUIRED": "Obrigatório",
	"FILTERS.LABEL": "Limpar filtros",
	"GENERIC.REGISTRY.CREATE.SUCCESS": "Criado o registro {target}",
	"GENERIC.REGISTRY.UPDATE.SUCCESS": "Atualizado o registro {target}",
	INTRODUCE_OPTION: INTRODUCE_OPTION$2,
	ITEM: ITEM$2,
	LANGUAGE: LANGUAGE$2,
	LOADING: LOADING$2,
	LOADING_DOTS: LOADING_DOTS$2,
	"MENU.HOME": "Início",
	"MODAL.NEW.REGISTER.TITLE": "Criar novo registro",
	MONTH: MONTH$2,
	MONTHS: MONTHS$2,
	NEW: NEW$2,
	"NEW.ENTRY": "Novo registro",
	"NEW.PLACEHOLDER": "Novo registro...",
	"NEW.REGISTER": "Novo",
	NO: NO$2,
	NO_OPTIONS: NO_OPTIONS$2,
	"OFFER.CURRENCY": "Divisa da oferta",
	OK: OK$2,
	OR: OR$2,
	"PAGINATOR.REPORT": "Mostrando '{first}' a '{last}' de '{totalRecords}'",
	PATH_DETAIL: PATH_DETAIL$2,
	PATH_HOME: PATH_HOME$2,
	PORTUGUESE: PORTUGUESE$2,
	"PRIVACY.POLICY": "Política de Privacidade",
	"PRODUCT.TYPE": "Tipo de produto",
	"QUICK_LINKS.AQS.DESCRIPTION": "Cotizador",
	"QUICK_LINKS.COMM.DESCRIPTION": "Comissões",
	"QUICK_LINKS.FACT.DESCRIPTION": "Faturamento",
	"QUICK_LINKS.FTTH.DESCRIPTION": "FTTH Network",
	"QUICK_LINKS.GDS.DESCRIPTION": "Serviços",
	"QUICK_LINKS.GFA.DESCRIPTION": "Faturas",
	"QUICK_LINKS.GTI.DESCRIPTION": "Tickets",
	"QUICK_LINKS.OFE.DESCRIPTION": "Ofertas",
	"QUICK_LINKS.PORTAL.DESCRIPTION": "Usuário",
	"QUICK_LINKS.QR.DESCRIPTION": "Inventário QR",
	"QUICK_LINKS.WEB.DESCRIPTION": "Site corporativo",
	RESET: RESET$2,
	RESTART: RESTART$2,
	SAVE: SAVE$2,
	SEARCH: SEARCH$2,
	"SEARCH.PLACEHOLDER": "Buscar...",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS": "A eliminação de {section} foi realizada com sucesso",
	"SECTION.DELETE.INDIVIDUAL.SUCCESS.WITH_ID": "A eliminação de {section} com ID {id} foi realizada com sucesso",
	"SECTION.DELETE.MASSIVE.FAILURE": "Ocorreu um erro na eliminação em massa de {section}",
	"SECTION.DELETE.MASSIVE.SUCCESS": "A eliminação em massa de {section} foi realizada com sucesso",
	"SELECT.CLIENT.TITLE": "Cliente",
	"SELECT.CLIENT.TOOLTIP": "Selecione um cliente da lista",
	"SELECT.CONTACT.NONE": "Sem contato",
	"SELECT.CONTACT.TITLE": "Contato",
	"SELECT.CONTACT.TOOLTIP": "Selecione um contato da lista",
	"SELECT.COUNTRY.TITLE": "País",
	"SELECT.COUNTRY.TOOLTIP": "Selecione um país da lista",
	"SELECT.GROUP.PLACEHOLDER": "Grupo",
	"SELECT.GROUP.TITLE": "Grupo Corporativo",
	"SELECT.GROUP.TOOLTIP": "Selecione um grupo corporativo da lista",
	SELECT_ALL: SELECT_ALL$3,
	"SERVICE.FINAL_CLIENT.INPUT.PLACEHOLDER": "Cliente final...",
	"SERVICE.FINAL_CLIENT.INPUT.TITLE": "Cliente final",
	"SERVICE.FINAL_CLIENT.INPUT.TOOLTIP": "Insira o nome do cliente final se aplicável",
	SPANISH: SPANISH$2,
	"STEP.BUTTON.BACK": "Voltar",
	"STEP.BUTTON.CLOSE": "Sair",
	"STEP.BUTTON.CONFIRM": "Confirmar",
	"STEP.BUTTON.CONTINUE": "Continuar",
	"STEP.BUTTON.SUBMIT": "Enviar",
	"STEP.BUTTON.WAIT": "Aguarde por favor...",
	"UNAUTHORIZED.ROUTE.ACCESS": "Acesso a rota restrita",
	UNKNOWN: UNKNOWN$2,
	UPDATE: UPDATE$2,
	"USER.EXTERNAL.NAME": "Externo",
	"USER.INTERNAL.NAME": "Interno",
	"USER.UNKNOWN.NAME": "Desconhecido",
	VALUE: VALUE$2,
	WELCOME: WELCOME$2,
	YES: YES$2
};

var JANUARY = "January";
var FEBRUARY = "February";
var MARCH = "March";
var APRIL = "April";
var MAY = "May";
var JUNE = "June";
var JULY = "July";
var AUGUST = "August";
var SEPTEMBER = "September";
var OCTOBER = "October";
var NOVEMBER = "November";
var DECEMBER = "December";
var ADJUDGE = "Adjudge";
var DELIVERY = "Delivery";
var BILLING = "Billing";
var CEASE = "Cease";
var MANUAL = "Manual";
var COMPLETED = "Completed";
var BULK_LOAD = "Bulk load";
var PENDING$1 = "Pending";
var APPROVED = "Approved";
var REJECTED$1 = "Rejected";
var commissionsEnMessages = {
	"MENU.COMMISSIONS": "Commissions",
	"MENU.ESTIMATED": "Estimated",
	"MENU.PENDING": "Pending authorize",
	"MENU.SETTLED.ACCOUNTS": "Settled Accounts",
	"MENU.REJECTED": "Rejected",
	"MENU.MONTH.SALES": "Goals",
	"SECTION.LIST.COMMMISIONS": "List commissions",
	"SECTION.LIST.PENDING": "List pending",
	"SECTION.LIST.SETTLED.ACCOUNTS": "List settled accounts",
	"SECTION.LIST.REJECTED": "List rejected",
	"COL.COMMISSION.SERVICE": "Service",
	"COL.COMMISSION.VALUE": "Value",
	"COL.COMMISSION.BASE": "Commission base",
	"COL.COMMISSION.SALE.MONTH": "Month of sale",
	"COL.COMMISSION.AUTH.LEVEL": "Auth level",
	"COL.COMMISSION.RESPONSABLE": "Level responsable",
	"COL.COMMISSION.MULTIPLE": "Multiple",
	"COL.GLOBAL.SERVICE.TYPE.NAME": "Service type",
	"COL.GLOBAL.TEAM.NAME": "Team",
	"COL.GLOBAL.TYPE.NAME": "Client type",
	"COL.GLOBAL.TERM.NAME": "Term in months",
	"COL.GLOBAL.ECONOMIC.MODEL.NAME": "Economic model",
	"COL.GLOBAL.PERCENTAGE": "Percentage commission",
	"COL.LEVEL": "Level",
	JANUARY: JANUARY,
	FEBRUARY: FEBRUARY,
	MARCH: MARCH,
	APRIL: APRIL,
	MAY: MAY,
	JUNE: JUNE,
	JULY: JULY,
	AUGUST: AUGUST,
	SEPTEMBER: SEPTEMBER,
	OCTOBER: OCTOBER,
	NOVEMBER: NOVEMBER,
	DECEMBER: DECEMBER,
	"PENDING.APPROVAL": "Total amount pending to authorize",
	"SELECT.YEAR": "Select year",
	"SELECT.USER": "Select user",
	"HEADER.MONTH": "Month",
	"DISCHARD.CHANGES": "Dischard changes",
	"SEND.REQUEST": "Send",
	ADJUDGE: ADJUDGE,
	DELIVERY: DELIVERY,
	BILLING: BILLING,
	CEASE: CEASE,
	MANUAL: MANUAL,
	"COL.COMMISSION.ADMINCODE": "Administrator code",
	"COL.COMMISSION.BACKLOG": "Backlog",
	"COL.COMMISSION.COMMISSIONTYPE": "Exchange commission",
	"COL.COMMISSION.BASEAMOUNT": "Commission base",
	"COL.COMMISSION.EXCHANGERATE": "Exchange rate",
	"COL.COMMISSION.FACTOR": "Achievement factor",
	"COL.COMMISSION.CURRENCY": "Currency",
	"COL.COMMISSION.PERCENTAGECOMMISSION": "% commission",
	"COL.COMMISSION.TOTALAMOUNT": "Final commission",
	"COL.COMMISSION.DATEAUTH": "Date authorization",
	"COL.COMMISSION.STATUSMULTIPLICADOR": "Commission status",
	"COL.COMMISSION.MONTHPAYDAY": "Month payment",
	"SENDING.REQUEST": "Sending",
	"COL.COMMISSION.DATEREJECTED": "Rejected date",
	"MENU.INPROCESS": "In process",
	"MENU.APPROVED": "Approved",
	"NECESSARY.RECALCULATION": "Necessary recalculation",
	"WAITING.BACKLOG": "Waiting backlog",
	"WAITING.AUTHORIZATION": "Waiting authorization",
	"CALCULATING.ACHIEVEMENT": "Calculating achievement",
	COMPLETED: COMPLETED,
	"COL.COMMISSION.STATUSCALCULATING": "Calculating status",
	"TOTAL.AMOUNT.AUTHORIZE": "Total amount authorize",
	"TOTAL.AMOUNT.REJECTED": "Total amount rejected",
	"PREVIEW.FILE": "File to be proccessed:",
	"DROPZONE.UPLOAD_EXCEL.TITLE": "Attach excel file",
	"LOAD.TEMPLATE": "Load template",
	"DOWNLOAD.TEMPLATE": "Download template",
	BULK_LOAD: BULK_LOAD,
	"ERROR.REQUIRED": "Required",
	"ERROR.FILE.EXTENSION": "Invalid file type",
	"MENU.AUTHORIZATION": "Authorizations",
	"COL.COMMISSION.STATUS": "Status",
	"BUTTON.APRROVED": "Approve",
	"BUTTON.REJECTED": "Reject",
	PENDING: PENDING$1,
	APPROVED: APPROVED,
	REJECTED: REJECTED$1,
	"MENU.MULTIPLICATOR": "Multipliers",
	"MENU.MULTIPLICATOR.GOALS": "Multipliers and goals",
	"COL.COMMISSION.YEAR": "Year",
	"COL.COMMISSION.MONTH": "Month",
	"COL.COMMISSION.ACHIEVEMENT.AMOUNT": "Net ARC achieved for the month",
	"COL.COMMISSION.ACHIEVEMENT.PERIODICITY.AMOUNT": "Net ARC achieved for the period",
	"COL.COMMISSION.GOALS.PERIODICITY.AMOUNT": "Net goal ARC for the period",
	"COL.COMMISSION.PERCENTANGE.ACHIEVEMENT": "% achievement",
	"COL.COMMISSION.MULTIPLICATOR": "Multiplier",
	"COL.COMMISSION.INITIAL.DATE": "Initial period date",
	"COL.COMMISSION.END.DATE": "End period date",
	"MISSING.CONFIGURATION": "Step 1 of 5: Missing configuration",
	"WAITING.EXCHANGERATE": "Step 2 of 5: Waiting exchange rate",
	"WAITING.DELIVERY": "Step 3 of 5: Waiting for delivery",
	"WAITING.BILLING": "Step 3 of 5: Waiting for billing",
	"CALCULATING.MULTIPLIER": "Step 4 of 5: Calculating multiplier",
	"WAITING.BACKLOGCEASE": "Step 4 of 5: Waiting backlog cease",
	"PENDING.AUTHORIZATION": "Step 5 of 5: Pending authorization"
};

var JANUARY$1 = "Enero";
var FEBRUARY$1 = "Febrero";
var MARCH$1 = "Marzo";
var APRIL$1 = "Abril";
var MAY$1 = "Mayo";
var JUNE$1 = "Junio";
var JULY$1 = "Julio";
var AUGUST$1 = "Agosto";
var SEPTEMBER$1 = "Setiembre";
var OCTOBER$1 = "Octubre";
var NOVEMBER$1 = "Noviembre";
var DECEMBER$1 = "Diciembre";
var ADJUDGE$1 = "Adjudicación";
var DELIVERY$1 = "Entrega";
var BILLING$1 = "Facturación";
var CEASE$1 = "Baja";
var MANUAL$1 = "Manual";
var COMPLETED$1 = "Completado";
var BULK_LOAD$1 = "Carga masiva";
var PENDING$2 = "Pendiente";
var APPROVED$1 = "Aprobado";
var REJECTED$2 = "Rechazado";
var commissionsEsMessages = {
	"MENU.COMMISSIONS": "Comisiones",
	"MENU.ESTIMATED": "Estimado",
	"MENU.PENDING": "Pendiente de autorizar",
	"MENU.SETTLED.ACCOUNTS": "Comisiones liquidadas",
	"MENU.REJECTED": "Rechazadas",
	"MENU.MONTH.SALES": "Metas",
	"SECTION.LIST.COMMMISIONS": "Lista de comisiones",
	"SECTION.LIST.PENDING": "Lista de pendientes",
	"SECTION.LIST.SETTLED.ACCOUNTS": "Lista de comisiones liquidadas",
	"SECTION.LIST.REJECTED": "Lista de rechazadas",
	"COL.COMMISSION.SERVICE": "Servicio",
	"COL.COMMISSION.VALUE": "Valor",
	"COL.COMMISSION.BASE": "Comisiones base",
	"COL.COMMISSION.SALE.MONTH": "Mes de venta",
	"COL.COMMISSION.AUTH.LEVEL": "Nivel de autorización",
	"COL.COMMISSION.RESPONSABLE": "Responsable del nivel",
	"COL.COMMISSION.MULTIPLE": "Multiplicador",
	"COL.GLOBAL.SERVICE.TYPE.NAME": "Tipo de servicio",
	"COL.GLOBAL.TEAM.NAME": "Equipo",
	"COL.GLOBAL.TYPE.NAME": "Tipo de cliente",
	"COL.GLOBAL.TERM.NAME": "Plazo en meses",
	"COL.GLOBAL.ECONOMIC.MODEL.NAME": "Modelo económico",
	"COL.GLOBAL.PERCENTAGE": "Porcentaje de comisión",
	"COL.LEVEL": "Nivel",
	JANUARY: JANUARY$1,
	FEBRUARY: FEBRUARY$1,
	MARCH: MARCH$1,
	APRIL: APRIL$1,
	MAY: MAY$1,
	JUNE: JUNE$1,
	JULY: JULY$1,
	AUGUST: AUGUST$1,
	SEPTEMBER: SEPTEMBER$1,
	OCTOBER: OCTOBER$1,
	NOVEMBER: NOVEMBER$1,
	DECEMBER: DECEMBER$1,
	"PENDING.APPROVAL": "Monto total pendiente de autorizar",
	"SELECT.YEAR": "Seleccionar año",
	"SELECT.USER": "Seleccionar usuario",
	"HEADER.MONTH": "Mes",
	"DISCHARD.CHANGES": "Descartar cambios",
	"SEND.REQUEST": "Enviar",
	ADJUDGE: ADJUDGE$1,
	DELIVERY: DELIVERY$1,
	BILLING: BILLING$1,
	CEASE: CEASE$1,
	MANUAL: MANUAL$1,
	"COL.COMMISSION.ADMINCODE": "Código administrativo",
	"COL.COMMISSION.BACKLOG": "Backlog",
	"COL.COMMISSION.COMMISSIONTYPE": "Tipo de comisión",
	"COL.COMMISSION.BASEAMOUNT": "Comisión base",
	"COL.COMMISSION.EXCHANGERATE": "Tipo de cambio",
	"COL.COMMISSION.FACTOR": "Factor de cumplimiento",
	"COL.COMMISSION.CURRENCY": "Moneda",
	"COL.COMMISSION.PERCENTAGECOMMISSION": "% de comisión",
	"COL.COMMISSION.TOTALAMOUNT": "Comisión final",
	"COL.COMMISSION.DATEAUTH": "Fecha de autorización",
	"COL.COMMISSION.STATUSMULTIPLICADOR": "Estado de cálculo",
	"COL.COMMISSION.MONTHPAYDAY": "Mes de pago",
	"SENDING.REQUEST": "Enviando",
	"COL.COMMISSION.DATEREJECTED": "Fecha de rechazo",
	"MENU.INPROCESS": "En proceso",
	"MENU.APPROVED": "Aprobado",
	"NECESSARY.RECALCULATION": "Recalculo necesario",
	"WAITING.BACKLOG": "Esperando backlog",
	"WAITING.AUTHORIZATION": "Esperando autorización",
	"CALCULATING.ACHIEVEMENT": "Calculando logro",
	COMPLETED: COMPLETED$1,
	"COL.COMMISSION.STATUSCALCULATING": "Estado de cálculo",
	"TOTAL.AMOUNT.AUTHORIZE": "Monto total autorizado",
	"TOTAL.AMOUNT.REJECTED": "Monto total rechazado",
	"PREVIEW.FILE": "Fichero a procesar:",
	"DROPZONE.UPLOAD_EXCEL.TITLE": "Adjuntar fichero excel",
	"LOAD.TEMPLATE": "Cargar plantilla",
	"DOWNLOAD.TEMPLATE": "Descargar plantilla",
	BULK_LOAD: BULK_LOAD$1,
	"ERROR.REQUIRED": "Requerido",
	"ERROR.FILE.EXTENSION": "Tipo de fichero inválido",
	"MENU.AUTHORIZATION": "Autorizaciones",
	"COL.COMMISSION.STATUS": "Estado",
	"BUTTON.APRROVED": "Aprobar",
	"BUTTON.REJECTED": "Rechazar",
	PENDING: PENDING$2,
	APPROVED: APPROVED$1,
	REJECTED: REJECTED$2,
	"MENU.MULTIPLICATOR": "Multiplicadores",
	"MENU.MULTIPLICATOR.GOALS": "Multiplicadores y metas",
	"COL.COMMISSION.YEAR": "Año",
	"COL.COMMISSION.MONTH": "Mes",
	"COL.COMMISSION.ACHIEVEMENT.AMOUNT": "ARC neto logrado del mes",
	"COL.COMMISSION.ACHIEVEMENT.PERIODICITY.AMOUNT": "ARC neto logrado del período",
	"COL.COMMISSION.GOALS.PERIODICITY.AMOUNT": "ARC neto meta del período",
	"COL.COMMISSION.PERCENTANGE.ACHIEVEMENT": "% de cumplimiento",
	"COL.COMMISSION.MULTIPLICATOR": "Multiplicador",
	"COL.COMMISSION.INITIAL.DATE": "Fecha inicio del período",
	"COL.COMMISSION.END.DATE": "Fecha fin del período",
	"MISSING.CONFIGURATION": "Paso 1 de 5: Configuración faltante",
	"WAITING.EXCHANGERATE": "Paso 2 de 5: Esperando tipo de cambio",
	"WAITING.DELIVERY": "Paso 3 de 5: Esperando entrega",
	"WAITING.BILLING": "Paso 3 de 5: Esperando facturación",
	"CALCULATING.MULTIPLIER": "Paso 4 de 5: Calculando multiplicador",
	"WAITING.BACKLOGCEASE": "Paso 4 de 5: Esperando backlog baja",
	"PENDING.AUTHORIZATION": "Paso 5 de 5: Pendiente autorización"
};

var JANUARY$2 = "Janeiro";
var FEBRUARY$2 = "Fevereiro";
var MARCH$2 = "Março";
var APRIL$2 = "Abril";
var MAY$2 = "Maio";
var JUNE$2 = "Junho";
var JULY$2 = "Julho";
var AUGUST$2 = "Agosto";
var SEPTEMBER$2 = "Setembro";
var OCTOBER$2 = "Outubro";
var NOVEMBER$2 = "Novembro";
var DECEMBER$2 = "Dezembro";
var ADJUDGE$2 = "Adjudicação";
var DELIVERY$2 = "Entrega";
var BILLING$2 = "Faturamento";
var CEASE$2 = "Baixa";
var MANUAL$2 = "Manual";
var COMPLETED$2 = "Concluído";
var BULK_LOAD$2 = "Carga em massa";
var PENDING$3 = "Pendente";
var APPROVED$2 = "Aprovado";
var REJECTED$3 = "Rejeitado";
var commissionsPtMessages = {
	"MENU.COMMISSIONS": "Comissões",
	"MENU.ESTIMATED": "Estimado",
	"MENU.PENDING": "Pendente de autorização",
	"MENU.SETTLED.ACCOUNTS": "Contas liquidadas",
	"MENU.REJECTED": "Rejeitadas",
	"MENU.MONTH.SALES": "Metas",
	"SECTION.LIST.COMMMISIONS": "Lista de comissões",
	"SECTION.LIST.PENDING": "Lista de pendências",
	"SECTION.LIST.SETTLED.ACCOUNTS": "Lista de contas liquidadas",
	"SECTION.LIST.REJECTED": "Lista de rejeitadas",
	"COL.COMMISSION.SERVICE": "Serviço",
	"COL.COMMISSION.VALUE": "Valor",
	"COL.COMMISSION.BASE": "Comissões base",
	"COL.COMMISSION.SALE.MONTH": "Mês de venda",
	"COL.COMMISSION.AUTH.LEVEL": "Nível de autorização",
	"COL.COMMISSION.RESPONSABLE": "Responsável pelo nível",
	"COL.COMMISSION.MULTIPLE": "Multiplicador",
	"COL.GLOBAL.SERVICE.TYPE.NAME": "ipo de serviço",
	"COL.GLOBAL.TEAM.NAME": "Equipe",
	"COL.GLOBAL.TYPE.NAME": "Tipo de cliente",
	"COL.GLOBAL.TERM.NAME": "Prazo em meses",
	"COL.GLOBAL.ECONOMIC.MODEL.NAME": "Modelo econômico",
	"COL.GLOBAL.PERCENTAGE": "Percentual de comissão",
	"COL.LEVEL": "Nível",
	JANUARY: JANUARY$2,
	FEBRUARY: FEBRUARY$2,
	MARCH: MARCH$2,
	APRIL: APRIL$2,
	MAY: MAY$2,
	JUNE: JUNE$2,
	JULY: JULY$2,
	AUGUST: AUGUST$2,
	SEPTEMBER: SEPTEMBER$2,
	OCTOBER: OCTOBER$2,
	NOVEMBER: NOVEMBER$2,
	DECEMBER: DECEMBER$2,
	"PENDING.APPROVAL": "Valor total pendente de aprovação",
	"SELECT.YEAR": "Selecionar ano",
	"SELECT.USER": "Selecionar usuário",
	"HEADER.MONTH": "Mês",
	"DISCHARD.CHANGES": "Descartar alterações",
	"SEND.REQUEST": "Enviar",
	ADJUDGE: ADJUDGE$2,
	DELIVERY: DELIVERY$2,
	BILLING: BILLING$2,
	CEASE: CEASE$2,
	MANUAL: MANUAL$2,
	"COL.COMMISSION.ADMINCODE": "Código administrativo",
	"COL.COMMISSION.BACKLOG": "Backlog",
	"COL.COMMISSION.COMMISSIONTYPE": "Tipo de comissão",
	"COL.COMMISSION.BASEAMOUNT": "Valor base",
	"COL.COMMISSION.EXCHANGERATE": "Taxa de câmbio",
	"COL.COMMISSION.FACTOR": "Fator de cumprimento",
	"COL.COMMISSION.CURRENCY": "Moeda",
	"COL.COMMISSION.PERCENTAGECOMMISSION": "% de comissão",
	"COL.COMMISSION.TOTALAMOUNT": "Valor final da comissão",
	"COL.COMMISSION.DATEAUTH": "Data de autorização",
	"COL.COMMISSION.STATUSMULTIPLICADOR": "Estado do multiplicador",
	"COL.COMMISSION.MONTHPAYDAY": "Mês de pagamento",
	"SENDING.REQUEST": "Enviando",
	"COL.COMMISSION.DATEREJECTED": "Data de rejeição",
	"MENU.INPROCESS": "Em processo",
	"MENU.APPROVED": "Aprovado",
	"NECESSARY.RECALCULATION": "Recálculo necessário",
	"WAITING.BACKLOG": "Aguardando backlog",
	"WAITING.AUTHORIZATION": "Aguardando autorização",
	"CALCULATING.ACHIEVEMENT": "Calculando conquista",
	COMPLETED: COMPLETED$2,
	"COL.COMMISSION.STATUSCALCULATING": "Estado de cálculo",
	"TOTAL.AMOUNT.AUTHORIZE": "Valor total autorizado",
	"TOTAL.AMOUNT.REJECTED": "Valor total rejeitado",
	"PREVIEW.FILE": "Pré-visualização do arquivo:",
	"DROPZONE.UPLOAD_EXCEL.TITLE": "Carregar arquivo Excel",
	"LOAD.TEMPLATE": "Carregar modelo",
	"DOWNLOAD.TEMPLATE": "Baixar modelo",
	BULK_LOAD: BULK_LOAD$2,
	"ERROR.REQUIRED": "Campo obrigatório",
	"ERROR.FILE.EXTENSION": "Tipo de arquivo inválido",
	"MENU.AUTHORIZATION": "Autorizações",
	"COL.COMMISSION.STATUS": "Estado",
	"BUTTON.APRROVED": "Aprovar",
	"BUTTON.REJECTED": "Rejeitar",
	PENDING: PENDING$3,
	APPROVED: APPROVED$2,
	REJECTED: REJECTED$3,
	"MENU.MULTIPLICATOR": "Multiplicadores",
	"MENU.MULTIPLICATOR.GOALS": "Multiplicadores e metas",
	"COL.COMMISSION.YEAR": "Ano",
	"COL.COMMISSION.MONTH": "Mês",
	"COL.COMMISSION.ACHIEVEMENT.AMOUNT": "Valor líquido alcançado no mês",
	"COL.COMMISSION.ACHIEVEMENT.PERIODICITY.AMOUNT": "Valor líquido alcançado no período",
	"COL.COMMISSION.GOALS.PERIODICITY.AMOUNT": "Valor líquido da meta no período",
	"COL.COMMISSION.PERCENTANGE.ACHIEVEMENT": "% de realização",
	"COL.COMMISSION.MULTIPLICATOR": "Multiplicador",
	"COL.COMMISSION.INITIAL.DATE": "Data inicial do período",
	"COL.COMMISSION.END.DATE": "Data final do período",
	"MISSING.CONFIGURATION": "Passo 1 de 5: Configuração em falta",
	"WAITING.EXCHANGERATE": "Passo 2 de 5: Aguardando taxa de câmbio",
	"WAITING.DELIVERY": "Passo 3 de 5: Aguardando entrega",
	"WAITING.BILLING": "Passo 3 de 5: Aguardando faturamento",
	"CALCULATING.MULTIPLIER": "Passo 4 de 5: Calculando multiplicador",
	"WAITING.BACKLOGCEASE": "Passo 4 de 5: Aguardando backlog para baixa",
	"PENDING.AUTHORIZATION": "Passo 5 de 5: Aguardando autorização"
};

const addLocale = (lang, options) => {
  api.addLocale(lang, options);
};
addLocale('en', primeReactEnMessages);
addLocale('es', primeReactEsMessages);
addLocale('pt', primeReactPtMessages);
const allMessages = {
  en: Object.assign({}, commonEnMessages, commissionsEnMessages),
  es: Object.assign({}, commonEsMessages, commissionsEsMessages),
  pt: Object.assign({}, commonPtMessages, commissionsPtMessages)
};
const I18nProvider = _ref => {
  let {
    messagesByLanguage,
    children
  } = _ref;
  const locale = ufinetWebFunctions.useLang();
  const localeMessages = Object.assign({}, allMessages[locale], messagesByLanguage === null || messagesByLanguage === void 0 ? void 0 : messagesByLanguage[locale]);
  return /*#__PURE__*/React__default.createElement(reactIntl.IntlProvider, {
    locale: locale,
    messages: localeMessages
  }, children);
};

const Ufineti18nProvider = _ref => {
  let {
    children
  } = _ref;
  const lang = ufinetWebFunctions.getConfig();
  return /*#__PURE__*/React__default.createElement(ufinetWebFunctions.I18nContext.Provider, {
    value: lang
  }, children);
};

const KTSVG = _ref => {
  let {
    className = '',
    path,
    svgClassName = 'mh-50px'
  } = _ref;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "svg-icon " + className
  }, /*#__PURE__*/React__default.createElement(SVG, {
    src: ufinetWebFunctions.toAbsoluteUrl(path),
    className: svgClassName
  }));
};

const AsideMenuItem = _ref => {
  let {
    children,
    to,
    title,
    icon,
    hasBullet = false,
    onClick,
    routerLocation
  } = _ref;
  const {
    pathname
  } = routerLocation;
  const isActive = ufinetWebFunctions.checkIsActive(pathname, to);
  const triggerAction = () => onClick && onClick();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item"
  }, /*#__PURE__*/React__default.createElement(reactRouterDom.Link, {
    className: clsx('menu-link without-sub', {
      active: isActive
    }),
    to: to,
    onClick: triggerAction
  }, hasBullet && /*#__PURE__*/React__default.createElement("span", {
    className: "menu-bullet"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bullet bullet-dot"
  })), icon ? typeof icon === 'string' ? /*#__PURE__*/React__default.createElement("span", {
    className: "menu-icon"
  }, /*#__PURE__*/React__default.createElement(KTSVG, {
    path: icon,
    className: "svg-icon-2"
  })) : /*#__PURE__*/React__default.createElement("span", {
    className: "menu-icon"
  }, /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
    size: "sm",
    icon: icon
  })) : undefined, /*#__PURE__*/React__default.createElement("span", {
    className: "menu-title"
  }, title)), children);
};

const AsideMenuItemWithSub = _ref => {
  let {
    children,
    title,
    icon,
    hasBullet,
    onClick,
    active = false
  } = _ref;
  const triggerAction = () => onClick && onClick();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item show menu-accordion",
    "data-kt-menu-trigger": "click",
    onClick: triggerAction
  }, /*#__PURE__*/React__default.createElement("span", {
    className: clsx('menu-link border-gray-300 border-1 border-bottom fs-4 py-7', {
      'sub-item-selected': active
    })
  }, hasBullet && /*#__PURE__*/React__default.createElement("span", {
    className: "menu-bullet"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bullet bullet-dot"
  })), icon && typeof icon === 'string' ? /*#__PURE__*/React__default.createElement("span", {
    className: "menu-icon"
  }, /*#__PURE__*/React__default.createElement(KTSVG, {
    path: icon,
    className: "svg-icon-2"
  })) : /*#__PURE__*/React__default.createElement("span", {
    className: "menu-icon me-5"
  }, icon), /*#__PURE__*/React__default.createElement("span", {
    className: "menu-title"
  }, title), /*#__PURE__*/React__default.createElement("span", {
    className: "menu-arrow"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "menu-sub menu-sub-accordion"
  }, children));
};

const DefaultLayoutConfig = {
  main: {
    type: 'default',
    primaryColor: '#009EF7',
    darkSkinEnabled: true
  },
  loader: {
    display: false,
    type: 'default'
  },
  scrolltop: {
    display: true
  },
  header: {
    display: true,
    width: 'fluid',
    left: 'menu',
    fixed: {
      desktop: true,
      tabletAndMobile: true
    },
    menuIcon: 'svg'
  },
  megaMenu: {
    display: false
  },
  aside: {
    display: true,
    theme: 'light',
    menu: 'main',
    fixed: true,
    minimized: false,
    minimize: true,
    hoverable: true,
    menuIcon: 'svg'
  },
  content: {
    width: 'fixed',
    layout: 'default'
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobileMode: true
    },
    layout: 'toolbar1',
    layouts: {
      toolbar1: {
        height: '55px',
        heightAndTabletMobileMode: '55px'
      },
      toolbar2: {
        height: '75px',
        heightAndTabletMobileMode: '65px'
      },
      toolbar3: {
        height: '55px',
        heightAndTabletMobileMode: '55px'
      },
      toolbar4: {
        height: '65px',
        heightAndTabletMobileMode: '65px'
      },
      toolbar5: {
        height: '75px',
        heightAndTabletMobileMode: '65px'
      }
    }
  },
  footer: {
    width: 'fluid'
  },
  pageTitle: {
    display: true,
    breadCrumbs: true,
    description: false,
    layout: 'default',
    direction: 'row',
    responsive: true,
    responsiveBreakpoint: 'lg',
    responsiveTarget: '#kt_toolbar_container'
  }
};

var _class;
const LAYOUT_CONFIG_KEY = process.env.REACT_APP_BASE_LAYOUT_CONFIG_KEY || 'LayoutConfig';
function getLayout() {
  const ls = localStorage.getItem(LAYOUT_CONFIG_KEY);
  if (ls) {
    try {
      return JSON.parse(ls);
    } catch (er) {
      console.error(er);
    }
  }
  return DefaultLayoutConfig;
}
function setLayout(config) {
  try {
    localStorage.setItem(LAYOUT_CONFIG_KEY, JSON.stringify(config));
  } catch (er) {
    console.error(er);
  }
}
function getEmptyCssClasses() {
  return {
    header: [],
    headerContainer: [],
    headerMobile: [],
    headerMenu: [],
    aside: [],
    asideMenu: [],
    asideToggle: [],
    toolbar: [],
    toolbarContainer: [],
    content: [],
    contentContainer: [],
    footerContainer: [],
    sidebar: [],
    pageTitle: []
  };
}
function getEmptyHTMLAttributes() {
  return {
    asideMenu: new Map(),
    headerMobile: new Map(),
    headerMenu: new Map(),
    headerContainer: new Map(),
    pageTitle: new Map()
  };
}
function getEmptyCSSVariables() {
  return {
    body: new Map()
  };
}
class LayoutSetup {
  static initCSSClasses() {
    LayoutSetup.classes = getEmptyCssClasses();
  }
  static initHTMLAttributes() {
    LayoutSetup.attributes = Object.assign({}, getEmptyHTMLAttributes());
  }
  static initCSSVariables() {
    LayoutSetup.cssVariables = getEmptyCSSVariables();
  }
  static initLayout(config) {
    var _config$main, _config$main$body, _config$main2, _config$main2$body;
    Array.from(document.body.attributes).forEach(attr => {
      document.body.removeAttribute(attr.name);
    });
    document.body.setAttribute('style', '');
    document.body.setAttribute('id', 'kt_body');
    if ((_config$main = config.main) !== null && _config$main !== void 0 && (_config$main$body = _config$main.body) !== null && _config$main$body !== void 0 && _config$main$body.backgroundImage) {
      document.body.style.backgroundImage = "url('" + config.main.body.backgroundImage + "')";
    }
    if ((_config$main2 = config.main) !== null && _config$main2 !== void 0 && (_config$main2$body = _config$main2.body) !== null && _config$main2$body !== void 0 && _config$main2$body.class) {
      document.body.classList.add(config.main.body.class);
    }
  }
  static initHeader(config) {
    LayoutSetup.classes.headerContainer.push(config.width === 'fluid' ? 'container-fluid' : 'container');
    if (config.fixed.desktop) {
      document.body.classList.add('header-fixed');
    }
    if (config.fixed.tabletAndMobile) {
      document.body.classList.add('header-tablet-and-mobile-fixed');
    }
  }
  static initToolbar(config) {
    if (!config.display) {
      return;
    }
    document.body.classList.add('toolbar-enabled');
    LayoutSetup.classes.toolbarContainer.push(config.width === 'fluid' ? 'container-fluid' : 'container');
    if (config.fixed.desktop) {
      document.body.classList.add('toolbar-fixed');
    }
    if (config.fixed.tabletAndMobileMode) {
      document.body.classList.add('toolbar-tablet-and-mobile-fixed');
    }
    const type = config.layout;
    const typeOptions = config.layouts[type];
    if (typeOptions) {
      let bodyStyles = '';
      if (typeOptions.height) {
        bodyStyles += " --kt-toolbar-height: " + typeOptions.height + ";";
      }
      if (typeOptions.heightAndTabletMobileMode) {
        bodyStyles += " --kt-toolbar-height-tablet-and-mobile: " + typeOptions.heightAndTabletMobileMode + ";";
      }
      document.body.setAttribute('style', bodyStyles);
    }
  }
  static initPageTitle(config) {
    if (!config.display) {
      return;
    }
    if (config.direction === 'column') {
      this.classes.pageTitle.push('flex-column');
      this.classes.pageTitle.push('align-items-start');
    } else {
      this.classes.pageTitle.push('align-items-center');
      this.classes.pageTitle.push('flex-wrap');
    }
    this.classes.pageTitle.push('me-3');
    if (config.responsive) {
      this.classes.pageTitle.push('mb-5');
      this.classes.pageTitle.push('mb-lg-0');
      LayoutSetup.attributes.pageTitle.set('data-kt-swapper', true);
      LayoutSetup.attributes.pageTitle.set('data-kt-swapper-mode', 'prepend');
      LayoutSetup.attributes.pageTitle.set('data-kt-swapper-parent', "{ default: '#kt_content_container', '" + config.responsiveBreakpoint + "': '" + config.responsiveTarget + "'}");
    }
  }
  static initContent(config) {
    LayoutSetup.classes.contentContainer.push(config.width === 'fluid' ? 'container-fluid' : 'container');
  }
  static initAside(config) {
    if (!config.display) {
      return;
    }
    document.body.classList.add('aside-enabled');
    LayoutSetup.classes.aside.push("aside-" + config.theme);
    if (config.fixed) {
      document.body.classList.add('aside-fixed');
    }
    if (config.minimized) {
      document.body.setAttribute('data-kt-aside-minimize', 'on');
    }
    if (config.hoverable) {
      LayoutSetup.classes.aside.push('aside-hoverable');
    }
  }
  static initAsideMenu(_config) {}
  static initFooter(config) {
    LayoutSetup.classes.footerContainer.push("container" + (config.width === 'fluid' ? '-fluid' : ''));
  }
  static initConfig(config) {
    var _config$main3, _config$main4;
    if ((_config$main3 = config.main) !== null && _config$main3 !== void 0 && _config$main3.darkSkinEnabled) {
      document.body.classList.add('dark-skin');
    }
    LayoutSetup.initLayout(config);
    if (((_config$main4 = config.main) === null || _config$main4 === void 0 ? void 0 : _config$main4.type) !== 'default') {
      return;
    }
    LayoutSetup.initHeader(config.header);
    LayoutSetup.initPageTitle(config.pageTitle);
    LayoutSetup.initToolbar(config.toolbar);
    LayoutSetup.initContent(config.content);
    LayoutSetup.initAside(config.aside);
    LayoutSetup.initFooter(config.footer);
    LayoutSetup.initAsideMenu(config.aside);
  }
  static updatePartialConfig(fieldsToUpdate) {
    const config = LayoutSetup.config;
    const updatedConfig = Object.assign({}, config, fieldsToUpdate);
    LayoutSetup.initCSSClasses();
    LayoutSetup.initCSSVariables();
    LayoutSetup.initHTMLAttributes();
    LayoutSetup.isLoaded = false;
    LayoutSetup.config = updatedConfig;
    LayoutSetup.initConfig(Object.assign({}, updatedConfig));
    LayoutSetup.isLoaded = true;
    return updatedConfig;
  }
  static setConfig(config) {
    setLayout(config);
  }
}
_class = LayoutSetup;
LayoutSetup.isLoaded = false;
LayoutSetup.config = getLayout();
LayoutSetup.classes = getEmptyCssClasses();
LayoutSetup.attributes = getEmptyHTMLAttributes();
LayoutSetup.cssVariables = getEmptyCSSVariables();
LayoutSetup.bootstrap = (() => {
  _class.updatePartialConfig(_class.config);
})();

const LayoutContext = /*#__PURE__*/React.createContext({
  config: DefaultLayoutConfig,
  classes: getEmptyCssClasses(),
  attributes: getEmptyHTMLAttributes(),
  cssVariables: getEmptyCSSVariables(),
  setLayout: _config => {}
});
const enableSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen');
  if (splashScreen) {
    splashScreen.style.setProperty('display', 'flex');
  }
};
const disableSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen');
  if (splashScreen) {
    splashScreen.style.setProperty('display', 'none');
  }
};
const LayoutProvider = _ref => {
  let {
    children
  } = _ref;
  const [config, setConfig] = React.useState(LayoutSetup.config);
  const [classes, setClasses] = React.useState(LayoutSetup.classes);
  const [attributes, setAttributes] = React.useState(LayoutSetup.attributes);
  const [cssVariables, setCSSVariables] = React.useState(LayoutSetup.cssVariables);
  const setLayout = _themeConfig => {
    enableSplashScreen();
    const bodyClasses = Array.from(document.body.classList);
    bodyClasses.forEach(cl => document.body.classList.remove(cl));
    LayoutSetup.updatePartialConfig(_themeConfig);
    setConfig(Object.assign({}, LayoutSetup.config));
    setClasses(LayoutSetup.classes);
    setAttributes(LayoutSetup.attributes);
    setCSSVariables(LayoutSetup.cssVariables);
    setTimeout(() => {
      disableSplashScreen();
    }, 500);
  };
  const value = {
    config,
    classes,
    attributes,
    cssVariables,
    setLayout
  };
  React.useEffect(() => {
    disableSplashScreen();
  }, []);
  return /*#__PURE__*/React__default.createElement(LayoutContext.Provider, {
    value: value
  }, children);
};
function useLayout() {
  return React.useContext(LayoutContext);
}

var NativeSymbol = global_1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (descriptors && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString_1(arguments[0]);
    var result = objectIsPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = functionUncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = functionUncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$4 = functionUncurryThis(''.replace);
  var stringSlice$3 = functionUncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwnProperty_1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$3(string, 7, -1) : replace$4(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const PageDataContext = /*#__PURE__*/React.createContext({
  setPageTitle: _title => {},
  setPageBreadcrumbs: _breadcrumbs => {},
  setPageDescription: _description => {}
});
const PageDataProvider = _ref => {
  let {
    children
  } = _ref;
  const [pageTitle, setPageTitle] = React.useState('');
  const [pageDescription, setPageDescription] = React.useState('');
  const [pageBreadcrumbs, setPageBreadcrumbs] = React.useState([]);
  const value = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs
  };
  return /*#__PURE__*/React__default.createElement(PageDataContext.Provider, {
    value: value
  }, children);
};
function usePageData() {
  return React.useContext(PageDataContext);
}
const PageTitle = _ref2 => {
  let {
    children,
    description,
    breadcrumbs
  } = _ref2;
  const {
    setPageTitle,
    setPageDescription,
    setPageBreadcrumbs
  } = usePageData();
  React.useEffect(() => {
    if (children) {
      setPageTitle(children.toString());
    }
    return () => {
      setPageTitle('');
    };
  }, [children]);
  React.useEffect(() => {
    if (description) {
      setPageDescription(description);
    }
    return () => {
      setPageDescription('');
    };
  }, [description]);
  React.useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs);
    }
    return () => {
      setPageBreadcrumbs([]);
    };
  }, [breadcrumbs]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
const PageDescription = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    setPageDescription
  } = usePageData();
  React.useEffect(() => {
    if (children) {
      setPageDescription(children.toString());
    }
    return () => {
      setPageDescription('');
    };
  }, [children]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};

const MetronicSplashScreenContext = /*#__PURE__*/React.createContext(undefined);
const MetronicSplashScreenProvider = _ref => {
  let {
    children
  } = _ref;
  const [count, setCount] = React.useState(0);
  const visible = count > 0;
  React.useEffect(() => {
    const splashScreen = document.getElementById('splash-screen');
    if (splashScreen && visible) {
      splashScreen.classList.remove('hidden');
      return () => {
        splashScreen.classList.add('hidden');
      };
    }
    let timeout;
    if (splashScreen && !visible) {
      timeout = window.setTimeout(() => {
        splashScreen.classList.add('hidden');
      }, 3000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [visible]);
  return /*#__PURE__*/React__default.createElement(MetronicSplashScreenContext.Provider, {
    value: setCount
  }, children);
};
const LayoutSplashScreen = _ref2 => {
  let {
    visible = true
  } = _ref2;
  const setCount = React.useContext(MetronicSplashScreenContext);
  React.useEffect(() => {
    if (!visible) {
      return;
    }
    if (setCount) {
      setCount(prev => {
        return prev + 1;
      });
    }
    return () => {
      if (setCount) {
        setCount(prev => {
          return prev - 1;
        });
      }
    };
  }, [setCount, visible]);
  return null;
};

const Content = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "kt_content_container",
    className: "container-fluid"
  }, children);
};

const Languages = () => {
  const intl = reactIntl.useIntl();
  const languages = [{
    lang: ufinetWebFunctions.LANGUAGE_CODE.ENGLISH,
    name: intl.formatMessage({
      id: 'ENGLISH'
    }),
    flag: ufinetWebFunctions.toAbsoluteUrl('/media/flags/united-states.svg')
  }, {
    lang: ufinetWebFunctions.LANGUAGE_CODE.SPANISH,
    name: intl.formatMessage({
      id: 'SPANISH'
    }),
    flag: ufinetWebFunctions.toAbsoluteUrl('/media/flags/spain.svg')
  }, {
    lang: ufinetWebFunctions.LANGUAGE_CODE.PORTUGUESE,
    name: intl.formatMessage({
      id: 'PORTUGUESE'
    }),
    flag: ufinetWebFunctions.toAbsoluteUrl('/media/flags/brazil.svg')
  }];
  const lang = ufinetWebFunctions.useLang();
  const currentLanguage = languages.find(x => x.lang === lang);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item px-5",
    "data-kt-menu-trigger": "hover",
    "data-kt-menu-placement": "left-start",
    "data-kt-menu-flip": "bottom"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "#",
    className: "menu-link px-5"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "menu-title position-relative"
  }, intl.formatMessage({
    id: 'LANGUAGE'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0"
  }, currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.name, ' ', /*#__PURE__*/React__default.createElement("img", {
    className: "w-15px h-15px rounded-1 ms-2",
    src: currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.flag,
    alt: "metronic"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "menu-sub menu-sub-dropdown w-175px py-4"
  }, languages.map(l => /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item px-3",
    key: l.lang,
    onClick: () => {
      ufinetWebFunctions.setLanguage(l.lang);
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "#",
    className: clsx('menu-link d-flex px-5', {
      active: l.lang === (currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.lang)
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "symbol symbol-20px me-4"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "rounded-1",
    src: l.flag,
    alt: "metronic"
  })), l.name)))));
};

const HeaderUserMenu = () => {
  const intl = reactIntl.useIntl();
  const {
    userData,
    logout
  } = React.useContext(ufinetWebFunctions.AuthContext);
  const userDetails = userData === null || userData === void 0 ? void 0 : userData.user;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary w-auto fw-bold py-4 fs-6 ",
    "data-kt-menu": "true"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item px-3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "menu-content d-flex align-items-center px-3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "symbol symbol-50px me-5"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Logo",
    src: ufinetWebFunctions.toAbsoluteUrl('/media/avatars/default.png')
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "fw-bolder d-flex align-items-center fs-5"
  }, /*#__PURE__*/React__default.createElement("span", null, userData === null || userData === void 0 ? void 0 : userData.user.fullName), userDetails && /*#__PURE__*/React__default.createElement("span", {
    className: "badge badge-" + (userDetails.type === ufinetWebFunctions.UserTypesEnum.INTERNAL_USER ? 'success' : userDetails.type === ufinetWebFunctions.UserTypesEnum.EXTERNAL_USER ? 'info' : 'secondary') + " fw-bolder fs-8 px-2 py-1 ms-2"
  }, intl.formatMessage({
    id: ufinetWebFunctions.userTypeMappings.get(userData.user.type)
  }))), /*#__PURE__*/React__default.createElement("a", {
    href: "#",
    className: "fw-bold text-muted text-hover-primary fs-7"
  }, userData === null || userData === void 0 ? void 0 : userData.username)))), /*#__PURE__*/React__default.createElement("div", {
    className: "separator my-2"
  }), /*#__PURE__*/React__default.createElement(Languages, null), /*#__PURE__*/React__default.createElement("div", {
    className: "menu-item px-5"
  }, /*#__PURE__*/React__default.createElement("a", {
    onClick: logout,
    className: "menu-link px-5"
  }, intl.formatMessage({
    id: 'AUTH.LOGOUT'
  }))));
};

const Quicklinks = () => {
  const intl = reactIntl.useIntl();
  const {
    userData
  } = React.useContext(ufinetWebFunctions.AuthContext);
  const roles = (userData === null || userData === void 0 ? void 0 : userData.authorities.map(authPattern => new ufinetWebFunctions.Authority(authPattern))) || [];
  const hasPortalAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityPortalBase);
  const hasAqsAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityQuotationBase);
  const hasGestionServiciosAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityGseBase);
  const hasGestionFacturasAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityGfaBase);
  const hasGestionTicketsAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityGtiBase);
  const hasFinanceAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityFinanceBase);
  const hasCommisionsAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityCommisionBase);
  const hasQrInventoryAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityNetwBase);
  const hasFtthAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityFTTHBase);
  const hasOfeAccess = roles.some(r => r.getBase() === ufinetWebFunctions.Authority.authorityOfferBase);
  const redirectTo = path => () => !path.includes(process.env.REACT_APP_URL || '') && window.open(path);
  const gridApplicationLinks = [hasPortalAccess && {
    name: 'PORTAL',
    description: 'QUICK_LINKS.PORTAL.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_PORTAL,
    icon: freeSolidSvgIcons.faHome
  }, hasAqsAccess && {
    name: 'AQS',
    description: 'QUICK_LINKS.AQS.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_AQS,
    icon: faMapLocationDot.faMapLocationDot
  }, hasGestionServiciosAccess && {
    name: 'GDS',
    description: 'QUICK_LINKS.GDS.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_GSE,
    icon: freeSolidSvgIcons.faLineChart
  }, hasGestionFacturasAccess && {
    name: 'GFA',
    description: 'QUICK_LINKS.GFA.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_GFA,
    icon: freeSolidSvgIcons.faFileInvoice
  }, hasFinanceAccess && {
    name: 'FACT',
    description: 'QUICK_LINKS.FACT.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_FINANCE,
    icon: freeSolidSvgIcons.faCoins
  }, hasCommisionsAccess && {
    name: 'COMM',
    description: 'QUICK_LINKS.COMM.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_COMMISIONS,
    icon: freeSolidSvgIcons.faMoneyBillTransfer
  }, hasGestionTicketsAccess && {
    name: 'GTI',
    description: 'QUICK_LINKS.GTI.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_GTI,
    icon: freeSolidSvgIcons.faTicket
  }, hasQrInventoryAccess && {
    name: 'QR',
    description: 'QUICK_LINKS.QR.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_QRINVENTORY,
    icon: freeSolidSvgIcons.faExchange
  }, hasFtthAccess && {
    name: 'FTTH',
    description: 'QUICK_LINKS.FTTH.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_FTTH,
    icon: freeSolidSvgIcons.faPlug
  }, hasOfeAccess && {
    name: 'OFE',
    description: 'QUICK_LINKS.OFE.DESCRIPTION',
    redirectTo: "" + process.env.REACT_APP_URL_OFE,
    icon: freeSolidSvgIcons.faFileInvoiceDollar
  }].filter(Boolean);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px",
    "data-kt-menu": "true"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "quick-links-image d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10",
    style: {
      backgroundImage: "url('" + ufinetWebFunctions.toAbsoluteUrl('/media/pictures/animated_shape.svg') + "')"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Logo",
    className: "h-80px logo",
    src: ufinetWebFunctions.toAbsoluteUrl('/media/logos/ufinet_logo_white.svg')
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row g-0"
  }, gridApplicationLinks.map((link, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index,
    className: "col-" + (index + 1 === gridApplicationLinks.length && gridApplicationLinks.length % 2 !== 0 ? 12 : 6)
  }, /*#__PURE__*/React__default.createElement("a", {
    href: link.redirectTo || '#',
    onClick: redirectTo(link.redirectTo),
    className: "d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom border-end"
  }, /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
    size: "3x",
    icon: link.icon
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "fs-5 fw-boldest text-primary mt-2"
  }, link.name), /*#__PURE__*/React__default.createElement("span", {
    className: "fs-7 text-gray-400"
  }, intl.formatMessage({
    id: link.description
  })))))));
};

const Topbar = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-stretch flex-shrink-0"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center ms-1 ms-lg-3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-attach": "parent",
    "data-kt-menu-placement": "bottom-end",
    "data-kt-menu-flip": "bottom"
  }, /*#__PURE__*/React__default.createElement(KTSVG, {
    path: ufinetWebFunctions.toAbsoluteUrl('/media/icons/duotune/general/gen025.svg'),
    className: "svg-icon-1"
  }), /*#__PURE__*/React__default.createElement(Quicklinks, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center ms-1 ms-lg-3",
    id: "kt_header_user_menu_toggle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-pointer symbol symbol-30px symbol-md-40px",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-attach": "parent",
    "data-kt-menu-placement": "bottom-end",
    "data-kt-menu-flip": "bottom"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: ufinetWebFunctions.toAbsoluteUrl('/media/avatars/default.png'),
    alt: "metronic"
  })), /*#__PURE__*/React__default.createElement(HeaderUserMenu, null)));
};

const HeaderWrapper = _ref => {
  let {
    asideMobile
  } = _ref;
  const easterRef = React.useRef();
  const [menuToggle, setMenuToggle] = React.useState(true);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EasterEggWrapper, {
    ref: easterRef
  }), /*#__PURE__*/React__default.createElement("div", {
    id: "kt_header",
    className: "header align-items-stretch shadow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container-fluid d-flex align-items-stretch justify-content-between"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center d-lg-none ms-n3 me-1",
    title: "Show aside menu"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px me-3",
    id: "kt_aside_mobile_toggle",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-attach": "parent",
    "data-kt-menu-placement": "bottom-end",
    "data-kt-menu-flip": "right",
    "data-kt-menu-permanent": "true",
    onClick: e => {
      if (!(e.target instanceof HTMLSpanElement)) {
        setMenuToggle(!menuToggle);
      }
    },
    "data-kt-menu-toggle": menuToggle
  }, asideMobile, /*#__PURE__*/React__default.createElement(KTSVG, {
    path: ufinetWebFunctions.toAbsoluteUrl('/media/icons/duotune/abstract/abs015.svg'),
    className: "svg-icon-2x toggle-btn"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "flex-grow-1"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center flex-grow-1 flex-lg-grow-0"
  }, /*#__PURE__*/React__default.createElement(MouseRecorder, {
    onComplete: () => {
      var _easterRef$current;
      return (_easterRef$current = easterRef.current) === null || _easterRef$current === void 0 ? void 0 : _easterRef$current.trigger();
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Logo",
    className: "h-100px logo",
    src: ufinetWebFunctions.toAbsoluteUrl('/media/logos/ufinet_logo_white.svg')
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-stretch justify-content-between flex-lg-grow-1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-stretch",
    id: "kt_header_nav"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-stretch flex-shrink-0"
  }, /*#__PURE__*/React__default.createElement(Topbar, null))))));
};

const PATH_DETAIL$3 = 'detail';
const DefaultTitle = _ref => {
  let {
    routerNameMap,
    routerLocation
  } = _ref;
  const {
    pathname
  } = routerLocation;
  const translate = ufinetWebFunctions.useTranslator();
  const [pathArray, setPathArray] = React.useState(['']);
  React.useEffect(() => {
    const array = pathname.split('/');
    array.shift();
    if (array.length > 1 && ufinetWebFunctions.compareStringIgnoreCase(array[array.length - 2], PATH_DETAIL$3)) {
      array.pop();
    }
    setPathArray(array);
  }, [pathname, translate]);
  const getSection = id => routerNameMap.get(id) ? translate(routerNameMap.get(id)) : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "kt_page_title",
    className: "page-title d-flex align-items-center flex-wrap me-3 mb-lg-0"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center text-primary my-1 fs-3"
  }, pathArray.map((section, index) => /*#__PURE__*/React__default.createElement("div", {
    key: section + "-" + index
  }, getSection(section) && (pathArray.length > 0 && index !== 0 && index !== pathArray.length - 1 ? /*#__PURE__*/React__default.createElement(reactRouterDom.Link, {
    to: [...pathArray].slice(0, index + 1).join('/'),
    className: "hover-underline-animation",
    key: "Title-section-" + index
  }, getSection(section)) : /*#__PURE__*/React__default.createElement("span", {
    key: "Title-section-" + index
  }, getSection(section))), getSection(pathArray[index + 1]) && index + 1 < pathArray.length && /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
    className: "mx-2",
    key: "Icon-section-" + index,
    icon: faAngleRight.faAngleRight
  })))));
};

const Toolbar = _ref => {
  let {
    routerNameMap
  } = _ref;
  const location = reactRouterDom.useLocation();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "toolbar border-bottom d-flex align-items-center shadow"
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "kt_toolbar_container",
    className: "container-fluid d-flex flex-stack"
  }, /*#__PURE__*/React__default.createElement(DefaultTitle, {
    routerLocation: location,
    routerNameMap: routerNameMap
  })));
};

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength$1 = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$3 = INCORRECT_RESULT || !properErrorOnNonWritableLength$1();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
_export({ target: 'Array', proto: true, arity: 1, forced: FORCED$3 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return arraySetLength(O, len + argCount);
  }
});

var floor$2 = Math.floor;
var charAt$4 = functionUncurryThis(''.charAt);
var replace$5 = functionUncurryThis(''.replace);
var stringSlice$4 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$5(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$4(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$4(str, 0, position);
      case "'": return stringSlice$4(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$4(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$2(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$4(ch, 1) : captures[f - 1] + charAt$4(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var max$2 = Math.max;
var min$2 = Math.min;
var concat$2 = functionUncurryThis([].concat);
var push$3 = functionUncurryThis([].push);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$5 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$3(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$2(min$2(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$3(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$2([matched], captures, position, S);
          if (namedCaptures !== undefined) push$3(replacerArgs, namedCaptures);
          replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$5(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$5(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var trim$1 = stringTrim.trim;


var $parseInt = global_1.parseInt;
var Symbol$3 = global_1.Symbol;
var ITERATOR$6 = Symbol$3 && Symbol$3.iterator;
var hex = /^[+-]?0x/i;
var exec$2 = functionUncurryThis(hex.exec);
var FORCED$4 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$6 && !fails(function () { $parseInt(Object(ITERATOR$6)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
  var S = trim$1(toString_1(string));
  return $parseInt(S, (radix >>> 0) || (exec$2(hex, S) ? 16 : 10));
} : $parseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt !== numberParseInt }, {
  parseInt: numberParseInt
});

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$3 = Math.max;
var min$3 = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$3(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$3(min, min$3(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains$3(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect$2(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$3(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$3(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max$3(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains$3(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$3(rect.top, accRect.top);
    accRect.right = min$3(rect.right, accRect.right);
    accRect.bottom = min$3(rect.bottom, accRect.bottom);
    accRect.left = max$3(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$3(min, tetherMin) : min, offset, tether ? max$3(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var trim$2 = stringTrim.trim;


var charAt$5 = functionUncurryThis(''.charAt);
var $parseFloat = global_1.parseFloat;
var Symbol$4 = global_1.Symbol;
var ITERATOR$7 = Symbol$4 && Symbol$4.iterator;
var FORCED$5 = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$7 && !fails(function () { $parseFloat(Object(ITERATOR$7)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$5 ? function parseFloat(string) {
  var trimmedString = trim$2(toString_1(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt$5(trimmedString, 0) === '-' ? -0 : result;
} : $parseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
_export({ global: true, forced: parseFloat !== numberParseFloat }, {
  parseFloat: numberParseFloat
});

function getObjectPropertyValueByKey(obj, key) {
  const map = new Map(Object.entries(obj));
  if (obj[key] && map) {
    return map.get(key);
  }
}
function getUniqueIdWithPrefix(prefix) {
  const result = Math.floor(Math.random() * new Date().getTime()).toString();
  if (!prefix) {
    return result;
  }
  return "" + prefix + result;
}
function stringSnakeToCamel(str) {
  return str.replace(/(\-\w)/g, function (m) {
    return m[1].toUpperCase();
  });
}
function toJSON(value) {
  if (typeof value !== 'string') {
    return value;
  }
  if (!value) {
    return undefined;
  }
  const result = value.toString().split('').map(el => el !== "'" ? el : '"').join('');
  const jsonStr = result.replace(/(\w+:)|(\w+ :)/g, function (matched) {
    return '"' + matched.substring(0, matched.length - 1) + '":';
  });
  try {
    return JSON.parse(jsonStr);
  } catch (_unused) {
    return undefined;
  }
}

class DOMEventHandlerUtil {
  static on(element, selector, eventName, callBack) {
    const eventId = getUniqueIdWithPrefix('DOMEvent');
    DOMEventHandlerUtil.store.set(eventId, e => {
      const targets = element.querySelectorAll(selector);
      let target = e.target;
      while (target && target !== element) {
        for (let i = 0; i < targets.length; i++) {
          if (target === targets[i]) {
            callBack.call(target, e);
          }
        }
        if (target.parentElement) {
          target = target.parentElement;
        } else {
          target = null;
        }
      }
    });
    element.addEventListener(eventName, DOMEventHandlerUtil.store.get(eventId));
    return eventId;
  }
  static off(element, eventName, eventId) {
    const funcFromStore = DOMEventHandlerUtil.store.get(eventId);
    if (!funcFromStore) {
      return;
    }
    element.removeEventListener(eventName, funcFromStore);
    DOMEventHandlerUtil.store.delete(eventId);
  }
  static one(element, eventName, callBack) {
    element.addEventListener(eventName, function calee(e) {
      if (e.target && e.target.removeEventListener) {
        e.target.removeEventListener(e.type, calee);
      }
      if (element && e && e.currentTarget) {
        e.currentTarget.removeEventListener(e.type, calee);
      }
      return callBack(e);
    });
  }
}
DOMEventHandlerUtil.store = new Map();

class ElementStyleUtil {
  static set(element, property, value, important) {
    if (important) {
      element.style.setProperty(property, value, 'important');
    } else {
      element.style.setProperty(property, value);
    }
  }
  static get(element, attributeName) {
    return element.style.getPropertyValue(attributeName);
  }
  static remove(element, attibuteName) {
    element.style.removeProperty(attibuteName);
  }
}

class ElementAnimateUtil {
  static animate(from, to, duration, update, complete) {
    const easings = {
      linear: function linear(t, b, c, d) {
        return c * t / d + b;
      }
    };
    if (!complete) {
      complete = function complete() {};
    }
    const change = to - from;
    function loop(timestamp) {
      const time = (timestamp || +new Date()) - start;
      if (time >= 0) {
        update(easings.linear(time, from, change, duration));
      }
      if (time >= 0 && time >= duration) {
        update(to);
        if (complete) {
          complete();
        }
      } else {
        window.requestAnimationFrame(loop);
      }
    }
    update(from);
    const start = window.performance && window.performance.now ? window.performance.now() : +new Date();
    window.requestAnimationFrame(loop);
  }
  static animateClass(element, animationName, callBack) {
    const animateClasses = animationName.split(' ');
    animateClasses.forEach(cssClass => element.classList.add(cssClass));
    DOMEventHandlerUtil.one(element, 'animationend', function () {
      animateClasses.forEach(cssClass => element.classList.remove(cssClass));
    });
    if (callBack) {
      DOMEventHandlerUtil.one(element, 'animationend', callBack);
    }
  }
  static transitionEnd(element, callBack) {
    DOMEventHandlerUtil.one(element, 'transitionend', callBack);
  }
  static animationEnd(element, callBack) {
    DOMEventHandlerUtil.one(element, 'animationend', callBack);
  }
  static animationDelay(element, value) {
    ElementStyleUtil.set(element, 'animation-delay', value);
  }
  static animationDuration(element, value) {
    ElementStyleUtil.set(element, 'animation-duration', value);
  }
  static getElementOffset(el) {
    if (!el.getClientRects().length) {
      return {
        top: 0,
        left: 0
      };
    }
    const rect = el.getBoundingClientRect();
    const win = el.ownerDocument.defaultView;
    if (win) {
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    }
    return rect;
  }
  static scrollTo(element, offset, duration) {
    if (duration === void 0) {
      duration = 500;
    }
    let targetPos = element ? ElementAnimateUtil.getElementOffset(element).top : 0;
    let scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset) {
      scrollPos += offset;
      targetPos = targetPos - offset;
    }
    const from = scrollPos;
    const to = targetPos;
    ElementAnimateUtil.animate(from, to, duration, function (value) {
      document.documentElement.scrollTop = value;
      document.body.scrollTop = value;
    });
  }
  static scrollTop(offset, duration) {
    ElementAnimateUtil.scrollTo(null, offset, duration);
  }
}

class DataUtil {
  static set(instance, key, data) {
    if (!instance) {
      return;
    }
    const instanceData = DataUtil.store.get(instance);
    if (!instanceData) {
      const newMap = new Map().set(key, data);
      DataUtil.store.set(instance, newMap);
      return;
    }
    instanceData.set(key, data);
  }
  static get(instance, key) {
    const instanceData = DataUtil.store.get(instance);
    if (!instanceData) {
      return;
    }
    return instanceData.get(key);
  }
  static remove(instance, key) {
    const instanceData = DataUtil.store.get(instance);
    if (!instanceData) {
      return;
    }
    instanceData.delete(key);
  }
  static has(instance, key) {
    const instanceData = DataUtil.store.get(instance);
    if (instanceData) {
      return instanceData.has(key);
    }
    return false;
  }
  static getAllInstancesByKey(key) {
    const result = [];
    DataUtil.store.forEach(val => {
      val.forEach((v, k) => {
        if (k === key) {
          result.push(v);
        }
      });
    });
    return result;
  }
}
DataUtil.store = new Map();

function getCSS(el, styleProp) {
  const defaultView = (el.ownerDocument || document).defaultView;
  if (!defaultView) {
    return '';
  }
  styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
  return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
}
function getCSSVariableValue(variableName) {
  let hex = getComputedStyle(document.documentElement).getPropertyValue(variableName);
  if (hex && hex.length > 0) {
    hex = hex.trim();
  }
  return hex;
}
function getElementActualCss(el, prop, cache) {
  let css = '';
  if (!el.getAttribute('kt-hidden-' + prop) || cache === false) {
    let value;
    css = el.style.cssText;
    el.style.cssText = 'position: absolute; visibility: hidden; display: block;';
    if (prop === 'width') {
      value = el.offsetWidth;
    } else if (prop === 'height') {
      value = el.offsetHeight;
    }
    el.style.cssText = css;
    if (value !== undefined) {
      el.setAttribute('kt-hidden-' + prop, value.toString());
      return parseFloat(value.toString());
    }
    return 0;
  } else {
    const attributeValue = el.getAttribute('kt-hidden-' + prop);
    if (attributeValue || attributeValue === '0') {
      return parseFloat(attributeValue);
    }
  }
}
function getElementActualHeight(el) {
  return getElementActualCss(el, 'height', false);
}
function getElementActualWidth(el, _cache) {
  return getElementActualCss(el, 'width', false);
}
function getElementIndex(element) {
  if (element.parentNode) {
    const c = element.parentNode.children;
    for (let i = 0; i < c.length; i++) {
      if (c[i] === element) return i;
    }
  }
  return -1;
}
function getElementMatches(element, selector) {
  const p = Element.prototype;
  const f = p.matches || p.webkitMatchesSelector;
  if (element && element.tagName) {
    return f.call(element, selector);
  } else {
    return false;
  }
}
function getElementOffset(el) {
  return ElementAnimateUtil.getElementOffset(el);
}
function getElementParents(element, selector) {
  if (!Element.prototype.matches) {
    Element.prototype.matches = function (s) {
      const matches = (document || this.ownerDocument).querySelectorAll(s);
      let i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }
  const parents = [];
  let el = element;
  for (; el && el !== document.body; el = el.parentElement) {
    if (selector) {
      if (el.matches(selector)) {
        parents.push(el);
      }
      continue;
    }
    parents.push(el);
  }
  return parents;
}
function getHighestZindex(el) {
  let bufferNode = el;
  let buffer = el;
  while (bufferNode && bufferNode !== document) {
    const position = buffer.style.getPropertyValue('position');
    if (position === 'absolute' || position === 'relative' || position === 'fixed') {
      const value = parseInt(buffer.style.getPropertyValue('z-index'));
      if (!isNaN(value) && value !== 0) {
        return value;
      }
    }
    bufferNode = bufferNode.parentNode;
    buffer = bufferNode;
  }
  return null;
}
function getScrollTop() {
  return (document.scrollingElement || document.documentElement).scrollTop;
}
function getViewPort() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}
function insertAfterElement(el, referenceNode) {
  var _referenceNode$parent;
  return (_referenceNode$parent = referenceNode.parentNode) === null || _referenceNode$parent === void 0 ? void 0 : _referenceNode$parent.insertBefore(el, referenceNode.nextSibling);
}
function isElementHasClasses(element, classesStr) {
  const classes = classesStr.split(' ');
  for (let i = 0; i < classes.length; i++) {
    if (!element.classList.contains(classes[i])) {
      return false;
    }
  }
  return true;
}
function isVisibleElement(element) {
  return !(element.offsetWidth === 0 && element.offsetHeight === 0);
}
function throttle(timer, func, delay) {
  if (timer) {
    return;
  }
  timer = window.setTimeout(function () {
    func();
    timer = undefined;
  }, delay);
}
function getElementChildren(element, selector) {
  if (!element || !element.childNodes) {
    return null;
  }
  const result = [];
  for (let i = 0; i < element.childNodes.length; i++) {
    const child = element.childNodes[i];
    if (child.nodeType === 1 && getElementMatches(child, selector)) {
      result.push(child);
    }
  }
  return result;
}
function getElementChild(element, selector) {
  const children = getElementChildren(element, selector);
  return children ? children[0] : null;
}
function isMobileDevice() {
  let test = getViewPort().width < +getBreakpoint('lg');
  if (!test) {
    test = navigator.userAgent.match(/iPad/i) !== null;
  }
  return test;
}
function slide(el, dir, speed, callback) {
  if (!el || dir === 'up' && !isVisibleElement(el) || dir === 'down' && isVisibleElement(el)) {
    return;
  }
  speed = speed || 600;
  const calcHeight = getElementActualHeight(el);
  let calcPaddingTop = 0;
  let calcPaddingBottom = 0;
  if (ElementStyleUtil.get(el, 'padding-top') && DataUtil.get(el, 'slide-padding-top') !== true) {
    DataUtil.set(el, 'slide-padding-top', ElementStyleUtil.get(el, 'padding-top'));
  }
  if (ElementStyleUtil.get(el, 'padding-bottom') && !DataUtil.has(el, 'slide-padding-bottom')) {
    DataUtil.set(el, 'slide-padding-bottom', ElementStyleUtil.get(el, 'padding-bottom'));
  }
  if (DataUtil.has(el, 'slide-padding-top')) {
    calcPaddingTop = parseInt(DataUtil.get(el, 'slide-padding-top'));
  }
  if (DataUtil.has(el, 'slide-padding-bottom')) {
    calcPaddingBottom = parseInt(DataUtil.get(el, 'slide-padding-bottom'));
  }
  if (dir === 'up') {
    el.style.cssText = 'display: block; overflow: hidden;';
    if (calcPaddingTop) {
      ElementAnimateUtil.animate(0, calcPaddingTop, speed, function (value) {
        el.style.paddingTop = calcPaddingTop - value + 'px';
      });
    }
    if (calcPaddingBottom) {
      ElementAnimateUtil.animate(0, calcPaddingBottom, speed, function (value) {
        el.style.paddingBottom = calcPaddingBottom - value + 'px';
      });
    }
    ElementAnimateUtil.animate(0, calcHeight || 0, speed, function (value) {
      el.style.height = (calcHeight || 0) - value + 'px';
    }, function () {
      el.style.height = '';
      el.style.display = 'none';
      if (typeof callback === 'function') {
        callback();
      }
    });
  } else if (dir === 'down') {
    el.style.cssText = 'display: block; overflow: hidden;';
    if (calcPaddingTop) {
      ElementAnimateUtil.animate(0, calcPaddingTop, speed, function (value) {
        el.style.paddingTop = value + 'px';
      }, function () {
        el.style.paddingTop = '';
      });
    }
    if (calcPaddingBottom) {
      ElementAnimateUtil.animate(0, calcPaddingBottom, speed, function (value) {
        el.style.paddingBottom = value + 'px';
      }, function () {
        el.style.paddingBottom = '';
      });
    }
    ElementAnimateUtil.animate(0, calcHeight || 0, speed, function (value) {
      el.style.height = value + 'px';
    }, function () {
      el.style.height = '';
      el.style.display = '';
      el.style.overflow = '';
      if (typeof callback === 'function') {
        callback();
      }
    });
  }
}
function slideUp(el, speed, callback) {
  slide(el, 'up', speed, callback);
}
function slideDown(el, speed, callback) {
  slide(el, 'down', speed, callback);
}
function getBreakpoint(breakpoint) {
  let value = getCSSVariableValue('--bs-' + breakpoint);
  if (value) {
    value = parseInt(value.trim());
  }
  return value;
}
function getAttributeValueByBreakpoint(incomingAttr) {
  const value = toJSON(incomingAttr);
  if (typeof value !== 'object') {
    return incomingAttr;
  }
  const width = getViewPort().width;
  let resultKey;
  let resultBreakpoint = -1;
  let breakpoint;
  for (const key in value) {
    if (key === 'default') {
      breakpoint = 0;
    } else {
      breakpoint = getBreakpoint(key) ? +getBreakpoint(key) : parseInt(key);
    }
    if (breakpoint <= width && breakpoint > resultBreakpoint) {
      resultKey = key;
      resultBreakpoint = breakpoint;
    }
  }
  return resultKey ? getObjectPropertyValueByKey(value, resultKey) : value;
}
function colorLighten(color, amount) {
  const addLight = (_color, _amount) => {
    const cc = parseInt(_color, 16) + _amount;
    const cNum = cc > 255 ? 255 : cc;
    const c = cNum.toString(16).length > 1 ? cNum.toString(16) : "0" + cNum.toString(16);
    return c;
  };
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt((255 * amount / 100).toString());
  return color = "#" + addLight(color.substring(0, 2), amount) + addLight(color.substring(2, 4), amount) + addLight(color.substring(4, 6), amount);
}
function colorDarken(color, amount) {
  const subtractLight = (_color, _amount) => {
    const cc = parseInt(color, 16) - amount;
    const cNum = cc < 0 ? 0 : cc;
    const c = cNum.toString(16).length > 1 ? cNum.toString(16) : "0" + cNum.toString(16);
    return c;
  };
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt((255 * amount / 100).toString());
  return color = "#" + subtractLight(color.substring(0, 2)) + subtractLight(color.substring(2, 4)) + subtractLight(color.substring(4, 6));
}

var _class$1;
class EventHandlerUtil {
  static setEventMetasByName(name, metas) {
    EventHandlerUtil.store.set(name, metas);
  }
  static getEventMetasByName(name) {
    return EventHandlerUtil.store.get(name);
  }
  static setEventMetaByNameAndHandlerId(name, handlerId, meta) {
    let metas = EventHandlerUtil.getEventMetasByName(name);
    if (!metas) {
      metas = new Map();
    }
    metas.set(handlerId, meta);
    EventHandlerUtil.setEventMetasByName(name, metas);
  }
  static getEventsMetaByHandlerId(name, handlerId) {
    const metas = EventHandlerUtil.store.get(name);
    if (!metas) {
      return;
    }
    return metas.get(handlerId);
  }
  static setFiredByNameAndHandlerId(name, handerId, fired) {
    const meta = EventHandlerUtil.getEventsMetaByHandlerId(name, handerId);
    if (!meta) {
      return;
    }
    meta.fired = fired;
    EventHandlerUtil.setEventMetaByNameAndHandlerId(name, handerId, meta);
  }
  static addEvent(element, name, callback, one) {
    if (one === void 0) {
      one = false;
    }
    const handlerId = getUniqueIdWithPrefix('event');
    DataUtil.set(element, name, handlerId);
    const meta = {
      name: name,
      callback: callback,
      one: one,
      fired: false
    };
    EventHandlerUtil.setEventMetaByNameAndHandlerId(name, handlerId, meta);
  }
  static removeEvent(element, name) {
    const handlerId = DataUtil.get(element, name);
    if (!handlerId) {
      return;
    }
    const metas = EventHandlerUtil.getEventMetasByName(name);
    if (!metas) {
      return;
    }
    metas.delete(handlerId);
    EventHandlerUtil.setEventMetasByName(name, metas);
  }
  static trigger(element, name, target, e) {
    if (DataUtil.has(element, name)) {
      const handlerId = DataUtil.get(element, name);
      if (!handlerId) {
        return undefined;
      }
      const handler = EventHandlerUtil.getEventsMetaByHandlerId(name, handlerId);
      if (handler) {
        if (handler.name === name) {
          if (handler.one) {
            if (!handler.fired) {
              EventHandlerUtil.setFiredByNameAndHandlerId(name, handlerId, true);
              return handler.callback.call(this, target, e);
            }
          } else {
            return handler.callback.call(this, target, e);
          }
        }
      }
    }
    return null;
  }
  static one(element, name, callBack) {
    EventHandlerUtil.addEvent(element, name, callBack, true);
  }
  static off(element, name) {
    EventHandlerUtil.removeEvent(element, name);
  }
}
_class$1 = EventHandlerUtil;
EventHandlerUtil.store = new Map();
EventHandlerUtil.on = function (element, name, callBack) {
  _class$1.addEvent(element, name, callBack, false);
};

var _class$2;
const defaultMenuOptions = {
  dropdown: {
    hoverTimeout: 200,
    zindex: 105
  },
  accordion: {
    slideSpeed: 250,
    expand: false
  }
};
class MenuComponent {
  constructor(_element2, options) {
    this.element = void 0;
    this.options = void 0;
    this.instanceUid = void 0;
    this.triggerElement = null;
    this._setTriggerElement = () => {
      const target = document.querySelector("[data-kt-menu-target=\"#" + this.element.getAttribute('id') + "\"");
      if (target) {
        this.triggerElement = target;
      } else if (this.element.closest('[data-kt-menu-trigger]')) {
        this.triggerElement = this.element.closest('[data-kt-menu-trigger]');
      } else if (this.element.parentNode && getElementChild(this.element.parentNode, '[data-kt-menu-trigger]')) {
        const child = getElementChild(this.element.parentNode, '[data-kt-menu-trigger]');
        if (child) {
          this.triggerElement = child;
        }
      }
      if (this.triggerElement) {
        DataUtil.set(this.triggerElement, 'menu', this);
      }
    };
    this._isTriggerElement = item => {
      return this.triggerElement === item;
    };
    this._getItemOption = (item, name) => {
      let value = null;
      if (item && item.hasAttribute('data-kt-menu-' + name)) {
        const attr = item.getAttribute('data-kt-menu-' + name) || '';
        value = getAttributeValueByBreakpoint(attr);
        if (value !== null && String(value) === 'true') {
          value = true;
        } else if (value !== null && String(value) === 'false') {
          value = false;
        }
      }
      return value;
    };
    this._getItemElement = _element => {
      if (this._isTriggerElement(_element)) {
        return _element;
      }
      if (_element.hasAttribute('data-kt-menu-trigger')) {
        return _element;
      }
      const itemElement = DataUtil.get(_element, 'item');
      if (itemElement) {
        return itemElement;
      }
      const item = _element.closest('.menu-item[data-kt-menu-trigger]');
      if (item) {
        return item;
      }
      const sub = _element.closest('.menu-sub');
      if (sub) {
        const subItem = DataUtil.get(sub, 'item');
        if (subItem) {
          return subItem;
        }
      }
    };
    this._getItemParentElement = item => {
      const sub = item.closest('.menu-sub');
      if (!sub) {
        return null;
      }
      const subItem = DataUtil.get(sub, 'item');
      if (subItem) {
        return subItem;
      }
      const parentItem = sub.closest('.menu-item[data-kt-menu-trigger]');
      if (sub && parentItem) {
        return parentItem;
      }
      return null;
    };
    this._getItemParentElements = item => {
      const parents = [];
      let parent;
      let i = 0;
      let buffer = item;
      do {
        parent = this._getItemParentElement(buffer);
        if (parent) {
          parents.push(parent);
          buffer = parent;
        }
        i++;
      } while (parent !== null && i < 20);
      if (this.triggerElement) {
        parents.unshift(this.triggerElement);
      }
      return parents;
    };
    this._getDropdownPopperConfig = item => {
      const placementOption = this._getItemOption(item, 'placement');
      let placement = 'right';
      if (placementOption) {
        placement = placementOption;
      }
      const offsetValue = this._getItemOption(item, 'offset');
      const offset = offsetValue ? offsetValue.toString().split(',') : [];
      const strategy = this._getItemOption(item, 'overflow') === true ? 'absolute' : 'fixed';
      return {
        placement: placement,
        strategy: strategy,
        modifiers: [{
          name: 'offset',
          options: {
            offset: offset
          }
        }, {
          name: 'preventOverflow'
        }, {
          name: 'flip',
          options: {
            flipVariations: false
          }
        }]
      };
    };
    this._getItemChildElement = item => {
      let selector = item;
      const subItem = DataUtil.get(item, 'sub');
      if (subItem) {
        selector = subItem;
      }
      if (selector) {
        const element = selector.querySelector('.menu-item[data-kt-menu-trigger]');
        if (element) {
          return element;
        }
      }
      return null;
    };
    this._getItemChildElements = item => {
      const children = [];
      let child;
      let i = 0;
      let buffer = item;
      do {
        child = this._getItemChildElement(buffer);
        if (child) {
          children.push(child);
          buffer = child;
        }
        i++;
      } while (child !== null && i < 20);
      return children;
    };
    this._getItemSubElement = item => {
      if (!item) {
        return null;
      }
      if (this._isTriggerElement(item)) {
        return this.element;
      }
      if (item.classList.contains('menu-sub')) {
        return item;
      } else if (DataUtil.has(item, 'sub')) {
        return DataUtil.get(item, 'sub');
      } else {
        return getElementChild(item, '.menu-sub');
      }
    };
    this._getCss = (el, styleProp) => {
      const defaultView = (el.ownerDocument || document).defaultView;
      if (!defaultView) {
        return '';
      }
      styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
      return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    };
    this._getItemSubType = element => {
      const sub = this._getItemSubElement(element);
      if (sub && parseInt(this._getCss(sub, 'z-index')) > 0) {
        return 'dropdown';
      } else {
        return 'accordion';
      }
    };
    this._isItemSubShown = item => {
      const sub = this._getItemSubElement(item);
      if (sub) {
        if (this._getItemSubType(item) === 'dropdown') {
          return sub.classList.contains('show') && sub.hasAttribute('data-popper-placement');
        } else {
          return item.classList.contains('show');
        }
      }
      return false;
    };
    this._isItemDropdownPermanent = item => {
      return this._getItemOption(item, 'permanent') === true;
    };
    this._isItemParentShown = item => {
      return getElementParents(item, '.menu-item.show').length > 0;
    };
    this._isItemSubElement = item => {
      return item.classList.contains('menu-sub');
    };
    this._hasItemSub = item => {
      return item.classList.contains('menu-item') && item.hasAttribute('data-kt-menu-trigger');
    };
    this._getItemLinkElement = item => {
      return getElementChild(item, '.menu-link');
    };
    this._getItemToggleElement = item => {
      if (this.triggerElement) {
        return this.triggerElement;
      }
      return this._getItemLinkElement(item);
    };
    this._showDropdown = item => {
      if (EventHandlerUtil.trigger(this.element, 'kt.menu.dropdown.show') === false) {
        return;
      }
      MenuComponent.hideDropdowns(item);
      const sub = this._getItemSubElement(item);
      const width = this._getItemOption(item, 'width');
      const height = this._getItemOption(item, 'height');
      let zindex = this.options.dropdown.zindex;
      const parentZindex = getHighestZindex(item);
      if (parentZindex !== null && parentZindex >= zindex) {
        zindex = parentZindex + 1;
      }
      if (zindex) {
        ElementStyleUtil.set(sub, 'z-index', zindex);
      }
      if (width) {
        ElementStyleUtil.set(sub, 'width', width);
      }
      if (height) {
        ElementStyleUtil.set(sub, 'height', height);
      }
      this.initDropdownPopper(item, sub);
      item.classList.add('show');
      item.classList.add('menu-dropdown');
      sub.classList.add('show');
      if (this._getItemOption(item, 'overflow') === true) {
        document.body.appendChild(sub);
        DataUtil.set(item, 'sub', sub);
        DataUtil.set(sub, 'item', item);
        DataUtil.set(sub, 'menu', this);
      } else {
        DataUtil.set(sub, 'item', item);
      }
      const backdropElement = document.querySelector('#mobile-backdrop');
      if (backdropElement) {
        backdropElement.classList.add('show');
      }
      EventHandlerUtil.trigger(this.element, 'kt.menu.dropdown.shown');
    };
    this.initDropdownPopper = (item, sub) => {
      let reference;
      const attach = this._getItemOption(item, 'attach');
      if (attach) {
        if (attach === 'parent') {
          reference = item.parentNode;
        } else {
          reference = document.querySelector(attach);
        }
      } else {
        reference = item;
      }
      if (reference) {
        const popper = createPopper(reference, sub, this._getDropdownPopperConfig(item));
        DataUtil.set(item, 'popper', popper);
      }
    };
    this._hideDropdown = item => {
      if (EventHandlerUtil.trigger(this.element, 'kt.menu.dropdown.hide') === false) {
        return;
      }
      const sub = this._getItemSubElement(item);
      ElementStyleUtil.set(sub, 'z-index', '');
      ElementStyleUtil.set(sub, 'width', '');
      ElementStyleUtil.set(sub, 'height', '');
      item.classList.remove('show');
      item.classList.remove('menu-dropdown');
      sub.classList.remove('show');
      if (this._getItemOption(item, 'overflow') === true) {
        if (item.classList.contains('menu-item')) {
          item.appendChild(sub);
        } else {
          insertAfterElement(this.element, item);
        }
        DataUtil.remove(item, 'sub');
        DataUtil.remove(sub, 'item');
        DataUtil.remove(sub, 'menu');
      }
      if (DataUtil.has(item, 'popper') === true) {
        DataUtil.get(item, 'popper').destroy();
        DataUtil.remove(item, 'popper');
      }
      this.destroyDropdownPopper(item);
      EventHandlerUtil.trigger(this.element, 'kt.menu.dropdown.hidden');
      const backdropElement = document.querySelector('#mobile-backdrop');
      if (backdropElement) {
        backdropElement.classList.remove('show');
      }
    };
    this.destroyDropdownPopper = item => {
      if (DataUtil.has(item, 'popper') === true) {
        DataUtil.get(item, 'popper').destroy();
        DataUtil.remove(item, 'popper');
      }
      EventHandlerUtil.trigger(this.element, 'kt.menu.dropdown.hidden');
    };
    this._showAccordion = item => {
      if (EventHandlerUtil.trigger(this.element, 'kt.menu.accordion.show') === false) {
        return;
      }
      if (this.options.accordion.expand === false) {
        this._hideAccordions(item);
      }
      if (DataUtil.has(item, 'popper') === true) {
        this._hideDropdown(item);
      }
      item.classList.add('hover');
      item.classList.add('showing');
      const subElement = this._getItemSubElement(item);
      if (subElement) {
        const sub = subElement;
        slideDown(sub, this.options.accordion.slideSpeed, () => {
          item.classList.remove('showing');
          item.classList.add('show');
          sub.classList.add('show');
          EventHandlerUtil.trigger(this.element, 'kt.menu.accordion.shown');
        });
      }
    };
    this._hideAccordion = item => {
      if (EventHandlerUtil.trigger(this.element, 'kt.menu.accordion.hide') === false) {
        return;
      }
      const sub = this._getItemSubElement(item);
      item.classList.add('hiding');
      if (sub) {
        slideUp(sub, this.options.accordion.slideSpeed, () => {
          item.classList.remove('hiding');
          item.classList.remove('show');
          sub.classList.remove('show');
          item.classList.remove('hover');
          EventHandlerUtil.trigger(this.element, 'kt.menu.accordion.hidden');
        });
      }
    };
    this._hideAccordions = item => {
      const itemsToHide = this.element.querySelectorAll('.show[data-kt-menu-trigger]');
      if (itemsToHide && itemsToHide.length > 0) {
        for (let i = 0, len = itemsToHide.length; i < len; i++) {
          const itemToHide = itemsToHide[i];
          if (this._getItemSubType(itemToHide) === 'accordion' && itemToHide !== item && item.contains(itemToHide) === false && itemToHide.contains(item) === false) {
            this._hideAccordion(itemToHide);
          }
        }
      }
    };
    this._reset = item => {
      if (this._hasItemSub(item) === false) {
        return;
      }
      const sub = this._getItemSubElement(item);
      if (DataUtil.has(item, 'type') && DataUtil.get(item, 'type') !== this._getItemSubType(item)) {
        item.classList.remove('hover');
        item.classList.remove('show');
        item.classList.remove('show');
        if (sub && sub.removeClass) {
          sub.removeClass(sub, 'show');
        }
      }
    };
    this._update = () => {
      const items = this.element.querySelectorAll('.menu-item[data-kt-menu-trigger]');
      items.forEach(el => this._reset(el));
    };
    this._hide = item => {
      if (!item) {
        return;
      }
      if (this._isItemSubShown(item) === false) {
        return;
      }
      if (this._getItemSubType(item) === 'dropdown') {
        this._hideDropdown(item);
      } else if (this._getItemSubType(item) === 'accordion') {
        this._hideAccordion(item);
      }
    };
    this._show = item => {
      if (!item) {
        return;
      }
      if (this._isItemSubShown(item) === true) {
        return;
      }
      if (this._getItemSubType(item) === 'dropdown') {
        this._showDropdown(item);
      } else if (this._getItemSubType(item) === 'accordion') {
        this._showAccordion(item);
      }
      DataUtil.set(item, 'type', this._getItemSubType(item));
    };
    this._toggle = item => {
      if (!item) {
        return;
      }
      if (this._isItemSubShown(item) === true) {
        this._hide(item);
      } else {
        this._show(item);
      }
    };
    this._mouseout = (element, _e) => {
      const item = this._getItemElement(element);
      if (!item) {
        return;
      }
      if (this._getItemOption(item, 'trigger') !== 'hover') {
        return;
      }
      const timeout = setTimeout(() => {
        if (DataUtil.get(item, 'hover') === '1') {
          this._hide(item);
        }
      }, this.options.dropdown.hoverTimeout);
      DataUtil.set(item, 'hover', '1');
      DataUtil.set(item, 'timeout', timeout);
    };
    this._mouseover = (element, _e) => {
      const item = this._getItemElement(element);
      if (!item) {
        return;
      }
      if (this._getItemOption(item, 'trigger') !== 'hover') {
        return;
      }
      if (DataUtil.get(item, 'hover') === '1') {
        clearTimeout(DataUtil.get(item, 'timeout'));
        DataUtil.remove(item, 'hover');
        DataUtil.remove(item, 'timeout');
      }
      this._show(item);
    };
    this._dismiss = (element, _e) => {
      const item = this._getItemElement(element);
      const items = this._getItemChildElements(item);
      const itemSubType = this._getItemSubType(item);
      if (item !== null && itemSubType === 'dropdown') {
        this._hide(item);
        if (items.length > 0) {
          for (let i = 0, len = items.length; i < len; i++) {
            if (items[i] !== null && this._getItemSubType(items[i]) === 'dropdown') {
              this._hide(items[i]);
            }
          }
        }
      }
    };
    this._link = (_element, _e) => {
      if (EventHandlerUtil.trigger(this.element, 'kt.menu.link.click') === false) {
        return;
      }
      MenuComponent.hideDropdowns(undefined);
      EventHandlerUtil.trigger(this.element, 'kt.menu.link.clicked');
    };
    this._click = (element, e) => {
      e.preventDefault();
      const item = this._getItemElement(element);
      if (this._getItemOption(item, 'trigger') !== 'click') {
        return;
      }
      if (this._getItemOption(item, 'toggle') === false) {
        this._show(item);
      } else {
        this._toggle(item);
      }
    };
    this.click = (element, e) => {
      return this._click(element, e);
    };
    this.link = (element, e) => {
      return this._link(element, e);
    };
    this.dismiss = (element, e) => {
      return this._dismiss(element, e);
    };
    this.mouseover = (element, e) => {
      return this._mouseover(element, e);
    };
    this.mouseout = (element, e) => {
      return this._mouseout(element, e);
    };
    this.getItemTriggerType = item => {
      return this._getItemOption(item, 'trigger');
    };
    this.getItemSubType = element => {
      return this._getItemSubType(element);
    };
    this.show = item => {
      return this._show(item);
    };
    this.hide = item => {
      return this._hide(item);
    };
    this.reset = item => {
      return this._reset(item);
    };
    this.update = () => {
      return this._update();
    };
    this.getElement = () => {
      return this.element;
    };
    this.getItemLinkElement = item => {
      return this._getItemLinkElement(item);
    };
    this.getItemToggleElement = item => {
      return this._getItemToggleElement(item);
    };
    this.getItemSubElement = item => {
      return this._getItemSubElement(item);
    };
    this.getItemParentElements = item => {
      return this._getItemParentElements(item);
    };
    this.isItemSubShown = item => {
      return this._isItemSubShown(item);
    };
    this.isItemParentShown = item => {
      return this._isItemParentShown(item);
    };
    this.getTriggerElement = () => {
      return this.triggerElement;
    };
    this.isItemDropdownPermanent = item => {
      return this._isItemDropdownPermanent(item);
    };
    this.hideAccordions = item => {
      return this._hideAccordions(item);
    };
    this.on = (name, handler) => {
      return EventHandlerUtil.on(this.element, name, handler);
    };
    this.one = (name, handler) => {
      return EventHandlerUtil.one(this.element, name, handler);
    };
    this.off = name => {
      return EventHandlerUtil.off(this.element, name);
    };
    this.element = _element2;
    this.options = Object.assign(defaultMenuOptions, options);
    this.instanceUid = getUniqueIdWithPrefix('menu');
    this._setTriggerElement();
    this._update();
    DataUtil.set(this.element, 'menu', this);
    return this;
  }
}
_class$2 = MenuComponent;
MenuComponent.getInstance = element => {
  const elementMenu = DataUtil.get(element, 'menu');
  if (elementMenu) {
    return elementMenu;
  }
  const menu = element.closest('.menu');
  if (menu) {
    const menuData = DataUtil.get(menu, 'menu');
    if (menuData) {
      return menuData;
    }
  }
  if (element.classList.contains('menu-link')) {
    const sub = element.closest('.menu-sub');
    if (sub) {
      const subMenu = DataUtil.get(sub, 'menu');
      if (subMenu) {
        return subMenu;
      }
    }
  }
  return null;
};
MenuComponent.hideDropdowns = skip => {
  const items = document.querySelectorAll('.show.menu-dropdown[data-kt-menu-trigger]');
  if (items && items.length > 0) {
    for (let i = 0, len = items.length; i < len; i++) {
      const item = items[i];
      const menu = _class$2.getInstance(item);
      if (menu && menu.getItemSubType(item) === 'dropdown') {
        if (skip) {
          if (menu.getItemSubElement(item).contains(skip) === false && item.contains(skip) === false && item !== skip) {
            menu.hide(item);
          }
        } else {
          menu.hide(item);
        }
      }
    }
  }
};
MenuComponent.updateDropdowns = () => {
  const items = document.querySelectorAll('.show.menu-dropdown[data-kt-menu-trigger]');
  if (items && items.length > 0) {
    for (let i = 0, len = items.length; i < len; i++) {
      const item = items[i];
      if (DataUtil.has(item, 'popper')) {
        DataUtil.get(item, 'popper').forceUpdate();
      }
    }
  }
};
MenuComponent.createInstances = selector => {
  document.querySelectorAll(selector).forEach(el => {
    const menuItem = el;
    let menuInstance = _class$2.getInstance(menuItem);
    if (!menuInstance) {
      menuInstance = new _class$2(el, defaultMenuOptions);
    }
  });
};
MenuComponent.initGlobalHandlers = () => {
  document.addEventListener('click', e => {
    const menuItems = document.querySelectorAll('.show.menu-dropdown[data-kt-menu-trigger]');
    if (menuItems && menuItems.length > 0) {
      for (let i = 0; i < menuItems.length; i++) {
        const item = menuItems[i];
        const menuObj = _class$2.getInstance(item);
        if (menuObj && menuObj.getItemSubType(item) === 'dropdown') {
          const menu = menuObj.getElement();
          const sub = menuObj.getItemSubElement(item);
          if (item === e.target || item.contains(e.target)) {
            continue;
          }
          if (sub && (sub === e.target || sub.contains(e.target))) {
            continue;
          }
          menuObj.hide(item);
        }
      }
    }
  });
  DOMEventHandlerUtil.on(document.body, '.menu-item[data-kt-menu-trigger] > .menu-link, [data-kt-menu-trigger]:not(.menu-item):not([data-kt-menu-trigger="auto"])', 'click', function (e) {
    const menu = _class$2.getInstance(this);
    if (menu) {
      return menu.click(this, e);
    }
  });
  DOMEventHandlerUtil.on(document.body, '.menu-item:not([data-kt-menu-trigger]) > .menu-link', 'click', function (e) {
    e.stopPropagation();
    const menu = _class$2.getInstance(this);
    if (menu && menu.link) {
      return menu.link(this, e);
    }
  });
  DOMEventHandlerUtil.on(document.body, '[data-kt-menu-dismiss="true"]', 'click', function (e) {
    const menu = _class$2.getInstance(this);
    if (menu) {
      return menu.dismiss(this, e);
    }
  });
  DOMEventHandlerUtil.on(document.body, '[data-kt-menu-trigger], .menu-sub', 'mouseover', function (e) {
    const menu = _class$2.getInstance(this);
    if (menu && menu.getItemSubType(this) === 'dropdown') {
      return menu.mouseover(this, e);
    }
  });
  DOMEventHandlerUtil.on(document.body, '[data-kt-menu-trigger], .menu-sub', 'mouseout', function (e) {
    const menu = _class$2.getInstance(this);
    if (menu && menu.getItemSubType(this) === 'dropdown') {
      return menu.mouseout(this, e);
    }
  });
  window.addEventListener('resize', () => {
    let timer;
    throttle(timer, () => {
      const elements = document.querySelectorAll('[data-kt-menu="true"]');
      elements.forEach(el => {
        const menu = _class$2.getInstance(el);
        if (menu) {
          menu.update();
        }
      });
    }, 200);
  });
};
MenuComponent.bootstrap = () => {
  _class$2.initGlobalHandlers();
  _class$2.createInstances('[data-kt-menu="true"]');
};
MenuComponent.reinitialization = () => {
  _class$2.createInstances('[data-kt-menu="true"]');
};
MenuComponent.createInsance = function (selector, options) {
  if (options === void 0) {
    options = defaultMenuOptions;
  }
  const element = document.body.querySelector(selector);
  if (!element) {
    return;
  }
  const item = element;
  let menu = _class$2.getInstance(item);
  if (!menu) {
    menu = new _class$2(item, options);
  }
  return menu;
};

const MasterLayout = _ref => {
  let {
    asideDefault,
    routerNameMap,
    routerLocation,
    asideMobile
  } = _ref;
  React.useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, []);
  React.useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [routerLocation.key]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "page d-flex flex-row flex-column-fluid"
  }, asideDefault, /*#__PURE__*/React__default.createElement("div", {
    className: "wrapper d-flex flex-column flex-row-fluid",
    id: "kt_wrapper"
  }, /*#__PURE__*/React__default.createElement(HeaderWrapper, {
    asideMobile: asideMobile
  }), /*#__PURE__*/React__default.createElement("div", {
    id: "kt_content",
    className: "content d-flex flex-column flex-column-fluid"
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    routerNameMap: routerNameMap
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column-fluid",
    id: "kt_post"
  }, /*#__PURE__*/React__default.createElement(Backdrop, null), /*#__PURE__*/React__default.createElement(Content, null, /*#__PURE__*/React__default.createElement(reactRouterDom.Outlet, null))))));
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;









var enforceInternalState = internalState.enforce;





var MATCH$2 = wellKnownSymbol('match');
var NativeRegExp = global_1.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = global_1.SyntaxError;
var exec$3 = functionUncurryThis(RegExpPrototype$3.exec);
var charAt$6 = functionUncurryThis(''.charAt);
var replace$6 = functionUncurryThis(''.replace);
var stringIndexOf$2 = functionUncurryThis(''.indexOf);
var stringSlice$6 = functionUncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = descriptors &&
  (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails(function () {
    re2[MATCH$2] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$6(string, index);
    if (chr === '\\') {
      result += chr + charAt$6(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$6(string, index);
    if (chr === '\\') {
      chr += charAt$6(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec$3(IS_NCG, stringSlice$6(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwnProperty_1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced_1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$3, this);
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = regexpGetFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString_1(pattern);
    flags = flags === undefined ? '' : toString_1(flags);
    rawPattern = pattern;

    if (regexpUnsupportedDotAll && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$2(flags, 's') > -1;
      if (dotAll) flags = replace$6(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY$1 && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$2(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$2) flags = replace$6(flags, /y/g, '');
    }

    if (regexpUnsupportedNcg) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys$2 = getOwnPropertyNames(NativeRegExp), index = 0; keys$2.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$2[index++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  defineBuiltIn(global_1, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var getInternalState$2 = internalState.get;

var RegExpPrototype$4 = RegExp.prototype;
var $TypeError$i = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (descriptors && regexpUnsupportedDotAll) {
  defineBuiltInAccessor(RegExpPrototype$4, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype$4) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classofRaw(this) === 'RegExp') {
        return !!getInternalState$2(this).dotAll;
      }
      throw $TypeError$i('Incompatible receiver, RegExp required');
    }
  });
}

class CookieComponent {
  static get(name) {
    const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  static set(name, value, cookieOptions) {
    const options = Object.assign({
      path: '/'
    }, cookieOptions);
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    for (const optionKey in options) {
      updatedCookie += '; ' + optionKey;
      const optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }
    document.cookie = updatedCookie;
  }
  static delete(name) {
    CookieComponent.set(name, '', {
      'max-age': -1
    });
  }
}

var _class2;
class DrawerStore {
  static set(instanceId, drawerComponentObj) {
    if (DrawerStore.has(instanceId)) {
      return;
    }
    DrawerStore.store.set(instanceId, drawerComponentObj);
  }
  static get(instanceId) {
    if (!DrawerStore.has(instanceId)) {
      return;
    }
    return DrawerStore.store.get(instanceId);
  }
  static remove(instanceId) {
    if (!DrawerStore.has(instanceId)) {
      return;
    }
    DrawerStore.store.delete(instanceId);
  }
  static has(instanceId) {
    return DrawerStore.store.has(instanceId);
  }
  static getAllInstances() {
    return DrawerStore.store;
  }
}
DrawerStore.store = new Map();
const defaultDrawerOptions = {
  overlay: true,
  baseClass: 'drawer',
  overlayClass: 'drawer-overlay',
  direction: 'end'
};
class DrawerComponent {
  constructor(_element, options) {
    this.element = void 0;
    this.overlayElement = null;
    this.toggleElement = null;
    this.options = void 0;
    this.instanceUid = void 0;
    this.name = '';
    this.shown = false;
    this.lastWidth = 0;
    this.closeElement = null;
    this._handlers = () => {
      const togglers = this._getOption('toggle');
      const closers = this._getOption('close');
      if (togglers !== null && togglers.length > 0) {
        DOMEventHandlerUtil.on(document.body, togglers, 'click', e => {
          e.preventDefault();
          this.toggleElement = document.getElementById(togglers);
          this._toggle();
        });
      }
      if (closers !== null && closers.length > 0) {
        DOMEventHandlerUtil.on(document.body, closers, 'click', e => {
          e.preventDefault();
          this.closeElement = document.getElementById(closers);
          this._hide();
        });
      }
    };
    this._update = () => {
      const width = String(this._getOption('width'));
      const direction = String(this._getOption('direction'));
      const hasBaseClass = this.element.classList.contains(this.options.baseClass + "-on");
      const bodyCanvasAttr = String(document.body.getAttribute("data-kt-drawer-" + this.name + "-"));
      if (hasBaseClass === true && bodyCanvasAttr === 'on') {
        this.shown = true;
      } else {
        this.shown = false;
      }
      if (this._getOption('activate') === true) {
        this.element.classList.add(this.options.baseClass);
        this.element.classList.add(this.options.baseClass + "-" + direction);
        ElementStyleUtil.set(this.element, 'width', width, true);
        this.lastWidth = parseInt(width);
      } else {
        ElementStyleUtil.set(this.element, 'width', '');
        this.element.classList.remove(this.options.baseClass);
        this.element.classList.remove(this.options.baseClass + "-" + direction);
        this._hide();
      }
    };
    this._getOption = name => {
      const attr = this.element.getAttribute("data-kt-drawer-" + name);
      if (attr) {
        const value = getAttributeValueByBreakpoint(attr);
        if (value !== null && String(value) === 'true') {
          return true;
        } else {
          if (value !== null && String(value) === 'false') {
            return false;
          }
        }
        return value;
      } else {
        const optionName = stringSnakeToCamel(name);
        const option = getObjectPropertyValueByKey(this.options, optionName);
        if (option) {
          return getAttributeValueByBreakpoint(option);
        } else {
          return null;
        }
      }
    };
    this._toggle = () => {
      if (EventHandlerUtil.trigger(this.element, 'kt.drawer.toggle') === false) {
        return;
      }
      if (this.shown) {
        this._hide();
      } else {
        this._show();
      }
      EventHandlerUtil.trigger(this.element, 'kt.drawer.toggled');
    };
    this._hide = () => {
      if (EventHandlerUtil.trigger(this.element, 'kt.drawer.hide') === false) {
        return;
      }
      this.shown = false;
      this._deleteOverlay();
      document.body.removeAttribute("data-kt-drawer-" + this.name);
      document.body.removeAttribute("data-kt-drawer");
      this.element.classList.remove(this.options.baseClass + "-on");
      if (this.toggleElement !== null) {
        this.toggleElement.classList.remove('active');
      }
      EventHandlerUtil.trigger(this.element, 'kt.drawer.after.hidden');
    };
    this._show = () => {
      if (EventHandlerUtil.trigger(this.element, 'kt.drawer.show') === false) {
        return;
      }
      this.shown = true;
      this._createOverlay();
      document.body.setAttribute("data-kt-drawer-" + this.name, 'on');
      document.body.setAttribute('data-kt-drawer', 'on');
      this.element.classList.add(this.options.baseClass + "-on");
      if (this.toggleElement !== null) {
        this.toggleElement.classList.add('active');
      }
      EventHandlerUtil.trigger(this.element, 'kt.drawer.shown');
    };
    this._createOverlay = () => {
      if (this._getOption('overlay') === true) {
        this.overlayElement = document.createElement('DIV');
        const elementZIndex = getCSS(this.element, 'z-index');
        if (elementZIndex) {
          const overlayZindex = parseInt(elementZIndex) - 1;
          ElementStyleUtil.set(this.overlayElement, 'z-index', overlayZindex);
        }
        document.body.append(this.overlayElement);
        const overlayClassOption = this._getOption('overlay-class');
        if (overlayClassOption) {
          this.overlayElement.classList.add(overlayClassOption.toString());
        }
        this.overlayElement.addEventListener('click', e => {
          e.preventDefault();
          this._hide();
        });
      }
    };
    this._deleteOverlay = () => {
      if (this.overlayElement !== null && this.overlayElement.parentNode) {
        this.overlayElement.parentNode.removeChild(this.overlayElement);
      }
    };
    this._getDirection = () => {
      return String(this._getOption('direction')) === 'left' ? 'left' : 'right';
    };
    this._getWidth = () => {
      let width = this._getOption('width');
      if (width && width === 'auto') {
        width = getCSS(this.element, 'width');
      }
      return width;
    };
    this.toggle = () => {
      this._toggle();
    };
    this.show = () => {
      this._show();
    };
    this.hide = () => {
      this._hide();
    };
    this.isShown = () => {
      return this.shown;
    };
    this.update = () => {
      this._update();
    };
    this.goElement = () => {
      return this.element;
    };
    this.on = (name, handler) => {
      return EventHandlerUtil.on(this.element, name, handler);
    };
    this.one = (name, handler) => {
      return EventHandlerUtil.one(this.element, name, handler);
    };
    this.off = name => {
      return EventHandlerUtil.off(this.element, name);
    };
    this.trigger = (name, event) => {
      return EventHandlerUtil.trigger(this.element, name, event);
    };
    this.element = _element;
    this.options = Object.assign(defaultDrawerOptions, options);
    this.instanceUid = getUniqueIdWithPrefix('drawer');
    this.overlayElement = null;
    this.name = this.element.getAttribute('data-kt-drawer-name') || '';
    this.shown = false;
    this.toggleElement = null;
    this._handlers();
    this._update();
    DrawerStore.set(this.element.id, this);
  }
  static createInstances(selector) {
    const elements = document.body.querySelectorAll(selector);
    elements.forEach(element => {
      const item = element;
      let drawer = DrawerComponent.getInstance(item.id);
      if (!drawer) {
        drawer = new DrawerComponent(item, defaultDrawerOptions);
      }
      drawer.element = item;
      drawer.hide();
    });
  }
  static initGlobalHandlers() {
    window.addEventListener('resize', function () {
      let timer;
      throttle(timer, () => {
        const elements = document.body.querySelectorAll('[data-kt-drawer="true"]');
        elements.forEach(el => {
          const item = el;
          const instance = DrawerComponent.getInstance(item.id);
          if (instance) {
            instance.element = item;
            instance.update();
          }
        });
      }, 200);
    });
  }
}
_class2 = DrawerComponent;
DrawerComponent.hasInstace = elementId => {
  return DrawerStore.has(elementId);
};
DrawerComponent.getInstance = elementId => {
  return DrawerStore.get(elementId);
};
DrawerComponent.hideAll = () => {
  const oldInstances = DrawerStore.getAllInstances();
  oldInstances.forEach(dr => {
    dr.hide();
  });
};
DrawerComponent.updateAll = () => {
  const oldInstances = DrawerStore.getAllInstances();
  oldInstances.forEach(dr => {
    dr.update();
  });
};
DrawerComponent.handleDismiss = () => {
  DOMEventHandlerUtil.on(document.body, '[data-kt-drawer-dismiss="true"]', 'click', () => {
    const element = _class2.closest('[data-kt-drawer="true"]');
    if (element) {
      const drawer = _class2.getInstance(element);
      if (drawer && drawer.isShown()) {
        drawer.hide();
      }
    }
  });
};
DrawerComponent.bootstrap = () => {
  _class2.createInstances('[data-kt-drawer="true"]');
  _class2.initGlobalHandlers();
  _class2.handleDismiss();
};
DrawerComponent.reinitialization = () => {
  _class2.createInstances('[data-kt-drawer="true"]');
  _class2.hideAll();
  _class2.updateAll();
  _class2.handleDismiss();
};

var _class$3;
const defaultStepperOptions = {
  startIndex: 1,
  animation: false,
  animationSpeed: '0.3s',
  animationNextClass: 'animate__animated animate__slideInRight animate__fast',
  animationPreviousClass: 'animate__animated animate__slideInLeft animate__fast'
};
class StepperComponent {
  constructor(_element, options) {
    var _this$steps;
    this.element = void 0;
    this.options = void 0;
    this.instanceUid = void 0;
    this.steps = void 0;
    this.btnNext = void 0;
    this.btnPrev = void 0;
    this.btnSubmit = void 0;
    this.totatStepsNumber = 0;
    this.passedStepIndex = 0;
    this.currentStepIndex = 1;
    this._goTo = index => {
      EventHandlerUtil.trigger(this.element, 'kt.stepper.change');
      if (index === this.currentStepIndex || index > this.totatStepsNumber || index < 0) {
        return;
      }
      index = parseInt(index.toString());
      this.passedStepIndex = this.currentStepIndex;
      this.currentStepIndex = index;
      this.refreshUI();
      EventHandlerUtil.trigger(this.element, 'kt.stepper.changed');
    };
    this.initHandlers = () => {
      var _this$btnNext, _this$btnPrev;
      (_this$btnNext = this.btnNext) === null || _this$btnNext === void 0 ? void 0 : _this$btnNext.addEventListener('click', e => {
        e.preventDefault();
        EventHandlerUtil.trigger(this.element, 'kt.stepper.next', e);
      });
      (_this$btnPrev = this.btnPrev) === null || _this$btnPrev === void 0 ? void 0 : _this$btnPrev.addEventListener('click', e => {
        e.preventDefault();
        EventHandlerUtil.trigger(this.element, 'kt.stepper.previous', e);
      });
    };
    this._getStepDirection = index => {
      return index > this.currentStepIndex ? 'next' : 'previous';
    };
    this.getStepContent = index => {
      const content = this.element.querySelectorAll('[data-kt-stepper-element="content"]');
      if (!content) {
        return false;
      }
      if (content[index - 1]) {
        return content[index - 1];
      }
      return false;
    };
    this.getLastStepIndex = () => {
      return this.totatStepsNumber;
    };
    this.getTotalStepsNumber = () => {
      return this.totatStepsNumber;
    };
    this.refreshUI = () => {
      let state = '';
      if (this.isLastStep()) {
        state = 'last';
      } else if (this.isFirstStep()) {
        state = 'first';
      } else {
        state = 'between';
      }
      this.element.classList.remove('last');
      this.element.classList.remove('first');
      this.element.classList.remove('between');
      this.element.classList.add(state);
      const elements = this.element.querySelectorAll('[data-kt-stepper-element="nav"], [data-kt-stepper-element="content"], [data-kt-stepper-element="info"]');
      if (!elements || elements.length <= 0) {
        return;
      }
      for (let i = 0, len = elements.length; i < len; i++) {
        const element = elements[i];
        const index = getElementIndex(element) + 1;
        element.classList.remove('current');
        element.classList.remove('completed');
        element.classList.remove('pending');
        if (index === this.currentStepIndex) {
          element.classList.add('current');
          if (this.options.animation !== false && element.getAttribute('data-kt-stepper-element') === 'content') {
            ElementStyleUtil.set(element, 'animationDuration', this.options.animationSpeed);
            const animation = this._getStepDirection(this.passedStepIndex) === 'previous' ? this.options.animationPreviousClass : this.options.animationNextClass;
            ElementAnimateUtil.animateClass(element, animation);
          }
        } else {
          if (index < this.currentStepIndex) {
            element.classList.add('completed');
          } else {
            element.classList.add('pending');
          }
        }
      }
    };
    this.isLastStep = () => {
      return this.currentStepIndex === this.totatStepsNumber;
    };
    this.isFirstStep = () => {
      return this.currentStepIndex === 1;
    };
    this.isBetweenStep = () => {
      return this.isLastStep() === false && this.isFirstStep() === false;
    };
    this.goto = index => {
      return this._goTo(index);
    };
    this.goNext = () => {
      return this.goto(this.getNextStepIndex());
    };
    this.goPrev = () => {
      return this.goto(this.getPrevStepIndex());
    };
    this.goFirst = () => {
      return this.goto(1);
    };
    this.goLast = () => {
      return this.goto(this.getLastStepIndex());
    };
    this.getCurrentStepIndex = () => {
      return this.currentStepIndex;
    };
    this.getNextStepIndex = () => {
      if (this.totatStepsNumber >= this.currentStepIndex + 1) {
        return this.currentStepIndex + 1;
      } else {
        return this.totatStepsNumber;
      }
    };
    this.getPassedStepIndex = () => {
      return this.passedStepIndex;
    };
    this.getPrevStepIndex = () => {
      if (this.currentStepIndex - 1 > 1) {
        return this.currentStepIndex - 1;
      } else {
        return 1;
      }
    };
    this.getElement = _index => {
      return this.element;
    };
    this.on = (name, handler) => {
      return EventHandlerUtil.on(this.element, name, handler);
    };
    this.one = (name, handler) => {
      return EventHandlerUtil.one(this.element, name, handler);
    };
    this.off = name => {
      return EventHandlerUtil.off(this.element, name);
    };
    this.destroy = () => {};
    this.trigger = (name, event) => {
      return EventHandlerUtil.trigger(this.element, name, event);
    };
    this.element = _element;
    this.options = Object.assign(defaultStepperOptions, options);
    this.instanceUid = getUniqueIdWithPrefix('stepper');
    this.steps = this.element.querySelectorAll('[data-kt-stepper-element="nav"]');
    this.btnNext = this.element.querySelector('[data-kt-stepper-action="next"]');
    this.btnPrev = this.element.querySelector('[data-kt-stepper-action="previous"]');
    this.btnSubmit = this.element.querySelector('[data-kt-stepper-action="submit"]');
    this.totatStepsNumber = ((_this$steps = this.steps) === null || _this$steps === void 0 ? void 0 : _this$steps.length) | 0;
    this.passedStepIndex = 0;
    this.currentStepIndex = 1;
    if (this.options.startIndex > 1) {
      this._goTo(this.options.startIndex);
    }
    this.initHandlers();
    DataUtil.set(this.element, 'stepper', this);
  }
  static hasInstace(element) {
    return DataUtil.has(element, 'stepper');
  }
  static getInstance(element) {
    if (element !== null && StepperComponent.hasInstace(element)) {
      return DataUtil.get(element, 'stepper');
    }
    return null;
  }
  static createInstances(selector) {
    const elements = document.body.querySelectorAll(selector);
    elements.forEach(element => {
      const item = element;
      let stepper = StepperComponent.getInstance(item);
      if (!stepper) {
        stepper = new StepperComponent(item, defaultStepperOptions);
      }
    });
  }
  static bootstrap(attr) {
    if (attr === void 0) {
      attr = '[data-kt-stepper]';
    }
    StepperComponent.createInstances(attr);
  }
}
_class$3 = StepperComponent;
StepperComponent.createInsance = function (element, options) {
  if (options === void 0) {
    options = defaultStepperOptions;
  }
  if (!element) {
    return null;
  }
  let stepper = _class$3.getInstance(element);
  if (!stepper) {
    stepper = new _class$3(element, options);
  }
  return stepper;
};

var _class$4;
const defaultToggleOptions = {
  saveState: false
};
class ToggleComponent {
  constructor(_element, options) {
    this.element = void 0;
    this.instanceUid = void 0;
    this.options = void 0;
    this.state = '';
    this.target = null;
    this.attribute = '';
    this._handlers = () => {
      this.element.addEventListener('click', e => {
        e.preventDefault();
        this._toggle();
      });
    };
    this._toggle = () => {
      EventHandlerUtil.trigger(this.element, 'kt.toggle.change');
      if (this._isEnabled()) {
        this._disable();
      } else {
        this._enable();
      }
      EventHandlerUtil.trigger(this.element, 'kt.toggle.changed');
      return this;
    };
    this._enable = () => {
      var _this$target;
      if (this._isEnabled()) {
        return;
      }
      EventHandlerUtil.trigger(this.element, 'kt.toggle.enable');
      (_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.setAttribute(this.attribute, 'on');
      if (this.state.length > 0) {
        this.element.classList.add(this.state);
      }
      if (this.options.saveState) {
        CookieComponent.set(this.attribute, 'on', {});
      }
      EventHandlerUtil.trigger(this.element, 'kt.toggle.enabled');
      return this;
    };
    this._disable = () => {
      var _this$target2;
      if (!this._isEnabled()) {
        return false;
      }
      EventHandlerUtil.trigger(this.element, 'kt.toggle.disable');
      (_this$target2 = this.target) === null || _this$target2 === void 0 ? void 0 : _this$target2.removeAttribute(this.attribute);
      if (this.state.length > 0) {
        this.element.classList.remove(this.state);
      }
      if (this.options.saveState) {
        CookieComponent.delete(this.attribute);
      }
      EventHandlerUtil.trigger(this.element, 'kt.toggle.disabled');
      return this;
    };
    this._isEnabled = () => {
      if (!this.target) {
        return false;
      }
      return String(this.target.getAttribute(this.attribute)).toLowerCase() === 'on';
    };
    this.toggle = () => {
      return this._toggle();
    };
    this.enable = () => {
      return this._enable();
    };
    this.disable = () => {
      return this._disable();
    };
    this.isEnabled = () => {
      return this._isEnabled();
    };
    this.goElement = () => {
      return this.element;
    };
    this.on = (name, handler) => {
      return EventHandlerUtil.on(this.element, name, handler);
    };
    this.one = (name, handler) => {
      return EventHandlerUtil.one(this.element, name, handler);
    };
    this.off = name => {
      return EventHandlerUtil.off(this.element, name);
    };
    this.trigger = (name, event) => {
      return EventHandlerUtil.trigger(this.element, name, event);
    };
    this.options = Object.assign(defaultToggleOptions, options);
    this.instanceUid = getUniqueIdWithPrefix('toggle');
    this.element = _element;
    const elementTargetAttr = this.element.getAttribute('data-kt-toggle-target');
    if (elementTargetAttr) {
      this.target = document.querySelector(elementTargetAttr);
    }
    const elementToggleAttr = this.element.getAttribute('data-kt-toggle-state');
    this.state = elementToggleAttr || '';
    this.attribute = 'data-kt-' + this.element.getAttribute('data-kt-toggle-name');
    this._handlers();
    DataUtil.set(this.element, 'toggle', this);
  }
}
_class$4 = ToggleComponent;
ToggleComponent.getInstance = el => {
  const toggleElement = DataUtil.get(el, 'toggle');
  if (toggleElement) {
    return toggleElement;
  }
  return null;
};
ToggleComponent.createInstances = selector => {
  const elements = document.body.querySelectorAll(selector);
  elements.forEach(el => {
    const item = el;
    let toggleElement = _class$4.getInstance(item);
    if (!toggleElement) {
      toggleElement = new _class$4(item, defaultToggleOptions);
    }
  });
};
ToggleComponent.createInsance = function (selector, options) {
  if (options === void 0) {
    options = defaultToggleOptions;
  }
  const element = document.body.querySelector(selector);
  if (!element) {
    return;
  }
  const item = element;
  let toggle = _class$4.getInstance(item);
  if (!toggle) {
    toggle = new _class$4(item, options);
  }
  return toggle;
};
ToggleComponent.reinitialization = () => {
  _class$4.createInstances('[data-kt-toggle]');
};
ToggleComponent.bootstrap = () => {
  _class$4.createInstances('[data-kt-toggle]');
};

function MasterInit() {
  const isFirstRun = React.useRef(true);
  const pluginsInitialization = () => {
    isFirstRun.current = false;
    setTimeout(() => {
      DrawerComponent.bootstrap();
      MenuComponent.bootstrap();
      StepperComponent.bootstrap();
      ToggleComponent.bootstrap();
    }, 500);
  };
  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      pluginsInitialization();
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
}

const customSizes = ['xxl', 'm'];
const UfinetModal = _ref => {
  let {
    title,
    show,
    handleClose,
    children,
    size,
    showCloseButton,
    stickyHeader,
    preventCloseOnEscapeKey = false
  } = _ref;
  return /*#__PURE__*/React__default.createElement(reactBootstrap.Modal, {
    dialogClassName: clsx(size && size === 'xxl' ? 'vw-90-modal' : ''),
    show: show,
    size: size && !customSizes.includes(size) ? size : undefined,
    onHide: handleClose,
    "aria-labelledby": "contained-modal-title-vcenter",
    centered: true,
    backdrop: "static",
    onEscapeKeyDown: e => {
      if (preventCloseOnEscapeKey) e.preventDefault();
    }
  }, /*#__PURE__*/React__default.createElement(reactBootstrap.Modal.Header, {
    className: clsx(stickyHeader ? 'sticky-top bg-white' : ''),
    closeButton: showCloseButton != null ? showCloseButton : true
  }, /*#__PURE__*/React__default.createElement(reactBootstrap.Modal.Title, {
    id: "contained-modal-title-vcenter"
  }, title)), /*#__PURE__*/React__default.createElement(reactBootstrap.Modal.Body, null, children));
};

const ToastContent = _ref => {
  let {
    title,
    message
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column justify-content-center"
  }, (title === null || title === void 0 ? void 0 : title.trim()) && /*#__PURE__*/React__default.createElement("h6", {
    className: "mb-0"
  }, title), typeof message === 'string' && message.trim() ? /*#__PURE__*/React__default.createElement("p", {
    className: "mb-0"
  }, message) : /*#__PURE__*/React__default.createElement("div", null, message));
};

// TODO: Remove from `core-js@4` since it's moved to entry points







var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
_export({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString_1(S);
    var exec = R.exec;
    if (!isCallable(exec)) return functionCall(nativeTest, R, string);
    var result = functionCall(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});

const AuthPage = () => {
  const intl = reactIntl.useIntl();
  const {
    setToken,
    setStatus
  } = React.useContext(ufinetWebFunctions.AuthContext);
  const [isPopUpOpen, setIsPopUpOpen] = React.useState(false);
  const [tokenReceived, setTokenReceived] = React.useState(false);
  const actionBtnRef = React.useRef(null);
  const isLoadingAuth = React.useCallback(() => isPopUpOpen || tokenReceived, [isPopUpOpen, tokenReceived]);
  React.useLayoutEffect(() => {
    var _actionBtnRef$current;
    (_actionBtnRef$current = actionBtnRef.current) === null || _actionBtnRef$current === void 0 ? void 0 : _actionBtnRef$current.changeActionStatus(isLoadingAuth());
  }, [isPopUpOpen, tokenReceived, isLoadingAuth]);
  const formik$1 = formik.useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: create$1().shape({
      email: create().required(intl.formatMessage({
        id: 'ERROR.REQUIRED'
      })).email(intl.formatMessage({
        id: 'ERROR.MAIL.INVALID'
      }))
    }),
    onSubmit: _ref => {
      let {
        email
      } = _ref;
      return handleSubmit(email);
    },
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true
  });
  const onLoginPopupOpen = () => setIsPopUpOpen(true);
  const onLoginPopupClose = () => setIsPopUpOpen(false);
  const onTokenReceived = () => setTokenReceived(true);
  const handleSubmit = email => {
    if (isLoadingAuth()) return;
    onLoginPopupOpen();
    const loginPromise = ufinetWebFunctions.internalMailRegExp.test(email) ? ufinetWebFunctions.authService.initLoginOAuth2(setToken, formik$1.values.email, onTokenReceived, onLoginPopupClose) : ufinetWebFunctions.authService.initLoginPwd(setToken, formik$1.values.email, onTokenReceived, onLoginPopupClose);
    loginPromise.then(userData => {
      return setStatus(ufinetWebFunctions.AuthStatus.LOGGED_IN, userData);
    }).catch(console.error).finally(onLoginPopupClose);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: formik$1.handleSubmit,
    className: "container h-100 d-flex justify-content-center auth-container-direction py-10"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "auth-container-picture"
  }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("img", {
    alt: "Logo",
    className: "img-fluid rounded",
    src: ufinetWebFunctions.toAbsoluteUrl('/media/pictures/ufinet_background.jpg')
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "shadow auth-container-login"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Logo",
    className: "h-100px  mb-10 logo",
    src: ufinetWebFunctions.toAbsoluteUrl('/media/logos/ufinet_logo.svg')
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "w-75"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mb-5 w-100"
  }, /*#__PURE__*/React__default.createElement(UfinetInput, Object.assign({}, formik$1.getFieldProps, {
    requiredIcon: false,
    type: "text",
    name: "email",
    value: formik$1.values.email,
    error: formik$1.errors.email,
    onChange: e => formik$1.setFieldValue('email', e.target.value),
    onBlur: () => ufinetWebFunctions.onFormikTrimField(formik$1, 'email', ''),
    solid: false,
    placeholder: "name@example.com",
    autofocus: true
  }))), /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionBtnRef,
    className: "w-100",
    content: intl.formatMessage({
      id: isLoadingAuth() ? 'AUTH.LOGGING_IN' : 'AUTH.LOGIN'
    })
  }))));
};

const VerificationPage = () => {
  const [showLoading, setShowLoading] = React.useState(false);
  React.useEffect(() => {
    const spinnerTimeout = setTimeout(() => setShowLoading(true), 1250);
    return () => {
      clearTimeout(spinnerTimeout);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "w-100 h-100 d-flex flex-column justify-content-center align-items-center"
  }, showLoading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactBootstrap.Spinner, {
    animation: "grow"
  }))));
};

const WelcomePage = _ref => {
  let {
    appName,
    message
  } = _ref;
  const translate = ufinetWebFunctions.useTranslator();
  return /*#__PURE__*/React__default.createElement(UfinetBox, {
    limitHeightToPageBottom: false
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "text-center"
  }, translate('WELCOME', {
    appName
  })), message ? /*#__PURE__*/React__default.createElement("p", {
    className: "text-center"
  }, message) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
};

const _excluded$d = ["id", "className", "name", "value", "selectedValue", "label", "onChange", "disabled", "checked", "solid"];
const UfinetRadioButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      id: propId,
      className,
      name,
      value,
      selectedValue,
      label = value,
      onChange = () => {},
      disabled = false,
      checked = false,
      solid = false
    } = _ref,
    inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  const id = React.useMemo(() => propId || name + "-" + value, [propId, name, value]);
  const isChecked = React.useMemo(() => checked || selectedValue === value, [checked, selectedValue, value]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('form-check form-check-custom', solid && 'form-check-solid', className)
  }, /*#__PURE__*/React__default.createElement("input", Object.assign({
    ref: ref,
    type: "radio",
    id: id,
    className: "form-check-input",
    name: name,
    value: value,
    checked: isChecked,
    disabled: disabled,
    onChange: onChange
  }, inputProps)), /*#__PURE__*/React__default.createElement("label", {
    className: "form-check-label",
    htmlFor: id
  }, label));
});

const UfinetRadioButtonGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    selection,
    options,
    name: propName,
    onChange = () => {},
    inline = false,
    disabled = false,
    error,
    solid,
    className,
    requiredIcon = false,
    title,
    titleClassName,
    tooltipTitle
  } = _ref;
  const wrapperId = React.useMemo(() => id || uuid.v4(), [id]);
  const name = React.useMemo(() => propName || uuid.v4(), [propName]);
  const [stateSelection, setStateSelection] = React.useState();
  const getSelectionOption = React.useCallback(value => options.find(it => it.value === value), [options]);
  React.useEffect(() => {
    setStateSelection(getSelectionOption(selection));
  }, [selection, getSelectionOption]);
  const onChangeSelection = React.useCallback(e => {
    const newValue = e.target.value;
    const newOption = getSelectionOption(newValue);
    setStateSelection(newOption);
    onChange(newOption);
  }, [onChange, getSelectionOption]);
  React.useImperativeHandle(ref, () => ({
    clear: () => {
      setStateSelection(undefined);
      onChange(undefined);
    },
    getCurrentSelection: () => stateSelection
  }), [stateSelection, onChange]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('d-flex flex-column', className)
  }, title && /*#__PURE__*/React__default.createElement(Label, {
    htmlForId: wrapperId,
    className: titleClassName,
    labelTitle: title,
    tooltipTitle: tooltipTitle,
    requiredIcon: requiredIcon
  }), /*#__PURE__*/React__default.createElement("div", {
    id: wrapperId
  }, options.map((opt, idx) => /*#__PURE__*/React__default.createElement("div", {
    key: idx,
    className: clsx('radio-btn-group', inline && 'form-check-inline')
  }, /*#__PURE__*/React__default.createElement(UfinetRadioButton, {
    name: name,
    value: opt.value,
    selectedValue: stateSelection === null || stateSelection === void 0 ? void 0 : stateSelection.value,
    label: opt.label,
    id: name + "-" + idx,
    checked: (stateSelection === null || stateSelection === void 0 ? void 0 : stateSelection.value) === opt.value,
    disabled: opt.disabled || disabled,
    onChange: onChangeSelection,
    className: inline ? 'me-1' : 'mt-1',
    solid: solid
  })))), error && /*#__PURE__*/React__default.createElement("label", {
    className: "text-danger"
  }, error));
});

const AuthRoute = _ref => {
  let {
    authorizedRoles,
    needsAllRoles = false,
    authorizedUsers = [ufinetWebFunctions.UserTypesEnum.INTERNAL_USER, ufinetWebFunctions.UserTypesEnum.EXTERNAL_USER],
    notAuthorizedRedirectTo = '/',
    children
  } = _ref;
  const intl = reactIntl.useIntl();
  const {
    userData
  } = React.useContext(ufinetWebFunctions.AuthContext);
  const isAuthorized = (userData === null || userData === void 0 ? void 0 : userData.authorities) && (needsAllRoles ? userData.authorities.every(userRole => authorizedRoles.find(role => role.equals(userRole))) : userData.authorities.some(userRole => authorizedRoles.find(role => role.equals(userRole)))) && authorizedUsers.includes(userData.user.type);
  if (isAuthorized) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);else {
    reactToastify.toast.error(intl.formatMessage({
      id: 'UNAUTHORIZED.ROUTE.ACCESS'
    }), {
      containerId: ufinetWebFunctions.TOAST_CONTAINER_ID
    });
    return /*#__PURE__*/React__default.createElement(reactRouterDom.Navigate, {
      to: notAuthorizedRedirectTo
    });
  }
};

const EntrypointHandler = _ref => {
  let {
    children
  } = _ref;
  const location = reactRouterDom.useLocation();
  const redirected = React.useRef(false);
  const {
    status
  } = React.useContext(ufinetWebFunctions.AuthContext);
  const redirectURL = React.useRef(location.pathname);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children, status === ufinetWebFunctions.AuthStatus.LOGGED_IN && !redirected.current && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactRouterDom.Navigate, {
    to: redirectURL.current
  }), " ", redirected.current = true));
};

const showSwal = swalOptions => Swal.fire(swalOptions);

var UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$4 = Math.min;
var $push = [].push;
var exec$4 = functionUncurryThis(/./.exec);
var push$4 = functionUncurryThis($push);
var stringSlice$7 = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] === 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length !== 4 ||
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString_1(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$4(output, stringSlice$7(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$4(separatorCopy, '')) push$4(output, '');
      } else push$4(output, stringSlice$7(string, lastLastIndex));
      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$3 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$3 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$3 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$3 ? stringSlice$7(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$4(toLength(splitter.lastIndex + (UNSUPPORTED_Y$3 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$4(A, stringSlice$7(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$4(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$4(A, stringSlice$7(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$3);

var $TypeError$j = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$3 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$j('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce$1 = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$3(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$3(true)
};

var $reduce = arrayReduce$1.left;




// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;
var FORCED$6 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: FORCED$6 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var REPLACE$1 = wellKnownSymbol('replace');
var $TypeError$k = TypeError;
var indexOf$2 = functionUncurryThis(''.indexOf);
var replace$7 = functionUncurryThis(''.replace);
var stringSlice$8 = functionUncurryThis(''.slice);
var max$4 = Math.max;

var stringIndexOf$3 = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf$2(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
_export({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegexp(searchValue);
      if (IS_REG_EXP) {
        flags = toString_1(requireObjectCoercible(regexpGetFlags(searchValue)));
        if (!~indexOf$2(flags, 'g')) throw $TypeError$k('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE$1);
      if (replacer) {
        return functionCall(replacer, searchValue, O, replaceValue);
      }
    }
    string = toString_1(O);
    searchString = toString_1(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString_1(replaceValue);
    searchLength = searchString.length;
    advanceBy = max$4(1, searchLength);
    position = stringIndexOf$3(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString_1(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice$8(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf$3(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice$8(string, endOfLastMatch);
    }
    return result;
  }
});

const _excluded$e = ["input", "separator", "separatorBefore", "hideSeparator", "wrapMode"];
const temporaryReplace = '__REPLACE-POINT__';
(function (WRAP_MODE) {
  WRAP_MODE[WRAP_MODE["WHITESPACE"] = 0] = "WHITESPACE";
  WRAP_MODE[WRAP_MODE["LINEBREAK"] = 1] = "LINEBREAK";
})(exports.WRAP_MODE || (exports.WRAP_MODE = {}));
const DivWrapped = _ref => {
  let {
      input,
      separator,
      separatorBefore = true,
      hideSeparator = false,
      wrapMode = exports.WRAP_MODE.WHITESPACE
    } = _ref,
    divProps = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  const multipleSeparator = React.useMemo(() => Array.isArray(separator), [separator]);
  const htmlSeparator = React.useMemo(() => wrapMode === exports.WRAP_MODE.WHITESPACE ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\u200B") : /*#__PURE__*/React__default.createElement("br", null), [wrapMode]);
  const parts = (!Array.isArray(separator) ? input.split(separator) : separator.reduce((acc, curr) => input.replaceAll(curr, temporaryReplace), input).split(temporaryReplace)).map(p => p.trim()).filter(Boolean);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, divProps), parts.map((part, idx) => separatorBefore ? /*#__PURE__*/React__default.createElement("span", {
    key: idx
  }, part, htmlSeparator, !hideSeparator && idx !== parts.length - 1 && !multipleSeparator ? separator : '') : /*#__PURE__*/React__default.createElement("span", {
    key: idx
  }, part, !hideSeparator && idx !== parts.length - 1 && !multipleSeparator ? separator : '', htmlSeparator)));
};

var nativeReverse = functionUncurryThis([].reverse);
var test$2 = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
_export({ target: 'Array', proto: true, forced: String(test$2) === String(test$2.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

var $trimStart = stringTrim.start;


// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
var stringTrimStart = stringTrimForced('trimStart') ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;

// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
_export({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== stringTrimStart }, {
  trimLeft: stringTrimStart
});

// TODO: Remove this line from `core-js@4`




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
_export({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== stringTrimStart }, {
  trimStart: stringTrimStart
});

const tableSortValueToSortDirection = input => {
  if (!input) return null;
  return input === -1 ? ufinetWebFunctions.SortingDirection.DESCENDING : ufinetWebFunctions.SortingDirection.ASCENDING;
};
const formatTableFilters = event => {
  const formattedFilters = Object.assign({}, event.filters);
  Object.entries(formattedFilters).forEach(_ref => {
    let [key, filter] = _ref;
    let filterValue = filter.value;
    if (typeof filterValue === 'string') {
      const trimmed = filterValue.trim();
      filterValue = trimmed === '' ? null : trimmed;
    }
    formattedFilters[key] = filterValue;
  });
  return formattedFilters;
};
const getOptionsForFilter = function getOptionsForFilter(data, col) {
  var _data;
  if (data === void 0) {
    data = [];
  }
  const parsedSetOpt = new Set((_data = data) === null || _data === void 0 ? void 0 : _data.map(item => {
    var _getNestedFieldValue;
    return (_getNestedFieldValue = getNestedFieldValue(item, col.field.toString())) === null || _getNestedFieldValue === void 0 ? void 0 : _getNestedFieldValue.toString();
  }).filter(Boolean));
  return Array.from(parsedSetOpt).map(item => ({
    label: item,
    value: item
  }));
};
const getNestedFieldValue = (data, path) => {
  const nestedFieldParts = path.split('.');
  const nestedFieldValue = nestedFieldParts.reduce((acc, part) => {
    return (acc || data)[part];
  }, undefined);
  return nestedFieldValue;
};

const useTable = _ref => {
  var _filtersWithGlobal$, _filtersWithGlobal$$g, _filtersWithGlobal$$g2, _initialFilters$globa, _initialFilters$globa2, _lazySettings$totalPa;
  let {
    tableState: {
      lazySettings,
      onSelectionChange: onSelectionChangeCallback,
      onValuesDisplayedChange: onValuesDisplayedChangeCallback,
      onRowEditComplete,
      afterTablePFSEvent,
      limitHeight,
      editOnCell,
      isLoading
    },
    data: {
      all: content,
      selected: selectedValues
    },
    columns: {
      columns,
      actionBodyTemplate,
      headerButtons
    },
    pagination: {
      showPaginator,
      onPage
    },
    filters: {
      filterOnlyDisplayedData = false,
      onFilter,
      onFilterClear,
      filterButtons,
      enableSearchFilter,
      customClassFilters,
      customClassHeaders
    },
    sortings: {
      sortField: propSortField,
      sortOrder: propSortOrder,
      onSort
    },
    editor: {
      textEditorClassName
    }
  } = _ref;
  const translate = ufinetWebFunctions.useTranslator();
  const [allData, setAllData] = React.useState();
  const [displayedData, setDisplayedData] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [selectValuesClear, clearSelectsValues] = ufinetWebFunctions.useSelectClear();
  const isLazy = lazySettings !== undefined;
  const actionColumns = !actionBodyTemplate ? [] : !Array.isArray(actionBodyTemplate) ? [actionBodyTemplate] : actionBodyTemplate;
  const [sortField, setSortField] = React.useState(propSortField);
  const [sortOrder, setSortOrder] = React.useState(propSortOrder);
  const [pageSize, setPageSize] = React.useState(ufinetWebFunctions.defaultPageSize);
  const [pageFirst, setPageFirst] = React.useState(0);
  const tableLoading = isLoading || (lazySettings === null || lazySettings === void 0 ? void 0 : lazySettings.loading) || loading;
  const initialFilters = {
    global: {
      value: ' ',
      matchMode: api.FilterMatchMode.CONTAINS
    }
  };
  const [filtersWithGlobal, setFiltersWithGlobal] = React.useState([initialFilters, ' ']);
  columns.forEach(col => initialFilters[col.field] = {
    value: null,
    matchMode: api.FilterMatchMode.IN
  });
  const filterDisplayType = columns.find(x => x.nonFilterable === undefined || !x.nonFilterable) === undefined ? undefined : 'menu';
  const areFiltersApplied = !fastEquals.deepEqual(Object.assign({}, filtersWithGlobal[0], {
    global: (_filtersWithGlobal$ = filtersWithGlobal[0]) === null || _filtersWithGlobal$ === void 0 ? void 0 : (_filtersWithGlobal$$g = _filtersWithGlobal$.global) === null || _filtersWithGlobal$$g === void 0 ? void 0 : (_filtersWithGlobal$$g2 = _filtersWithGlobal$$g.value) === null || _filtersWithGlobal$$g2 === void 0 ? void 0 : _filtersWithGlobal$$g2.trim()
  }), Object.assign({}, initialFilters, {
    global: initialFilters === null || initialFilters === void 0 ? void 0 : (_initialFilters$globa = initialFilters.global) === null || _initialFilters$globa === void 0 ? void 0 : (_initialFilters$globa2 = _initialFilters$globa.value) === null || _initialFilters$globa2 === void 0 ? void 0 : _initialFilters$globa2.trim()
  }));
  const globalFilterFields = React.useMemo(() => {
    const filterableColumns = columns.filter(col => !col.nonSearchable).map(col => col.field);
    return filterableColumns.length > 0 ? filterableColumns : undefined;
  }, [columns]);
  const clearSort = () => {
    setSortField(undefined);
    setSortOrder(undefined);
  };
  const onSortControlledState = e => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);
    onSort === null || onSort === void 0 ? void 0 : onSort(e);
    (lazySettings === null || lazySettings === void 0 ? void 0 : lazySettings.onSort) && lazySettings.onSort(e);
    afterTablePFSEvent === null || afterTablePFSEvent === void 0 ? void 0 : afterTablePFSEvent(e);
  };
  const columnSortFunction = React.useCallback((e, compareFn) => {
    var _e$data;
    if (!e.order) return e.data;
    const isDateColumn = Boolean((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.find(v => ufinetWebFunctions.isFormattedDate(getNestedFieldValue(v, e.field))));
    const newData = !e.data ? [] : [...e.data];
    if (compareFn !== undefined) {
      newData.sort(compareFn);
    } else {
      newData.sort((a, b) => {
        const valueA = getNestedFieldValue(a, e.field);
        const valueB = getNestedFieldValue(b, e.field);
        return isDateColumn ? ufinetWebFunctions.compareDates(valueA, valueB) : valueA === valueB ? 0 : valueA > valueB ? 1 : -1;
      });
    }
    if (e.order === -1) newData.reverse();
    return newData;
  }, []);
  const columnFilterElementType = (column, options) => {
    var _options$value;
    if (column.nonFilterable) return;
    switch (column.filterType) {
      case 'number':
        return /*#__PURE__*/React__default.createElement(UfinetSimpleInput, {
          type: "decimal",
          value: options.value,
          onChange: e => options.filterApplyCallback([+(e === null || e === void 0 ? void 0 : e.target.value)])
        });
      case 'text':
        return /*#__PURE__*/React__default.createElement(UfinetSimpleInput, {
          type: "text",
          value: options.value || '',
          onChange: e => {
            options.filterApplyCallback(e === null || e === void 0 ? void 0 : e.target.value);
          }
        });
      case 'select':
      default:
        return /*#__PURE__*/React__default.createElement(UfinetSelect, {
          clearValues: selectValuesClear,
          className: "table-select-filter",
          isMulti: true,
          isClearable: true,
          isSearchable: true,
          options: column.filterOptions || getOptionsForFilter(filterOnlyDisplayedData ? displayedData : allData, column),
          value: (_options$value = options.value) === null || _options$value === void 0 ? void 0 : _options$value.map(it => {
            var _column$filterOptions, _column$filterOptions2;
            return {
              label: ((_column$filterOptions = column.filterOptions) === null || _column$filterOptions === void 0 ? void 0 : (_column$filterOptions2 = _column$filterOptions.find(opt => opt.value === it)) === null || _column$filterOptions2 === void 0 ? void 0 : _column$filterOptions2.label) || it,
              value: it
            };
          }),
          onChange: e => options.filterApplyCallback(Array.isArray(e) ? (e === null || e === void 0 ? void 0 : e.length) === 0 ? null : e === null || e === void 0 ? void 0 : e.map(i => i.value) : e === null || e === void 0 ? void 0 : e.value)
        });
    }
  };
  const onFilterControlledState = e => {
    var _lazySettings$onFilte;
    setFiltersWithGlobal([e.filters, filtersWithGlobal[1]]);
    onFilter === null || onFilter === void 0 ? void 0 : onFilter(e);
    lazySettings === null || lazySettings === void 0 ? void 0 : (_lazySettings$onFilte = lazySettings.onFilter) === null || _lazySettings$onFilte === void 0 ? void 0 : _lazySettings$onFilte.call(lazySettings, e);
    afterTablePFSEvent === null || afterTablePFSEvent === void 0 ? void 0 : afterTablePFSEvent(e);
  };
  const onPageControlledState = e => {
    var _lazySettings$onPage;
    setPageSize(e.rows);
    setPageFirst(e.first);
    onPage && onPage(e);
    lazySettings === null || lazySettings === void 0 ? void 0 : (_lazySettings$onPage = lazySettings.onPage) === null || _lazySettings$onPage === void 0 ? void 0 : _lazySettings$onPage.call(lazySettings, e);
    afterTablePFSEvent === null || afterTablePFSEvent === void 0 ? void 0 : afterTablePFSEvent(e);
  };
  const initFilters = () => {
    clearSelectsValues();
    setFiltersWithGlobal([initialFilters, ' ']);
  };
  React.useEffect(() => {
    initFilters();
  }, []);
  React.useEffect(() => {
    setAllData(content);
    setDisplayedData(content);
    setLoading(false);
  }, [content]);
  const onGlobalFilterChange = React.useCallback(e => {
    const baseValue = e.target.value;
    const trimValue = baseValue.trimStart();
    const newGlobalFilter = Object.assign({}, filtersWithGlobal[0].global, {
      value: trimValue
    });
    const _filters = Object.assign({}, filtersWithGlobal[0], {
      global: newGlobalFilter
    });
    setFiltersWithGlobal([_filters, trimValue || ' ']);
  }, [filtersWithGlobal]);
  const clearFilter = () => {
    setDisplayedData(allData);
    initFilters();
    onFilterClear === null || onFilterClear === void 0 ? void 0 : onFilterClear(initialFilters);
  };
  const onSelectionChange = e => {
    if (!onSelectionChangeCallback) return;
    const selectedAllLazy = lazySettings && lazySettings.pageSize === e.value.length;
    const newSelectedValues = !selectedAllLazy ? e.value : [...(selectedValues || []), ...e.value];
    onSelectionChangeCallback(ufinetWebFunctions.removeDuplicates(newSelectedValues));
  };
  const cellEditor = (col, options) => {
    return col.customEditableField ? col.customEditableField(col, options) : /*#__PURE__*/React__default.createElement(UfinetSimpleInput, {
      className: clsx('w-100', textEditorClassName),
      type: col.type ? col.type : 'text',
      isDisabled: !col.editable,
      value: options.value,
      onChange: e => {
        var _options$editorCallba;
        (_options$editorCallba = options.editorCallback) === null || _options$editorCallba === void 0 ? void 0 : _options$editorCallba.call(options, e.target.value);
      }
    });
  };
  const renderHeader = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'col d-flex flex-column justify-content-center' + ' ' + customClassFilters
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex justify-content-start my-4"
    }, filterDisplayType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(UfinetButton, {
      uiStyle: "primereact",
      type: "button",
      icon: freeSolidSvgIcons.faFilterCircleXmark,
      content: translate('FILTERS.LABEL'),
      outline: !areFiltersApplied,
      className: "me-1",
      onClick: clearFilter,
      isDisabled: tableLoading
    }), enableSearchFilter && /*#__PURE__*/React__default.createElement("span", {
      className: "d-flex p-input-icon-left",
      style: {
        zIndex: 9
      }
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "pi " + (lazySettings !== null && lazySettings !== void 0 && lazySettings.loading ? 'pi-spin pi-spinner' : 'pi-search')
    }), /*#__PURE__*/React__default.createElement(inputtext.InputText, {
      value: filtersWithGlobal[1].trimStart(),
      onChange: onGlobalFilterChange,
      placeholder: translate('SEARCH.PLACEHOLDER')
    })), filterButtons && /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex justify-content-start ms-5 fw-normal"
    }, filterButtons)))), /*#__PURE__*/React__default.createElement("div", {
      className: 'col d-flex flex-column justify-content-center' + ' ' + customClassHeaders
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex justify-content-end my-4"
    }, headerButtons)));
  };
  const getCellWidth = col => col.width || '120px';
  const getCellDisplayFormat = col => {
    switch (col.contentDisplayFormat) {
      case 'center':
        return {
          display: 'flex',
          justifyContent: 'center'
        };
      default:
        return {};
    }
  };
  const additionalClasses = clsx(onSelectionChangeCallback && !onRowEditComplete ? 'with-checkboxs' : onRowEditComplete && !onSelectionChangeCallback ? 'with-edit' : onRowEditComplete && onSelectionChangeCallback ? 'with-checkboxs-and-edit' : 'without-specials-columns', limitHeight && 'limit-height');
  return {
    container: {
      classname: clsx('datatable-ufinet', additionalClasses)
    },
    state: {
      isLazy,
      isLoading: tableLoading,
      onValueChange: e => {
        setDisplayedData(e);
        onValuesDisplayedChangeCallback === null || onValuesDisplayedChangeCallback === void 0 ? void 0 : onValuesDisplayedChangeCallback(e);
      },
      onSelectionChange,
      editOnCell
    },
    data: {
      all: allData,
      displayed: displayedData
    },
    columns: {
      actionColumns,
      sortFunction: columnSortFunction,
      filterElement: columnFilterElementType
    },
    pagination: {
      pageSize: (lazySettings === null || lazySettings === void 0 ? void 0 : lazySettings.pageSize) || pageSize,
      pageFirst: lazySettings ? lazySettings.pageNumber * lazySettings.pageSize : pageFirst,
      paginator: showPaginator && (Boolean(allData && allData.length > 1) || Boolean(allData && ((_lazySettings$totalPa = lazySettings === null || lazySettings === void 0 ? void 0 : lazySettings.totalPages) != null ? _lazySettings$totalPa : 0) > 1)),
      onPage: onPageControlledState
    },
    filters: {
      initialFilters,
      filtersWithGlobal,
      globalFilterFields,
      filterOnlyDisplayedData: isLazy ? true : filterOnlyDisplayedData,
      areFiltersApplied,
      onFilter: onFilterControlledState,
      clearFilter,
      filterDisplayType
    },
    sortings: {
      sortField,
      sortOrder,
      clearSort,
      onSort: onSortControlledState
    },
    helpers: {
      getCellWidth,
      getCellDisplayFormat,
      renderHeader,
      cellEditor
    }
  };
};

const defaultRowsPerPageOptions = [5, 10, 20, 50];
function getContent(e) {
  return e === null || e === void 0 ? void 0 : e.map(element => element.value);
}
function getEditPencilBodyTemplate(rowData, onClick) {
  return /*#__PURE__*/React__default.createElement("i", {
    className: "pi pi-pencil edit-pencil",
    onClick: onClick
  });
}
const TableInner = (_ref, ref) => {
  let {
    dataKey = 'id',
    cols: columns,
    content,
    headerButtons,
    filterButtons,
    onRowClick,
    onRowDoubleClick,
    onRowEditInit: _onRowEditInit = () => {},
    onRowEditComplete: _onRowEditComplete,
    onRowEditCancel = () => {},
    onCellEditInit,
    onCellEditComplete: _onCellEditComplete,
    onCellEditCancel,
    editDisabled,
    className,
    textEditorClassName,
    selectedValues,
    onSelectionChange,
    onValuesDisplayedChange,
    showSelectAll = true,
    sortField: propSortField,
    sortOrder: propSortOrder,
    emptyMessage,
    filterOnDisplayedData: filterOnDisplayedDataProp = false,
    actionBodyTemplate,
    customColumns,
    rowsPerPageOptions = defaultRowsPerPageOptions,
    showPaginator = true,
    onPage,
    onFilter,
    onFilterClear = () => {},
    onSort,
    afterTablePFSEvent = () => {},
    lazySettings,
    limitHeight = true,
    enableSearchFilter = true,
    customClassFilters = '',
    customClassHeaders = '',
    loading
  } = _ref;
  const translate = ufinetWebFunctions.useTranslator();
  const {
    container: tableContainer,
    state: tableState,
    data: {
      all: data
    },
    columns: tableColumns,
    pagination: tablePagination,
    filters: tableFilters,
    sortings: tableSorting,
    helpers: {
      getCellWidth,
      getCellDisplayFormat,
      renderHeader,
      cellEditor
    }
  } = useTable({
    tableState: {
      lazySettings,
      onSelectionChange,
      onValuesDisplayedChange,
      onRowEditComplete: _onRowEditComplete,
      afterTablePFSEvent,
      limitHeight,
      isLoading: loading
    },
    data: {
      all: content,
      selected: selectedValues
    },
    columns: {
      columns,
      actionBodyTemplate,
      headerButtons
    },
    pagination: {
      showPaginator,
      onPage
    },
    filters: {
      filterOnlyDisplayedData: filterOnDisplayedDataProp,
      onFilter,
      onFilterClear,
      filterButtons,
      enableSearchFilter,
      customClassFilters,
      customClassHeaders
    },
    sortings: {
      sortField: propSortField,
      sortOrder: propSortOrder,
      onSort
    },
    editor: {
      textEditorClassName
    }
  });
  React.useImperativeHandle(ref, () => ({
    clearFilter: () => tableFilters.clearFilter(),
    clearSort: () => tableSorting.clearSort(),
    getInitialFilters: () => tableFilters.initialFilters,
    getCurrentFilters: () => tableFilters.filtersWithGlobal[0],
    areFiltersApplied: () => tableFilters.areFiltersApplied
  }), [tableFilters, tableSorting]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: tableContainer.classname
  }, /*#__PURE__*/React__default.createElement(datatable.DataTable, {
    className: className,
    value: data,
    selection: selectedValues,
    selectionMode: "checkbox",
    showSelectAll: showSelectAll,
    selectionAutoFocus: false,
    onSelectionChange: tableState.onSelectionChange,
    onValueChange: tableState.onValueChange,
    onRowClick: onRowClick,
    onRowDoubleClick: onRowDoubleClick,
    editMode: _onCellEditComplete ? 'cell' : 'row',
    onRowEditInit: e => _onRowEditInit(e),
    onRowEditComplete: e => _onRowEditComplete && _onRowEditComplete(e.newData),
    onRowEditCancel: onRowEditCancel,
    paginator: tablePagination.paginator,
    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    currentPageReportTemplate: translate('PAGINATOR.REPORT'),
    rowsPerPageOptions: rowsPerPageOptions,
    first: tablePagination.pageFirst,
    rows: tablePagination.pageSize,
    dataKey: dataKey,
    removableSort: true,
    filters: tableFilters.filtersWithGlobal[0],
    filterDisplay: tableFilters.filterDisplayType,
    loading: tableState.isLoading,
    loadingIcon: "pi pi-spinner",
    scrollable: true,
    scrollHeight: "flex",
    sortField: tableSorting.sortField,
    sortOrder: tableSorting.sortOrder,
    header: renderHeader,
    emptyMessage: emptyMessage || translate('EMPTY.MESSAGE'),
    lazy: tableState.isLazy,
    totalRecords: (lazySettings === null || lazySettings === void 0 ? void 0 : lazySettings.totalElements) || (data === null || data === void 0 ? void 0 : data.length),
    onPage: tablePagination.onPage,
    onFilter: tableFilters.onFilter,
    filterDelay: 500,
    onSort: tableSorting.onSort,
    globalFilter: tableFilters.filtersWithGlobal[1],
    globalFilterFields: tableFilters.globalFilterFields,
    globalFilterMatchMode: api.FilterMatchMode.CONTAINS
  }, onSelectionChange && /*#__PURE__*/React__default.createElement(column.Column, {
    selectionMode: "multiple",
    headerStyle: {
      width: '3em'
    }
  }), _onRowEditComplete && /*#__PURE__*/React__default.createElement(column.Column, {
    rowEditor: true,
    headerStyle: {
      maxWidth: '100px',
      minWidth: '100px'
    },
    bodyStyle: {
      textAlign: 'center',
      maxWidth: '100px',
      minWidth: '100px'
    },
    bodyClassName: editDisabled ? 'edit-disabled' : ''
  }), tableColumns.actionColumns.length !== 0 && tableColumns.actionColumns.map((actionColumnBody, id) => /*#__PURE__*/React__default.createElement(column.Column, {
    key: id,
    body: actionColumnBody,
    exportable: false,
    sortable: false,
    className: "column-action"
  })), columns.map((col, idx) => /*#__PURE__*/React__default.createElement(column.Column, {
    key: idx,
    field: col.field,
    hidden: col.hidden,
    bodyClassName: "text-break",
    header: /*#__PURE__*/React.isValidElement(col.header) ? col.header : typeof col.header === 'string' ? translate(col.header) : translate(col.header.key, col.header.variables),
    editor: col.editable ? options => cellEditor(col, options) : undefined,
    style: Object.assign({
      minWidth: getCellWidth(col),
      width: getCellWidth(col)
    }, getCellDisplayFormat(col)),
    sortFunction: e => {
      var _tableColumns$sortFun;
      return (_tableColumns$sortFun = tableColumns.sortFunction) === null || _tableColumns$sortFun === void 0 ? void 0 : _tableColumns$sortFun.call(tableColumns, e, col.sortFunction);
    },
    filter: !col.nonFilterable,
    filterApply: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    filterClear: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    filterElement: options => {
      var _tableColumns$filterE;
      return (_tableColumns$filterE = tableColumns.filterElement) === null || _tableColumns$filterE === void 0 ? void 0 : _tableColumns$filterE.call(tableColumns, col, options);
    },
    showFilterMatchModes: false,
    sortable: !col.nonSortable,
    body: col.editable && _onCellEditComplete !== undefined ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, col.editable && /*#__PURE__*/React__default.createElement("i", {
      className: "pi pi-pencil edit-pencil me-2"
    }), col.body) : col.body,
    onBeforeCellEditShow: e => onCellEditInit === null || onCellEditInit === void 0 ? void 0 : onCellEditInit({
      rowData: e.newRowData,
      cellData: e.newValue
    }),
    onBeforeCellEditHide: e => onCellEditCancel === null || onCellEditCancel === void 0 ? void 0 : onCellEditCancel({
      rowData: e.newRowData,
      cellData: e.newValue
    }),
    onCellEditComplete: e => _onCellEditComplete === null || _onCellEditComplete === void 0 ? void 0 : _onCellEditComplete({
      rowData: e.newRowData,
      cellData: e.newValue
    })
  })), (customColumns === null || customColumns === void 0 ? void 0 : customColumns.filter(Boolean).length) && customColumns.map((column$1, idx) => /*#__PURE__*/React__default.createElement(column.Column, {
    key: idx,
    body: column$1,
    exportable: false,
    className: "column-custom"
  }))));
};
const Table = /*#__PURE__*/React.forwardRef(TableInner);

const TableArrivalsStyle = _ref => {
  let {
    header,
    content,
    className
  } = _ref;
  const instanceOfITableArrivalsStyleContent = data => {
    return Array.isArray(data[0]) && 'value' in data[0][0];
  };
  const getDecoratedContent = () => {
    return content.map((contentElement, contentIndex) => /*#__PURE__*/React__default.createElement("tr", {
      key: "tr-table-arrivals-" + contentIndex
    }, header.map((_headerElement, index) => {
      return contentElement && (contentElement[index].value || contentElement[index].value === 0) ? /*#__PURE__*/React__default.createElement("td", {
        key: "td-tb-arr-style-" + index,
        scope: "" + (index === 0 ? 'row' : '')
      }, /*#__PURE__*/React__default.createElement("span", {
        className: (index === 0 ? 'ps-4 ' : '') + "  mb-1 fs-6  " + (contentElement[index].style ? contentElement[index].style : 'text-dark fw-bolder')
      }, contentElement[index].value)) : /*#__PURE__*/React__default.createElement("td", {
        key: "td-tb-arr-style-" + index
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "mb-1"
      }));
    })));
  };
  const getPlainContent = () => {
    const contentParsed = content.map(object => {
      return Object.entries(object).map(_ref2 => {
        let [_key, value] = _ref2;
        return value;
      });
    });
    return contentParsed.map((contentArray, contentIndex) => /*#__PURE__*/React__default.createElement("tr", {
      key: "tr-table-arrivals-" + contentIndex
    }, header.map((headerElement, index) => {
      return contentArray[index] ? /*#__PURE__*/React__default.createElement("td", {
        key: "td-tb-arr-style-" + index,
        scope: "" + (index === 0 ? 'row' : '')
      }, /*#__PURE__*/React__default.createElement("span", {
        className: (index === 0 ? 'ps-4 ' : '') + "  mb-1 fs-6 text-dark fw-bolder'}"
      }, contentArray[index])) : /*#__PURE__*/React__default.createElement("td", {
        key: "td-tb-arr-style-" + index
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "mb-1"
      }));
    })));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "table-responsive " + className
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "table align-middle gs-0 gy-4"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "fw-bolder text-muted bg-light"
  }, header.map((element, index) => /*#__PURE__*/React__default.createElement("th", {
    key: "th-tb-arr-style-" + index,
    scope: "col",
    className: "" + (index === 0 ? 'ps-4 rounded-start ' : '')
  }, element)), /*#__PURE__*/React__default.createElement("th", {
    scope: "col",
    className: "rounded-end"
  }))), /*#__PURE__*/React__default.createElement("tbody", null, instanceOfITableArrivalsStyleContent(content) ? getDecoratedContent() : getPlainContent())));
};

const TableCellButton = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ufinet-table-cell"
  }, /*#__PURE__*/React__default.createElement(UfinetButton, Object.assign({}, props, {
    type: "button"
  })));
};

function mkGenericEditableField(targetField, inputType, _ref) {
  let {
    disabled = false,
    validChangeCondition = () => true,
    onValidValue,
    onInvalidValue,
    fieldFallback
  } = _ref;
  const editFunction = (col, options) => {
    const cellDataFallback = fieldFallback ? options.rowData["" + fieldFallback] : options.rowData[targetField + "Updated"] || options.rowData[targetField.replace('Updated', '')];
    const cellData = options.rowData[targetField] || cellDataFallback;
    const entryData = {
      rowData: options.rowData,
      cellData: cellData
    };
    const onCompleteFunction = () => {
      const userInputValue = options.value;
      if (validChangeCondition(userInputValue, entryData)) {
        onValidValue && options.editorCallback(onValidValue(userInputValue, entryData));
      } else {
        onInvalidValue && options.editorCallback(onInvalidValue(userInputValue, entryData));
      }
    };
    return /*#__PURE__*/React__default.createElement(UfinetSimpleInput, {
      type: inputType,
      value: cellData,
      onChange: e => {
        const newValue = e.target.value;
        options.editorCallback(newValue);
      },
      onBlur: onCompleteFunction,
      required: true,
      isDisabled: disabled
    });
  };
  return editFunction;
}

const Wizard = _ref => {
  let {
    content,
    submitTextButton
  } = _ref;
  const stepperRef = React.useRef(null);
  const stepper = React.useRef(null);
  const intl = reactIntl.useIntl();
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current);
  };
  React.useEffect(() => {
    if (!stepperRef.current) {
      return;
    }
    loadStepper();
  }, [stepperRef]);
  const gotoStep = index => {
    var _stepper$current;
    (_stepper$current = stepper.current) === null || _stepper$current === void 0 ? void 0 : _stepper$current.goto(index + 1);
  };
  const goNext = () => {
    var _stepper$current2;
    (_stepper$current2 = stepper.current) === null || _stepper$current2 === void 0 ? void 0 : _stepper$current2.goNext();
  };
  const goPrev = () => {
    var _stepper$current3;
    (_stepper$current3 = stepper.current) === null || _stepper$current3 === void 0 ? void 0 : _stepper$current3.goPrev();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: stepperRef,
    className: "stepper stepper-pills"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-nav flex-wrap mb-10"
  }, content.map((element, index) => /*#__PURE__*/React__default.createElement("div", {
    key: element.stepperTitle + "-" + index,
    className: clsx('stepper-item mx-2 my-4', index === 0 && 'current'),
    "data-kt-stepper-element": "nav",
    "data-kt-stepper-action": "step",
    onClick: () => gotoStep(index)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-line w-40px"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-icon w-40px h-40px"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "stepper-check fas fa-check"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "stepper-number"
  }, index + 1)), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-label"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "stepper-title"
  }, element.stepperTitle), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-desc"
  }, element.stepperDescription))))), /*#__PURE__*/React__default.createElement("form", {
    className: "form w-lg-500px mx-auto",
    noValidate: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mb-5"
  }, content.map((element, index) => /*#__PURE__*/React__default.createElement("div", {
    key: "content-" + element.stepperTitle + "-" + index,
    className: clsx('flex-column', index === 0 && 'current'),
    "data-kt-stepper-element": "content"
  }, element.stepperComponent))), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-stack"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "me-2"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-light btn-active-light-primary",
    "data-kt-stepper-action": "previous",
    onClick: () => goPrev()
  }, intl.formatMessage({
    id: 'STEP.BUTTON.BACK'
  }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    "data-kt-stepper-action": "submit"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "indicator-label"
  }, submitTextButton || intl.formatMessage({
    id: 'STEP.BUTTON.SUBMIT'
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "indicator-progress"
  }, intl.formatMessage({
    id: 'STEP.BUTTON.WAIT'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "spinner-border spinner-border-sm align-middle ms-2"
  }))), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    "data-kt-stepper-action": "next",
    onClick: () => goNext()
  }, intl.formatMessage({
    id: 'STEP.BUTTON.CONTINUE'
  }))))))));
};

const WizardVertical = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    content,
    closeFn
  } = _ref;
  const stepperRef = React.useRef(null);
  const stepper = React.useRef(null);
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current);
  };
  React.useEffect(() => {
    if (!stepperRef.current) {
      return;
    }
    loadStepper();
  }, [stepperRef]);
  const gotoStep = index => {
    var _stepper$current;
    return (_stepper$current = stepper.current) === null || _stepper$current === void 0 ? void 0 : _stepper$current.goto(index + 1);
  };
  const goNext = () => {
    var _stepper$current2;
    return (_stepper$current2 = stepper.current) === null || _stepper$current2 === void 0 ? void 0 : _stepper$current2.goNext();
  };
  const goPrev = () => {
    var _stepper$current3;
    return (_stepper$current3 = stepper.current) === null || _stepper$current3 === void 0 ? void 0 : _stepper$current3.goPrev();
  };
  const close = closeFn || (() => {});
  React.useImperativeHandle(ref, () => ({
    goNext,
    goPrev,
    gotoStep,
    close
  }));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "h-100"
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: stepperRef,
    className: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row h-100",
    id: "kt_stepper_example_vertical"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bg-white rounded p-15 d-flex flex-row-auto w-100 w-xl-400px shadow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-nav"
  }, content.map((element, index) => /*#__PURE__*/React__default.createElement("div", {
    className: clsx('stepper-item', 'me-5', index === 0 && 'current'),
    "data-kt-stepper-element": "nav",
    "data-kt-stepper-action": "step",
    key: "stepper-item-wzd-vertical-" + index
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-line min-w-40px"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-icon min-w-40px min-h-40px"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "stepper-check fas fa-check"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "stepper-number"
  }, index + 1)), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-label"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "stepper-title"
  }, element.stepperTitle), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-desc"
  }, element.stepperDescription)))))), /*#__PURE__*/React__default.createElement("div", {
    className: "rounded ms-xl-5 mt-5 w-xl-400px mt-xl-0 flex-fill"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "m-auto h-100 rounded shadow"
  }, content.map((element, index) => /*#__PURE__*/React__default.createElement("div", {
    key: "content-" + element.stepperTitle + "-" + index,
    className: clsx('bg-white rounded flex-column h-100', index === 0 && 'current'),
    "data-kt-stepper-element": "content"
  }, element.stepperComponent))))));
});

const WizardButtonClose = _ref => {
  let {
    wizardRef,
    actionButtonRef,
    isDisabled,
    beforeContinue = () => Promise.resolve(true)
  } = _ref;
  const intl = reactIntl.useIntl();
  const handleClick = event => {
    event.preventDefault();
    beforeContinue().then(shouldContinue => {
      var _wizardRef$current;
      return shouldContinue && ((_wizardRef$current = wizardRef.current) === null || _wizardRef$current === void 0 ? void 0 : _wizardRef$current.close());
    }).catch(console.error);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionButtonRef,
    className: "w-lg-25 w-sm-50 m-2 btn-danger",
    isDisabled: isDisabled,
    onClick: handleClick,
    content: intl.formatMessage({
      id: 'STEP.BUTTON.CLOSE'
    })
  }));
};

const WizardButtonNext = _ref => {
  let {
    isDisabled = false,
    wizardRef,
    beforeContinue = () => Promise.resolve(true),
    actionButtonRef,
    submitForm = false,
    buttonMessageId = 'STEP.BUTTON.CONTINUE'
  } = _ref;
  const intl = reactIntl.useIntl();
  const handleClick = event => {
    if (!submitForm) {
      event.preventDefault();
      beforeContinue().then(shouldContinue => {
        var _wizardRef$current;
        return shouldContinue && (wizardRef === null || wizardRef === void 0 ? void 0 : (_wizardRef$current = wizardRef.current) === null || _wizardRef$current === void 0 ? void 0 : _wizardRef$current.goNext());
      }).catch(console.error);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionButtonRef,
    className: "w-lg-25 w-sm-50 m-2",
    isDisabled: isDisabled,
    onClick: handleClick,
    content: intl.formatMessage({
      id: buttonMessageId
    })
  }));
};

const WizardButtonPrev = _ref => {
  let {
    wizardRef,
    actionButtonRef,
    beforeContinue = () => Promise.resolve(true),
    isDisabled
  } = _ref;
  const intl = reactIntl.useIntl();
  const handleClick = event => {
    event.preventDefault();
    beforeContinue().then(shouldContinue => {
      var _wizardRef$current;
      return shouldContinue && ((_wizardRef$current = wizardRef.current) === null || _wizardRef$current === void 0 ? void 0 : _wizardRef$current.goPrev());
    }).catch(console.error);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(UfinetActionButton, {
    ref: actionButtonRef,
    className: "w-lg-25 w-sm-50 m-2",
    isDisabled: isDisabled,
    onClick: handleClick,
    content: intl.formatMessage({
      id: 'STEP.BUTTON.BACK'
    })
  }));
};

const WizardButtonsWrapper = _ref => {
  let {
    alignment,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "flex-grow-1 pt-5"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('d-flex', alignment === 'left' ? 'justify-content-start' : alignment === 'right' ? 'justify-content-end' : alignment === 'center' ? 'justify-content-center' : 'justify-content-between')
  }, children));
};

Object.defineProperty(exports, 'TOAST_CONTAINER_ID', {
	enumerable: true,
	get: function () {
		return ufinetWebFunctions.TOAST_CONTAINER_ID;
	}
});
Object.defineProperty(exports, 'UfinetSelectBaseStyles', {
	enumerable: true,
	get: function () {
		return ufinetWebFunctions.UfinetSelectBaseStyles;
	}
});
Object.defineProperty(exports, 'emptyUfinetSelectOption', {
	enumerable: true,
	get: function () {
		return ufinetWebFunctions.emptyUfinetSelectOption;
	}
});
exports.AreaSelect = AreaSelect;
exports.AreaTypeSelect = AreaTypeSelect;
exports.AsideMenuItem = AsideMenuItem;
exports.AsideMenuItemWithSub = AsideMenuItemWithSub;
exports.AuthPage = AuthPage;
exports.AuthProvider = AuthProvider;
exports.AuthRoute = AuthRoute;
exports.Backdrop = Backdrop;
exports.BandwidthEditSelect = BandwidthEditSelect;
exports.BandwidthSelect = BandwidthSelect;
exports.ClientEditSelect = ClientEditSelect;
exports.ClientSelect = ClientSelect;
exports.ContactSelect = ContactSelect;
exports.Content = Content;
exports.CookieComponent = CookieComponent;
exports.CorporateGroupSelect = CorporateGroupSelect;
exports.CountrySelect = CountrySelect;
exports.DOMEventHandlerUtil = DOMEventHandlerUtil;
exports.DataUtil = DataUtil;
exports.DatePicker = DatePicker;
exports.DeadlineSelect = DeadlineSelect;
exports.DefaultLayoutConfig = DefaultLayoutConfig;
exports.DefaultTitle = DefaultTitle;
exports.DivWrapped = DivWrapped;
exports.DrawerComponent = DrawerComponent;
exports.DrawerStore = DrawerStore;
exports.EasterEgg = EasterEgg;
exports.EasterEggInner = EasterEggInner;
exports.EasterEggWrapper = EasterEggWrapper;
exports.ElementAnimateUtil = ElementAnimateUtil;
exports.ElementStyleUtil = ElementStyleUtil;
exports.EntrypointHandler = EntrypointHandler;
exports.EventHandlerUtil = EventHandlerUtil;
exports.Filter = Filter;
exports.HardFilterWrapper = HardFilterWrapper;
exports.HeaderUserMenu = HeaderUserMenu;
exports.HeaderWrapper = HeaderWrapper;
exports.I18nProvider = I18nProvider;
exports.KTSVG = KTSVG;
exports.Label = Label;
exports.Languages = Languages;
exports.LayoutContext = LayoutContext;
exports.LayoutProvider = LayoutProvider;
exports.LayoutSetup = LayoutSetup;
exports.LayoutSplashScreen = LayoutSplashScreen;
exports.LoadTypeSelect = LoadTypeSelect;
exports.Loading = Loading;
exports.LoadingButton = LoadingButton;
exports.MasterInit = MasterInit;
exports.MasterLayout = MasterLayout;
exports.MenuComponent = MenuComponent;
exports.MetronicSplashScreenProvider = MetronicSplashScreenProvider;
exports.MouseRecorder = MouseRecorder;
exports.MultipleDeleter = MultipleDeleter;
exports.PATH_DETAIL = PATH_DETAIL$3;
exports.PageDataProvider = PageDataProvider;
exports.PageDescription = PageDescription;
exports.PageTitle = PageTitle;
exports.PopSelect = PopSelect;
exports.Quicklinks = Quicklinks;
exports.SELECT_ALL = SELECT_ALL;
exports.StepperComponent = StepperComponent;
exports.StubAuthProvider = StubAuthProvider;
exports.Table = Table;
exports.TableArrivalsStyle = TableArrivalsStyle;
exports.TableCellButton = TableCellButton;
exports.ToastContent = ToastContent;
exports.ToggleComponent = ToggleComponent;
exports.Toolbar = Toolbar;
exports.TooltipButton = TooltipButton;
exports.Topbar = Topbar;
exports.UfinetActionButton = UfinetActionButton;
exports.UfinetAsyncButton = UfinetAsyncButton;
exports.UfinetBox = UfinetBox;
exports.UfinetBoxContext = UfinetBoxContext;
exports.UfinetButton = UfinetButton;
exports.UfinetCheckBoxGroup = UfinetCheckBoxGroup;
exports.UfinetCheckbox = UfinetCheckbox;
exports.UfinetDropzone = UfinetDropzone;
exports.UfinetInput = UfinetInput;
exports.UfinetModal = UfinetModal;
exports.UfinetRadioButton = UfinetRadioButton;
exports.UfinetRadioButtonGroup = UfinetRadioButtonGroup;
exports.UfinetSectionBox = UfinetSectionBox;
exports.UfinetSelect = UfinetSelect;
exports.UfinetSelectOptionBaseValidation = UfinetSelectOptionBaseValidation;
exports.UfinetSelectOptionShape = UfinetSelectOptionShape;
exports.UfinetSimpleInput = UfinetSimpleInput;
exports.Ufineti18nProvider = Ufineti18nProvider;
exports.VerificationPage = VerificationPage;
exports.WelcomePage = WelcomePage;
exports.Wizard = Wizard;
exports.WizardButtonClose = WizardButtonClose;
exports.WizardButtonNext = WizardButtonNext;
exports.WizardButtonPrev = WizardButtonPrev;
exports.WizardButtonsWrapper = WizardButtonsWrapper;
exports.WizardVertical = WizardVertical;
exports.YesNoSelect = YesNoSelect;
exports.allowAllFilterFields = allowAllFilterFields;
exports.allowNoneFilterFields = allowNoneFilterFields;
exports.colorConstants = colorConstants;
exports.colorDarken = colorDarken;
exports.colorLighten = colorLighten;
exports.deadlineSelectDefaultOptions = deadlineSelectDefaultOptions;
exports.defaultDrawerOptions = defaultDrawerOptions;
exports.defaultMenuOptions = defaultMenuOptions;
exports.defaultStepperOptions = defaultStepperOptions;
exports.defaultToggleOptions = defaultToggleOptions;
exports.emptyClientSelectOption = emptyClientSelectOption;
exports.formatTableFilters = formatTableFilters;
exports.getAttributeValueByBreakpoint = getAttributeValueByBreakpoint;
exports.getBreakpoint = getBreakpoint;
exports.getCSS = getCSS;
exports.getCSSVariableValue = getCSSVariableValue;
exports.getContent = getContent;
exports.getEditPencilBodyTemplate = getEditPencilBodyTemplate;
exports.getElementActualCss = getElementActualCss;
exports.getElementActualHeight = getElementActualHeight;
exports.getElementActualWidth = getElementActualWidth;
exports.getElementChild = getElementChild;
exports.getElementChildren = getElementChildren;
exports.getElementIndex = getElementIndex;
exports.getElementMatches = getElementMatches;
exports.getElementOffset = getElementOffset;
exports.getElementParents = getElementParents;
exports.getEmptyCSSVariables = getEmptyCSSVariables;
exports.getEmptyCssClasses = getEmptyCssClasses;
exports.getEmptyHTMLAttributes = getEmptyHTMLAttributes;
exports.getHighestZindex = getHighestZindex;
exports.getLayout = getLayout;
exports.getNestedFieldValue = getNestedFieldValue;
exports.getObjectPropertyValueByKey = getObjectPropertyValueByKey;
exports.getOptionsForFilter = getOptionsForFilter;
exports.getScrollTop = getScrollTop;
exports.getUniqueIdWithPrefix = getUniqueIdWithPrefix;
exports.getValuesFromSelect = getValuesFromSelect;
exports.getViewPort = getViewPort;
exports.insertAfterElement = insertAfterElement;
exports.isElementHasClasses = isElementHasClasses;
exports.isMobileDevice = isMobileDevice;
exports.isVisibleElement = isVisibleElement;
exports.loadTypesColorBlue = loadTypesColorBlue;
exports.loadTypesColorRed = loadTypesColorRed;
exports.mkGenericEditableField = mkGenericEditableField;
exports.mkOptionFromAreaType = mkOptionFromAreaType;
exports.mkOptionFromNetworkItemType = mkOptionFromNetworkItemType;
exports.mkOptionFromNumber = mkOptionFromNumber;
exports.showSwal = showSwal;
exports.slide = slide;
exports.slideDown = slideDown;
exports.slideUp = slideUp;
exports.stringSnakeToCamel = stringSnakeToCamel;
exports.tableSortValueToSortDirection = tableSortValueToSortDirection;
exports.throttle = throttle;
exports.toJSON = toJSON;
exports.useLayout = useLayout;
exports.usePageData = usePageData;
//# sourceMappingURL=index.js.map
